import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { AttachmentToUpdate, Enquiry, EnquiryHeaderItem, EnquiryNpsSchedule, EnquirySms, EnquiyNormGrade, ItemAttachment } from 'src/app/shared/models/data/enquiry.model';
import { ItemParametersValues, MarketFamily, Mill, Sql, TubeExecution, UomsType } from 'src/app/shared/models/data/itemParametersValues.model';
import { ItemLimitation, ItemToUpdate } from 'src/app/shared/models/data/itemToUpdate.model';
import { NormGrade } from 'src/app/shared/models/data/normGrades.model';
import { NpsAndSchedule } from 'src/app/shared/models/data/npsAndSchedules.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftBreadCrumb } from 'src/app/shared/teiasoft-bucket/teiasoft-breadcrumb/teiasoft-breadcrumb.component';
import { Autocomplete } from 'src/app/shared/teiasoft-bucket/teiasoft-input/teiasoft-input.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { ToggleObject } from 'src/app/shared/teiasoft-bucket/teiasoft-toggle/teiasoft-toggle.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import * as _ from 'lodash';
import { firstValueFrom, Subscription } from 'rxjs';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { Limitation, LimitationsForNormGrades } from 'src/app/shared/models/data/limitationsForNormGrades.model';
import { CalculateItemWeightParamters } from 'src/app/shared/models/data/calculateItemWeightParameters.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { Uom } from 'src/app/shared/models/data/headerParametersValues.model';
import { ItemParametersLengthValues } from 'src/app/shared/models/data/itemParametersLengthValues.model';
import { Material } from 'src/app/shared/models/data/materials.model';
import { DimType, ItemAttributesByMaterialCode } from 'src/app/shared/models/data/itemAttributesByMaterialCode.model';
import { RawMaterialGrade } from 'src/app/shared/models/data/rawMaterialGrades.model';
declare var $: any;

export class AttachComplete {
  itemNo?: string;
  attachments?: AttachmentToUpdate[];
}

export class ItemAttachmentToDelete {
  enquiryNo?: string;
  itemNo?: string;
  fileId?: number;
}

@Component({
  selector: 'app-modal-item',
  templateUrl: './modal-item.component.html',
  styleUrls: ['./modal-item.component.scss']
})
export class ModalItemComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';
  @Input() items: EnquiryHeaderItem[] = new Array();
  @Input() action: string = '';
  @Input() itemParameterValues: ItemParametersValues = new ItemParametersValues();
  @Input() itemParameterLengthValues: ItemParametersLengthValues = new ItemParametersLengthValues();
  @Input() materials: Material[] = new Array();


  @Input() selectedIndexItem: number = -1;
  @Input() enquiryNo: string = "";
  @Input() enquiryToEdit: Enquiry = new Enquiry();
  @Input() roundDigitsForItemForm: RoundDigit[] = new Array();

  @Output() closeModalItem: EventEmitter<any> = new EventEmitter();
  //@Output() updateEnquiryItems: EventEmitter<ItemToUpdate[]> = new EventEmitter();
  @Output() reloadEnquiry: EventEmitter<string> = new EventEmitter();


  //#region internal vars
  title: string = "";
  dialogIcon: string = '';
  millChangedByUser: boolean = false;
  marketingRoute: string = "";
  salesOffice: string = "";
  attachmentsToUpdate: AttachmentToUpdate[] = new Array();
  isInitialLoad: boolean = true;
  //listAttachmenst: AttachComplete[] = new Array();
  showSelectAttach: boolean = false;
  selectedAttach: ItemAttachment = new ItemAttachment();
  fillFromEnquiry: boolean = false;
  listAttachToDelete: ItemAttachmentToDelete[] = new Array();
  topPx: number = 0;
  analysisLimitationFreeInput: boolean = false;
  otherLimitationFreeInput: boolean = false;
  isDragging: boolean = false;

  //#region FormVars
  unitSystemOptionList: SelectOption[] = new Array();
  unitSystemIsValid: boolean = true;
  unitSystemValue: any;

  smsMarketingRouteOptionList: SelectOption[] = new Array();
  smsMarketingRouteValue: any = "";
  smsMarketingRouteIsValid: boolean = true;

  smsOptionList: SelectOption[] = new Array();
  smsValue: any = "";
  smsIsValid: boolean = true;

  customerItemNoValue: string = '';
  customerItemNoIsValid: boolean = true;

  remarkValue: string = '';

  applicableNormsValue: string = '';
  applicableNormsIsValid: boolean = true;

  alloySurchargeOptionList: SelectOption[] = new Array();
  alloySurchargeIsValid: boolean = true;
  alloySurchargeValue: any;

  normGradesIds: number[] | null = new Array();
  normGradesCodes: any[] = new Array();
  normGradesDataset: NormGrade[] = new Array();
  normGradesDataset_Cache: NormGrade[] = new Array();
  normGradesMaterialDataset?: NormGrade[] = new Array();
  columnsNormGrades: string[] = ['normGradeCode'];
  columnsToHideNormGrades: string[] = ['normGradeId'];
  normGradeIsValid: boolean = true;
  normGradesIsrequired: boolean = true;

  rawMaterialGradeValue: any;
  rawMaterialGradeDataset: any[] = new Array();
  rawMaterialGradeAvailableDataset: RawMaterialGrade[] = new Array();
  columnsRawMaterialGrades: string[] = ['rawMaterialGradeCode'];
  columnsToHideRawMaterialGrades: string[] = ['rawMaterialGradeId', 'isDefault'];
  rawMaterialGradeIsValid: boolean = true;
  rawMaterialGradeDisabled: boolean = false;
  rawMaterialGradeIsRequired: boolean = false;

  materialValue?: string;
  materialDataset: Material[] = new Array();
  columnsMaterial: string[] = ['materialCode'];
  columnsToHideMaterial: string[] = [];
  materialIsValid: boolean = true;
  materialDisabled: boolean = false;
  materialIsRequired: boolean = false;

  toolbarButtonsList: TTButton[] = new Array();

  npsValue: any;
  npsId?: number | null;
  npsIsReadOnly: boolean = true;
  npsDisabled: boolean = true;
  npsIsrequired: boolean = false;
  npsIsValid: boolean = true;

  quantityValue: number = 0;
  quantityIsValid: boolean = true;
  quantityUomOptionList: SelectOption[] = new Array();
  quantityUomIsValid: boolean = true;
  quantityUomValue: any;
  quantityUomValueType: any;


  odValue: any;
  odIsValid: boolean = true;
  odIsRequired: boolean = true;
  odReadOnly: boolean = false;

  odUomOptionList: SelectOption[] = new Array();
  odUomIsValid: boolean = true;
  odUomValue: any;
  odUomIsRequired: boolean = true;
  odUomReadOnly: boolean = false;

  odTolerancePlusIsValid: boolean = true;
  odToleranceMinusIsValid: boolean = true;
  odTolerancePlusIsRequired: boolean = true;
  odToleranceMinusIsRequired: boolean = true;
  odTolerancePlusDisabled: boolean = true;
  odToleranceMinusDisabled: boolean = true;
  odTolerancePlusValue: any;
  odToleranceMinusValue: any;

  odToleranceUomIsRequired: boolean = false;
  odToleranceUomIsValid: boolean = true;
  odToleranceUomValue: any;
  odToleranceUomReadOnly: boolean = false;

  wtValue: any;
  wtIsValid: boolean = true;
  wtIsRequired: boolean = true;
  wtReadOnly: boolean = false;

  wtUomOptionList: SelectOption[] = new Array();
  wtUomValue: any;
  wtUomIsValid: boolean = true;
  wtUomIsRequired: boolean = true;
  wtUomReadOnly: boolean = false;

  wtToleranceUomIsRequired: boolean = false;
  wtToleranceUomIsValid: boolean = true;
  wtToleranceUomValue: any;
  wtToleranceUomReadOnly: boolean = false;
  wtToleranceUomDisabled: boolean = false;

  idValue: any;
  idIsValid: boolean = true;
  idIsRequired: boolean = true;
  idReadOnly: boolean = false;
  idIsDisabled: boolean = false;

  idUomOptionList: SelectOption[] = new Array();
  idUomIsValid: boolean = true;
  idUomValue: any;
  idUomIsRequired: boolean = true;
  idUomReadOnly: boolean = false;
  idUomIsDisabled: boolean = false;

  idTolerancePlusIsValid: boolean = true;
  idToleranceMinusIsValid: boolean = true;
  idTolerancePlusIsRequired: boolean = true;
  idToleranceMinusIsRequired: boolean = true;
  idTolerancePlusDisabled: boolean = true;
  idToleranceMinusDisabled: boolean = true;
  idTolerancePlusValue: any;
  idToleranceMinusValue: any;

  idToleranceUomIsRequired: boolean = false;
  idToleranceUomIsValid: boolean = true;
  idToleranceUomValue: any;
  idToleranceUomReadOnly: boolean = false;

  totalWeightValue: any;
  totalWeightIsvalid: boolean = true;

  totalWeightUomOptionList: SelectOption[] = new Array();
  totalWeightUomValue: any;
  totalWeightUomIsValid: boolean = true;
  totalWeightCanBeCalculated: boolean = false;

  tubeExecutionOptionList: SelectOption[] = new Array();
  tubeExecutionIsValid: boolean = true;
  tubeExecutionIsDisabled: boolean = true;
  tubeExecutionValue: any;
  prevTubeExecutionValue: any;

  typeOfToleranceOptionList: SelectOption[] = new Array();
  typeOfToleranceIsValid: boolean = true;
  typeOfToleranceIsDisabled: boolean = true;
  typeOfToleranceValue: any;

  wtTolerancePlusIsValid: boolean = true;
  wtToleranceMinusIsValid: boolean = true;
  wtTolerancePlusDisabled: boolean = true;
  wtToleranceMinusDisabled: boolean = true;
  wtTolerancePlusValue: any;
  wtToleranceMinusValue: any;

  toleranceUomOptionList: SelectOption[] = new Array();

  marketFamilyOptionList: SelectOption[] = new Array();
  marketFamilyIsValid: boolean = true;
  marketFamilyValue: any;

  utOptionList: SelectOption[] = new Array();
  utValue: any;
  utIsValid: boolean = true;

  hydroTesttOptionList: SelectOption[] = new Array();
  hydroTestValue: any;
  hydroTestIsValid: boolean = true;
  hydroTestDisabled: boolean = false;

  ctsOptionList: SelectOption[] = new Array();
  ctsValue: any;
  ctsIsvalid: boolean = true;
  private readonly materialDependentCtsProperties: string[] = ['ut', 'hydroTest', 'ht', 'htAdditional', 'endsCondition', 'testCondition', 'uBent'];

  endsConditionOptionList: SelectOption[] = new Array();
  endsConditionValue: any;
  endsConditionIsvalid: boolean = true;

  testConditionOptionList: SelectOption[] = new Array();
  testConditionValue: any;
  testConditionIsvalid: boolean = true;

  sqlOptionList: SelectOption[] = new Array();
  defaultSqlOptionList: SelectOption[] = new Array();
  sqlValue: any;
  sqlIsValid: boolean = true;

  offerSchemeOptionList: SelectOption[] = new Array();
  offerSchemeValue: any;
  offerSchemeIsValid: boolean = true;

  energySurchargeOptionList: SelectOption[] = new Array();
  energySurchargeIsValid: boolean = true;
  energySurchargeValue: any;

  uBentOptionList: SelectOption[] = new Array();
  uBentIsValid: boolean = true;
  uBentValue: any;

  htOptionList: SelectOption[] = new Array();
  htIsValid: boolean = true;
  htValue: any;

  htAdditionalOptionList: SelectOption[] = new Array();
  htAdditionalValue: any;
  htAdditionalIsValid: boolean = true;

  inspectionType3Dot2IsValidOptionList: SelectOption[] = new Array();
  inspectionType3Dot2Value: any;
  inspectionType3Dot2IsValid: boolean = true;

  lengthTypeOptionList: SelectOption[] = new Array();
  lengthTypeValue: any;
  lengthTypeIsValid: boolean = true;

  lengthMinIsRequired: boolean = true;
  lengthMinValue: any;
  lengthMinIsValid: boolean = true;

  lengthMaxIsRequired: boolean = true;
  lengthMaxValue: any;
  lengthMaxIsValid: boolean = true;

  nominalLengthIsRequired: boolean = true;
  nominalLengthValue: any;
  nominalLengthIsValid: boolean = true;

  multipleLengthIsRequired: boolean = true;
  multipleLengthValue: any;
  multipleLengthIsValid: boolean = true;

  lengthUomOptionList: SelectOption[] = new Array();
  lengthUomValue: any;
  lengthUomIsValid: boolean = true;

  multipleCuttingOptionList: SelectOption[] = new Array();
  multipleCuttingIsValid: boolean = true;
  multipleCuttingValue: any;

  surfaceTypeOptionList: SelectOption[] = new Array();
  surfaceTypeValue: any;
  surfaceTypeIsValid: boolean = true;

  millDataset: any[] = new Array();
  columnsMill: string[] = ['name', 'shortName', 'city', 'country'];
  columnsToHideMill: string[] = ['millId'];
  millValue: any;
  millIsValid: boolean = true;

  optionDateIsValid: boolean = true;
  optionDateValue: any;

  customerDeliveryDateValue: any;
  customerDeliveryDateIsValid: boolean = true;

  limitationForNormGrade: LimitationsForNormGrades = new LimitationsForNormGrades();
  analysisLimitationOptionList: SelectOption[] = new Array();
  analysisLimitationValue: string = "";
  analysisLimitationIsValid: boolean = true;

  otherLimitationOptionList: SelectOption[] = new Array();
  otherLimitationValue: string = "";
  otherLimitationIsValid: boolean = true;

  dataSetNps: any[] = new Array();
  columnsNps: string[] = ["npsScheduleId", "npsDescription", "nps", "schedule", "odMetric", "wtMetric", "odImperial", "wtImperial"];
  columnsToHideNps: string[] = ["npsScheduleId", "schedule", 'nps'];
  columnsToFilterNps: string[] = ["npsDescription"];
  showSelectNps: boolean = false;
  selectedNpsRow: NpsAndSchedule = new NpsAndSchedule();


  // delivery extras
  dyePenetrantValue: boolean = false;
  dyePenetrant100PValue: boolean = false;
  penaltyValue: boolean = false;
  colorCodingValue: boolean = false;
  specialOperationsValue: boolean = false;
  specialTestsValue: boolean = false;
  grindingHoningValue: boolean = false;
  ecValue: boolean = false;
  notStdPackagingValue: boolean = false;
  //#endregion

  // SUBSCRIPTIONS
  subscriptions: Subscription = new Subscription();
  rawMaterialSubscription = new Subscription();

  step = -1;
  itemAttributesForMaterialCode?: ItemAttributesByMaterialCode;
  fillFormLoading: boolean = false;

  constructor(private backendService: BackendService, private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService,
    private teiasoftModalService: TeiasoftModalService, private teiasoftLoader: TeiasoftLoaderService, public globals: Globals,
    private utils: UtilsService) {
    this.topPx = window.scrollY;
  }


  ngOnInit(): void {
    this.materialDataset = this.materials.slice(0, 100); // take first 100 to init the dataset
    this.subscriptions.add(this.globals.discardItems.subscribe({
      next: () => this.closeModalItem.emit()
    }))
  }

  ngAfterViewInit() {
    this.isInitialLoad = false;  // Reset the isInitialLoad flag after handling the initial load
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["action"]) {
      this.action = changes["action"].currentValue;
    }

    if (changes && changes["roundDigitsForItemForm"]) {
      this.roundDigitsForItemForm = new Array();
      this.roundDigitsForItemForm = changes["roundDigitsForItemForm"].currentValue;
      this.setRoundDigitsEnquiryForm();
    }

    if (changes && changes["itemParameterValues"]) {
      if (changes["itemParameterValues"].currentValue != undefined) {
        this.itemParameterValues = new ItemParametersValues();
        this.itemParameterValues = changes["itemParameterValues"].currentValue;
        this.fillOptionLists();
      }
    }

    if (changes && changes["enquiryToEdit"]) {
      this.enquiryToEdit = new Enquiry();
      this.enquiryToEdit = JSON.parse(JSON.stringify(changes["enquiryToEdit"].currentValue));
      this.salesOffice = this.enquiryToEdit.header!.salesOffice!;
      //this.fillForm();
    }

    if (changes && changes["items"]) {
      this.items = new Array();
      this.items = JSON.parse(JSON.stringify(changes["items"].currentValue));
      //if (this.action == 'edit'){
      this.fillForm();
      this.setRoundDigitsEnquiryForm();
      //} 
    }
  }

  ngOnDestroy(): void {
    if (this.rawMaterialSubscription != undefined) this.rawMaterialSubscription.unsubscribe();
    this.subscriptions.unsubscribe();
  }

  /* METHODS */
  fillOptionLists() {
    this.smsMarketingRouteOptionList = this.getSmsMarketingRouteOptionList();
    this.smsOptionList = this.getSmsOptionList();
    this.tubeExecutionOptionList = this.getTubeExecutionOptionList();

    this.typeOfToleranceOptionList = new Array();
    for (var x = 0; x < this.itemParameterValues.typeOfTolerance!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.typeOfTolerance![x].value;
      _item.value = this.itemParameterValues.typeOfTolerance![x].value;
      _item.isDefault = this.itemParameterValues.typeOfTolerance![x].isDefault;
      this.typeOfToleranceOptionList.push(_item);
    }

    this.marketFamilyOptionList = new Array();
    for (var x = 0; x < this.itemParameterValues.marketFamily!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.marketFamily![x].name;
      _item.value = this.itemParameterValues.marketFamily![x].marketFamilyId;
      this.marketFamilyOptionList.push(_item);
    }

    this.testConditionOptionList = new Array();
    for (var x = 0; x < this.itemParameterValues.testCondition!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.testCondition![x].value;
      _item.value = this.itemParameterValues.testCondition![x].value;
      _item.isDefault = this.itemParameterValues.testCondition![x].isDefault;
      this.testConditionOptionList.push(_item);
    }

    this.sqlOptionList = new Array();
    for (const sql of (this.itemParameterValues.sqls || [])) {
      const _item: SelectOption = new SelectOption();
      _item.text = sql.name;
      _item.value = sql.sqlId;
      _item.isDefault = sql.isDefault;
      this.sqlOptionList.push(_item);
    }
    this.defaultSqlOptionList = this.sqlOptionList.map(opt => ({ ...opt } as SelectOption));

    this.offerSchemeOptionList = new Array();
    for (const offerScheme of (this.itemParameterValues.offerSchemes || [])) {
      const _item: SelectOption = new SelectOption();
      _item.text = offerScheme.offerSchemeDescription ?? offerScheme.offerSchemeCode;
      _item.value = offerScheme.offerSchemeCode;
      _item.isDefault = offerScheme.isDefault;
      this.offerSchemeOptionList.push(_item);
    }

    this.ctsOptionList = this.buildBooleanOptionList(this.itemParameterValues.multipleCutting! as any);
    this.htAdditionalOptionList = this.buildBooleanOptionList(this.itemParameterValues.htAdditional! as any);
    this.inspectionType3Dot2IsValidOptionList = this.buildBooleanOptionList(this.itemParameterValues.inspectionType3dot2! as any);
    this.multipleCuttingOptionList = this.buildBooleanOptionList(this.itemParameterValues.multipleCutting! as any);
    this.utOptionList = this.buildBooleanOptionList(this.itemParameterValues.ut! as any);
    this.hydroTesttOptionList = this.buildBooleanOptionList(this.itemParameterValues.hydroTest! as any);
    this.htOptionList = this.buildBooleanOptionList(this.itemParameterValues.ht! as any);
    this.surfaceTypeOptionList = this.getSurfaceTypeOptionList();

    this.endsConditionOptionList = new Array();
    for (var x = 0; x < this.itemParameterValues.endsCondition!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.endsCondition![x].value;
      _item.value = this.itemParameterValues.endsCondition![x].value;
      _item.isDefault = this.itemParameterValues.endsCondition![x].isDefault;
      this.endsConditionOptionList.push(_item);
    }

    this.lengthTypeOptionList = new Array();
    for (var x = 0; x < this.itemParameterValues.lengthType!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.itemParameterValues.lengthType![x].value;
      _item.value = this.itemParameterValues.lengthType![x].value;
      _item.isDefault = this.itemParameterValues.lengthType![x].isDefault;
      this.lengthTypeOptionList.push(_item);
    }

  }

  buildBooleanOptionList(values: { value: any; isDefault: boolean }[]): SelectOption[] {
    const defaultOption: SelectOption[] = [];
    const otherOptions: SelectOption[] = [];

    for (const item of values) {
      const option: SelectOption = new SelectOption();
      option.text = item.value === true ? "Yes" : item.value === false ? "No" : ""; // Handle true/false/null text
      option.value = item.value;
      option.isDefault = item.isDefault;
      if (item.isDefault) {
        defaultOption.push(option);
      } else {
        otherOptions.push(option);
      }
    }

    return [...defaultOption, ...otherOptions];
  }

  getSmsMarketingRouteOptionList(): SelectOption[] {
    let list = new Array();

    let smsMarketingRouteOpts = [...new Set(this.itemParameterValues.sms!.map(s => s.marketingRoute))];


    for (var x = 0; x < smsMarketingRouteOpts.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = smsMarketingRouteOpts[x];
      _item.value = smsMarketingRouteOpts[x];
      list.push(_item);
    }
    return list;
  }


  getSmsOptionList(): SelectOption[] {
    let list = new Array();

    let smsOpts = this.itemParameterValues.sms!;

    if (this.smsMarketingRouteValue) {
      smsOpts = smsOpts.filter(s => s.marketingRoute === this.smsMarketingRouteValue);
    }

    for (var x = 0; x < smsOpts.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = smsOpts[x].description;
      _item.value = smsOpts[x].smsId;
      list.push(_item);
    }
    return list;
  }

  private ensureTubeExecutionOption(currentTubeExecution?: TubeExecution | null) {
    if (!currentTubeExecution || currentTubeExecution.tubeExecutionId == null) {
      return;
    }

    const tubeExecutionId = currentTubeExecution.tubeExecutionId;
    const alreadyInList = this.tubeExecutionOptionList.some(
      opt => opt.value != null && opt.value.toString() === tubeExecutionId.toString()
    );

    if (alreadyInList) {
      return;
    }

    const customOption = new SelectOption();
    customOption.text = currentTubeExecution.description || currentTubeExecution.name || '';
    customOption.value = tubeExecutionId;
    customOption.isDefault = false;

    const emptyIndex = this.tubeExecutionOptionList.findIndex(opt => opt.value == null);
    if (emptyIndex == 0) {
      this.tubeExecutionOptionList.splice(1, 0, customOption);
    } else {
      this.tubeExecutionOptionList.unshift(customOption);
    }
  }

  getTubeExecutionOptionList(): SelectOption[] {
    let list = new Array();

    const emptyOption = new SelectOption();
    emptyOption.text = '';
    emptyOption.value = null;

    list.push(emptyOption);

    let tubeExecutionOpts = this.itemParameterValues.tubeExecution!;

    if (this.smsMarketingRouteValue) {
      tubeExecutionOpts = tubeExecutionOpts.filter(s => s.marketingRoute === this.smsMarketingRouteValue || s.isCustom);
    }

    for (var x = 0; x < tubeExecutionOpts.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = tubeExecutionOpts[x].description;
      _item.value = tubeExecutionOpts[x].tubeExecutionId;
      _item.isDefault = this.smsMarketingRouteValue == 'Hot' ? tubeExecutionOpts[x].isDefaultForHot : tubeExecutionOpts[x].isDefaultForCold
      list.push(_item);
    }
    return list;
  }

  getSurfaceTypeOptionList(smsMarketingRouteValue?: string): SelectOption[] {
    let list = new Array();

    let surfaceTypesOpts = this.itemParameterValues.surfaceTypes!;

    if (smsMarketingRouteValue == 'Hot') {
      surfaceTypesOpts = surfaceTypesOpts.filter(s => s.name !== 'IN BRIGHT CONDITION');
    }

    for (var x = 0; x < surfaceTypesOpts.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = surfaceTypesOpts[x].name;
      _item.value = surfaceTypesOpts[x].surfaceTypeId;
      list.push(_item);
    }

    return list;
  }

  private normalizeSurfaceText(value?: string | null): string {
    return (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private getOdInMm(): number | null {
    const od = Number(this.odValue);
    if (!Number.isFinite(od)) {
      return null;
    }

    const uom = (this.odUomValue || '').toString().toLowerCase();
    if (uom === 'in') return od * 25.4;
    if (uom === 'cm') return od * 10;
    if (uom === 'dm') return od * 100;
    if (uom === 'm') return od * 1000;
    return od; // default mm
  }

  private findSurfaceTypeByNames(names: string[]): any | undefined {
    const candidates = names.map(name => this.normalizeSurfaceText(name));
    return this.itemParameterValues.surfaceTypes?.find(surface => {
      const name = this.normalizeSurfaceText(surface.name);
      const description = this.normalizeSurfaceText((surface as any).description);
      return candidates.includes(name) || candidates.includes(description);
    });
  }

  private resolveDefaultSurfaceType(): any | undefined {
    const route = (this.smsMarketingRouteValue || this.marketingRoute || '').toString().toLowerCase();

    const pickled = this.findSurfaceTypeByNames(['PICKLED / PASSIVATED']);
    const freeFromScale = this.findSurfaceTypeByNames(['FREE FROM SCALE']);
    const brightAnnealed = this.findSurfaceTypeByNames(['BRIGHT ANNEALED', 'IN BRIGHT CONDITION']);

    if (route !== 'cold') {
      return pickled;
    }

    const millShortName = (this.items[this.selectedIndexItem]?.mill?.shortName || this.millValue || '').toString().toUpperCase();
    const odMm = this.getOdInMm();

    if (millShortName === 'CV' && odMm !== null && odMm >= 6 && odMm <= 15) {
      return brightAnnealed || pickled;
    }

    if (millShortName === 'CV' && odMm !== null && odMm > 15) {
      return freeFromScale || pickled;
    }

    if (millShortName === 'RS') {
      return freeFromScale || pickled;
    }

    return pickled;
  }

  private applyDefaultSurfaceType(): void {
    const defaultSurfaceType = this.resolveDefaultSurfaceType();
    if (!defaultSurfaceType) {
      return;
    }

    this.surfaceTypeValue = defaultSurfaceType.surfaceTypeId;
    this.surfaceTypeIsValid = true;
    this.items[this.selectedIndexItem].surfaceType = defaultSurfaceType;
  }

  setupTitleAndIcon() {
    if (this.action === 'edit') {
      this.dialogIcon = 'fal fa-pencil-alt';
      this.title = `${this.translate.instant('grid.editItem')} ${this.items[this.selectedIndexItem]?.customerItemNo || ''
        }`;
    } else if (this.action === 'create') {
      if (this.items[this.selectedIndexItem]?.itemNo) {
        this.dialogIcon = 'fal fa-pencil-alt';
        this.title = `${this.translate.instant('grid.editItem')} ${this.items[this.selectedIndexItem]?.customerItemNo || ''
          }`;
      } else {
        this.dialogIcon = 'fal fa-plus';
        this.title = `${this.translate.instant('enquiryBook.addItem')} (${this.items.filter((x) => !x.itemNo).length
          } ${this.translate.instant('enquiryBook.newItems')})`;
      }
    } else {
      this.dialogIcon = 'fal fa-clone';
      this.title = this.translate.instant('enquiryBook.duplicateItem');
    }

    this.title += ` - ${this.translate.instant('enquiryBook.enquiry')} ${this.enquiryNo}`;
  }

  updateItemDeliveryExtraProperty(property: string, value: boolean): void {
    if (this.selectedIndexItem !== undefined && this.items[this.selectedIndexItem]) {
      this.items[this.selectedIndexItem][property] = value;
    }
  }


  async fillForm() {
    if (!this.enquiryToEdit.enquiryNo) return;

    this.fillFormLoading = true;
    this.setupTitleAndIcon();
    this.getUnitSystems();

    this.fillFromEnquiry = false;
    //  this.action == 'create' && (this.items.length == 1);

    if (!this.fillFromEnquiry) {
      this.unitSystemValue = this.items[this.selectedIndexItem].unitSystem ? this.items[this.selectedIndexItem].unitSystem! : '';
    } else {
      this.unitSystemValue = this.enquiryToEdit.header!.unitSystem ? this.enquiryToEdit.header!.unitSystem! : '';
    }

    // Load UomsList on Selects
    this.prepareUomsList(true);
    const defaultSmsMarketingRoute = this.smsMarketingRouteOptionList?.[0]?.value ?? '';

    if (!this.fillFromEnquiry) {
      this.smsMarketingRouteValue = this.items[this.selectedIndexItem].sms! ? this.items[this.selectedIndexItem].sms!.marketingRoute! : defaultSmsMarketingRoute;
      this.smsValue = this.items[this.selectedIndexItem].sms! ? this.items[this.selectedIndexItem].sms!.smsId! : '';
    } else {
      this.smsValue = this.enquiryToEdit.header!.sms!.smsId ? this.enquiryToEdit.header!.sms!.smsId! : '';
      this.smsMarketingRouteValue = this.enquiryToEdit.header!.sms! ? this.enquiryToEdit.header!.sms!.marketingRoute! : defaultSmsMarketingRoute;

    }
    this.smsOptionList = this.getSmsOptionList();
    this.tubeExecutionOptionList = this.getTubeExecutionOptionList();
    this.surfaceTypeOptionList = this.getSurfaceTypeOptionList(this.smsMarketingRouteValue);

    if (!this.fillFromEnquiry) {
      this.applicableNormsValue = this.items[this.selectedIndexItem].applicableNorms ? this.items[this.selectedIndexItem].applicableNorms! : '';
    } else {
      this.applicableNormsValue = this.enquiryToEdit.header!.applicableNorms ? this.enquiryToEdit.header!.applicableNorms! : '';
    }

    this.alloySurchargeOptionList = new Array();
    this.alloySurchargeOptionList = this.getBooleanOptions();

    this.energySurchargeOptionList = new Array();
    this.energySurchargeOptionList = this.getBooleanOptions();

    this.uBentOptionList = new Array();
    this.uBentOptionList = this.getBooleanOptions();

    if (!this.fillFromEnquiry) {
      //this.alloySurchargeValue = this.items[this.selectedIndexItem].alloySurcharge ? this.items[this.selectedIndexItem].alloySurcharge! : '';
      // MQF269 - GBR 30/05/2024 - Fix AlloySurcharge
      this.alloySurchargeValue = true;
    } else {
      this.alloySurchargeValue = true;
    }
    this.items[this.selectedIndexItem].alloySurcharge = true;

    if (!this.fillFromEnquiry) {
      this.normGradesCodes = this.items[this.selectedIndexItem].normGrades! ? this.items[this.selectedIndexItem].normGrades!.map(x => x.normGradeCode!) : []; //.join(',') : '';
    } else {
      this.normGradesCodes = this.enquiryToEdit.header!.normGrades ? this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeCode!)! : []; //.join(',') : '';
    }
    await this.getNormGrades('', true);

    this.normGradesIds = new Array();
    if (!this.fillFromEnquiry) {
      this.normGradesIds = this.items[this.selectedIndexItem].normGrades! ? this.items[this.selectedIndexItem].normGrades!.map(x => x.normGradeId!) : null;
    } else {
      this.normGradesIds = this.enquiryToEdit.header!.normGrades! ? this.enquiryToEdit.header!.normGrades!.map(x => x.normGradeId!) : null;
    }

    if (!this.fillFromEnquiry) {
      this.rawMaterialGradeValue = this.items[this.selectedIndexItem].rawMaterialGrade! ? this.items[this.selectedIndexItem].rawMaterialGrade!.rawMaterialGradeCode : '';
    } else {
      this.rawMaterialGradeValue = this.enquiryToEdit.header!.rawMaterialGrade ? this.enquiryToEdit.header!.rawMaterialGrade : '';
    }

    if (!this.fillFromEnquiry) {
      this.npsValue = this.items[this.selectedIndexItem].npsSchedule! ? this.items[this.selectedIndexItem].npsSchedule!.npsDescription! : '';
    } else {
      this.npsValue = this.enquiryToEdit.header!.npsSchedule! ? this.enquiryToEdit.header!.npsSchedule!.npsDescription! : '';
    }
    this.npsIsrequired = this.npsValue ? true : false;

    if (!this.fillFromEnquiry) {
      this.npsId = this.items[this.selectedIndexItem].npsSchedule! ? this.items[this.selectedIndexItem].npsSchedule!.npsScheduleId! : null;
      if (this.npsId != null) {
        this.selectedNpsRow = this.items[this.selectedIndexItem].npsSchedule!;
      }
    } else {
      this.npsId = this.enquiryToEdit.header!.npsSchedule! ? this.enquiryToEdit.header!.npsSchedule!.npsScheduleId! : null;
    }

    this.quantityValue = this.items[this.selectedIndexItem].quantity!
    this.quantityUomValue = this.items[this.selectedIndexItem].quantityUom ? this.items[this.selectedIndexItem].quantityUom : '';

    if (!this.fillFromEnquiry) {
      this.odValue = this.npsId ? parseFloat(this.items[this.selectedIndexItem].od!.toString()).toFixed(4) : this.items[this.selectedIndexItem].od!;
      this.odUomValue = this.items[this.selectedIndexItem].odUom ? this.items[this.selectedIndexItem].odUom! : this.getDefaultUom('od')?.value;
      this.wtValue = this.npsId ? parseFloat(this.items[this.selectedIndexItem].wt!.toString()).toFixed(4) : this.items[this.selectedIndexItem].wt!;
      this.wtUomValue = this.items[this.selectedIndexItem].wtUom ? this.items[this.selectedIndexItem].wtUom! : this.getDefaultUom('wt')?.value;
      this.totalWeightValue = this.items[this.selectedIndexItem].totalWeight;
      this.totalWeightUomValue = this.items[this.selectedIndexItem].totalWeightUom ? this.items[this.selectedIndexItem].totalWeightUom : '';
      this.idValue = this.items[this.selectedIndexItem].id!;
      this.idUomValue = this.items[this.selectedIndexItem].idUom ? this.items[this.selectedIndexItem].idUom! : this.getDefaultUom('id')?.value;
      this.lengthUomValue = this.items[this.selectedIndexItem].lengthUom ? this.items[this.selectedIndexItem].lengthUom : this.lengthUomOptionList.find(i => i.isDefault)?.value;
    } else {
      this.odValue = this.npsId ? parseFloat(this.enquiryToEdit.header!.od!.toString()).toFixed(4) : this.enquiryToEdit.header!.od!;
      this.odUomValue = this.enquiryToEdit.header!.odUom ? this.enquiryToEdit.header!.odUom! : this.getDefaultUom('od')?.value;
      this.wtValue = this.npsId ? parseFloat(this.enquiryToEdit.header!.wt!.toString()).toFixed(4) : this.enquiryToEdit.header!.wt!;
      this.wtUomValue = this.enquiryToEdit.header!.wtUom ? this.enquiryToEdit.header!.wtUom! : this.getDefaultUom('wt')?.value;
      this.totalWeightValue = this.enquiryToEdit.header!.totalWeight;
      this.totalWeightUomValue = this.enquiryToEdit.header!.totalWeightUom ? this.enquiryToEdit.header!.totalWeightUom : '';
      this.idValue = this.enquiryToEdit.header!.id!;
      this.idUomValue = this.enquiryToEdit.header!.idUom ? this.enquiryToEdit.header!.idUom! : this.getDefaultUom('id')?.value;
      this.lengthUomValue = this.lengthUomOptionList.find(i => i.isDefault)?.value;
    }

    this.setItemUoms();

    this.odToleranceMinusValue = this.items[this.selectedIndexItem].odToleranceMinus;
    this.odTolerancePlusValue = this.items[this.selectedIndexItem].odTolerancePlus;
    this.odToleranceUomValue = this.items[this.selectedIndexItem].odToleranceUom;

    this.idToleranceMinusValue = this.items[this.selectedIndexItem].idToleranceMinus;
    this.idTolerancePlusValue = this.items[this.selectedIndexItem].idTolerancePlus;
    this.idToleranceUomValue = this.items[this.selectedIndexItem].idToleranceUom;

    this.typeOfToleranceValue = this.items[this.selectedIndexItem].typeOfTolerance;
    this.tubeExecutionValue = this.items[this.selectedIndexItem].tubeExecution ? this.items[this.selectedIndexItem].tubeExecution?.tubeExecutionId : undefined;
    this.wtToleranceMinusValue = this.items[this.selectedIndexItem].wtToleranceMinus;
    this.wtTolerancePlusValue = this.items[this.selectedIndexItem].wtTolerancePlus;
    this.wtToleranceUomValue = this.items[this.selectedIndexItem].wtToleranceUom;
    if (this.items[this.selectedIndexItem].tubeExecution?.isCustom) {
      this.ensureTubeExecutionOption(this.items[this.selectedIndexItem].tubeExecution);
    }

    if (!this.fillFromEnquiry) {
      this.marketFamilyValue = this.items[this.selectedIndexItem].marketFamily! ? this.items[this.selectedIndexItem].marketFamily!.marketFamilyId : '';
    } else {
      this.marketFamilyValue = this.enquiryToEdit.header!.marketFamily! ? this.enquiryToEdit.header!.marketFamily!.marketFamilyId : '';
    }

    this.utValue = this.items[this.selectedIndexItem].ut != undefined ? this.items[this.selectedIndexItem].ut : this.utOptionList.find(i => i.isDefault)?.value;
    if (this.items[this.selectedIndexItem].ht != undefined) {
      this.htValue = this.items[this.selectedIndexItem].ht;
    } else {
      this.setDefaultHtValue();
    }
    this.multipleCuttingValue = this.items[this.selectedIndexItem].multipleCutting != undefined ? this.items[this.selectedIndexItem].multipleCutting : this.multipleCuttingOptionList.find(i => i.isDefault)?.value;
    this.hydroTestValue = this.items[this.selectedIndexItem].hydroTest != undefined ? this.items[this.selectedIndexItem].hydroTest : this.hydroTesttOptionList.find(i => i.isDefault)?.value;
    this.inspectionType3Dot2Value = this.items[this.selectedIndexItem].inspectionType3Dot2 != undefined ? this.items[this.selectedIndexItem].inspectionType3Dot2 : this.inspectionType3Dot2IsValidOptionList.find(i => i.isDefault)?.value;
    this.htAdditionalValue = this.items[this.selectedIndexItem].htAdditional != undefined ? this.items[this.selectedIndexItem].htAdditional : this.htAdditionalOptionList.find(i => i.isDefault)?.value;

    this.endsConditionValue = this.items[this.selectedIndexItem].endsCondition ? this.items[this.selectedIndexItem].endsCondition : this.endsConditionOptionList.find(i => i.isDefault)?.value;

    this.lengthTypeValue = this.items[this.selectedIndexItem].lengthType ? this.items[this.selectedIndexItem].lengthType : this.lengthTypeOptionList.find(i => i.isDefault)?.value;
    this.getMills();
    this.millValue = this.items[this.selectedIndexItem].mill! ? this.items[this.selectedIndexItem].mill!.shortName! : '';

    if (!this.fillFromEnquiry) {
      this.lengthMinValue = this.items[this.selectedIndexItem].lengthMin;
      this.lengthMaxValue = this.items[this.selectedIndexItem].lengthMax;
      this.nominalLengthValue = this.items[this.selectedIndexItem].lengthNominal ? this.items[this.selectedIndexItem].lengthNominal! : null;
    } else {
      this.setDefaultLength();
    }

    if (this.fillFromEnquiry) {
      if (this.isHollowBarsSms(this.enquiryToEdit.header?.sms)) {
        this.onSelectedHollowBarsSms();
      }
    }

    if (this.items[this.selectedIndexItem].surfaceType) {
      this.surfaceTypeValue = this.items[this.selectedIndexItem].surfaceType!.surfaceTypeId;
    } else {
      this.applyDefaultSurfaceType();
    }

    this.optionDateValue = this.items[this.selectedIndexItem].optionDate;
    this.customerDeliveryDateValue = this.items[this.selectedIndexItem].customerDeliveryDate;

    this.testConditionValue = this.fillFromEnquiry ? this.testConditionOptionList.find(i => i.isDefault)?.value : this.items[this.selectedIndexItem].testCondition!;
    this.sqlValue = this.items[this.selectedIndexItem].sql?.sqlId ?? this.sqlOptionList.find(i => i.isDefault)?.value;
    this.items[this.selectedIndexItem].sql = this.itemParameterValues.sqls?.find(x => x.sqlId == this.sqlValue);
    this.offerSchemeValue = this.items[this.selectedIndexItem].offerScheme?.offerSchemeCode ?? this.offerSchemeOptionList.find(i => i.isDefault)?.value;
    this.items[this.selectedIndexItem].offerScheme = this.itemParameterValues.offerSchemes?.find(x => x.offerSchemeCode == this.offerSchemeValue);
    this.uBentValue = this.items[this.selectedIndexItem].uBent ? this.items[this.selectedIndexItem].uBent! : false;
    if (this.shouldSetUbentFromHeaderForFirstItem()) {
      this.setUbentValue(true);
    }
    this.energySurchargeValue = this.items[this.selectedIndexItem].energySurcharge ? this.items[this.selectedIndexItem].energySurcharge! : false;
    this.multipleLengthValue = this.items[this.selectedIndexItem].multipleLength ? this.items[this.selectedIndexItem].multipleLength! : false;

    this.ctsValue = !!this.items[this.selectedIndexItem].cts;
    this.syncHydroTestRule(false);

    this.dyePenetrantValue = !!this.items[this.selectedIndexItem].dyePenetrant;
    this.dyePenetrant100PValue = !!this.items[this.selectedIndexItem].dyePenetrant100P;
    this.penaltyValue = !!this.items[this.selectedIndexItem].penalty;
    this.colorCodingValue = !!this.items[this.selectedIndexItem].colorCoding;
    this.specialOperationsValue = !!this.items[this.selectedIndexItem].specialOperations;
    this.specialTestsValue = !!this.items[this.selectedIndexItem].specialTests;
    this.grindingHoningValue = !!this.items[this.selectedIndexItem].grindingHoning;
    this.ecValue = !!this.items[this.selectedIndexItem].ec;
    this.notStdPackagingValue = !!this.items[this.selectedIndexItem].notStdPackaging;

    this.customerItemNoValue = this.items[this.selectedIndexItem].customerItemNo || '';
    this.remarkValue = this.items[this.selectedIndexItem].remark || '';

    // materialCode
    this.materialValue = this.items[this.selectedIndexItem].material?.materialCode;
    if (this.materialValue) {
      // init norms list based on material code
      this.setNormsByMaterialCode(this.materialValue);
    }


    this.getWtOdIDNpsTTButtons();
    //if (this.action == 'edit' || this.action == 'duplicate') this.checkWtOdId(false);

    // Setto a disabled Od/Id/Wt se ho un NPS Schedule
    if (this.npsId != null) {
      this.odReadOnly = true;
      this.odUomReadOnly = true;
      this.idReadOnly = true;
      this.idUomReadOnly = true;
      this.idIsRequired = false;
      this.idUomIsRequired = false;
      this.wtReadOnly = true;
      this.wtUomReadOnly = true;
    }

    if (this.fillFromEnquiry) {
      this.fillItemFromEnquiry();
    } else {
      if (this.action == 'edit' || this.action == 'duplicate') {
        this.checkDataObsolete();
        this.isFormValid(false);
      }
    }

    this.checkWtOdId(false);
    this.fillFormLoading = false;
  }

  setNormsByMaterialCode(materialCode: string) {
    this.subscriptions.add(this.backendService.getItemAttributesByMaterialCode(materialCode, this.enquiryToEdit.header!.unitSystem!).subscribe({
      next: res => {
        this.normGradesMaterialDataset = res.normGrades;
        this.normGradesDataset = res.normGrades?.sort(this.sortNormGrades) || [];
      },
      error: error => {
        if (!this.isMaterialCodeUnavailableError(error)) {
          return;
        }

        const currentMaterialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
        if (currentMaterialCode?.toString().trim().toLowerCase() !== materialCode.toString().trim().toLowerCase()) {
          return;
        }

        this.clearUnavailableMaterialCode();
      }
    }));

  }

  private isMaterialCodeUnavailableError(error: unknown): boolean {
    return error === this.translate.instant('errors.400040');
  }

  private clearUnavailableMaterialCode(): void {
    this.itemAttributesForMaterialCode = undefined;
    this.resetSqlOptionList();
    this.materialValue = undefined;
    this.materialIsValid = !this.materialIsRequired;

    if (this.selectedIndexItem != -1 && this.items[this.selectedIndexItem]) {
      this.items[this.selectedIndexItem].material = undefined;
    }

    if (this.normGradesDataset_Cache.length > 0) {
      this.normGradesDataset = this.normGradesDataset_Cache;
    } else {
      this.getNormGrades('', false);
    }
  }

  fillItemFromEnquiry() {
    this.items[this.selectedIndexItem]!.alloySurcharge = true;
    if (!this.items[this.selectedIndexItem].normGrades) {
      this.items[this.selectedIndexItem].normGrades = new Array();
      this.items[this.selectedIndexItem].normGrades = this.enquiryToEdit.header!.normGrades!;
    }

    if (this.npsId != null) {
      this.items[this.selectedIndexItem]!.npsSchedule = this.enquiryToEdit.header!.npsSchedule;
      this.selectedNpsRow = this.enquiryToEdit.header!.npsSchedule!;
    }

    this.items[this.selectedIndexItem]!.od = this.odValue;
    this.items[this.selectedIndexItem]!.odUom = this.odUomValue;
    this.items[this.selectedIndexItem]!.wt = this.wtValue;
    this.items[this.selectedIndexItem]!.wtUom = this.wtUomValue;
    this.items[this.selectedIndexItem]!.totalWeight = this.totalWeightValue;
    this.items[this.selectedIndexItem]!.totalWeightUom = this.totalWeightUomValue;
    this.items[this.selectedIndexItem]!.id = this.idValue;
    this.items[this.selectedIndexItem]!.idUom = this.idUomValue;

    if (this.action == 'edit') this.checkDataObsolete();
    this.getWtOdIDNpsTTButtons();
    this.applyOdMillRule();
  }

  setRoundDigitsEnquiryForm() {
    // ROUND DIGITS
    if (!this.roundDigitsForItemForm || this.roundDigitsForItemForm.length == 0) return;
    if (!this.items || this.items.length == 0) return;

    let _unitSystem: string = this.items[this.selectedIndexItem].unitSystem!;

    let _i: number = -1;
    for (var k = 0; k < this.roundDigitsForItemForm.length; k++) {
      let _obj: EnquiryHeaderItem = new EnquiryHeaderItem();
      _obj = this.items[this.selectedIndexItem];
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (key.toLowerCase() == this.roundDigitsForItemForm[k].fieldName!.toLowerCase()) {
          if (key == 'od' && this.odValue != _value)
            _value = this.odValue;

          if (key == 'wt' && this.wtValue != _value)
            _value = this.wtValue;

          if (_unitSystem == 'Metric' && _value != null && _value != '') {
            _obj[key as keyof typeof _obj] = Number.parseFloat(parseFloat(_value).toFixed(this.roundDigitsForItemForm[k].metricDigits!));
          }

          if (_unitSystem == 'Imperial' && _value != null && _value != '') {
            _obj[key as keyof typeof _obj] = Number.parseFloat(parseFloat(_value).toFixed(this.roundDigitsForItemForm[k].imperialDigits!));
          }

          if (key == 'od')
            this.odValue = _obj[key as keyof typeof _obj];

          if (key == 'wt')
            this.wtValue = _obj[key as keyof typeof _obj];
        }
      }

      this.items[this.selectedIndexItem] = JSON.parse(JSON.stringify(_obj));
    }
  }

  getRoundDigits(col: string): number {
    if (!this.roundDigitsForItemForm || this.roundDigitsForItemForm.length == 0) return 2;
    let _i: number = this.roundDigitsForItemForm.findIndex(x => x.fieldName?.toLowerCase() == col.toLowerCase());
    if (_i != -1) {
      if (this.items[this.selectedIndexItem].unitSystem == 'Metric') {
        return this.roundDigitsForItemForm[_i].metricDigits!;
      } else {
        return this.roundDigitsForItemForm[_i].imperialDigits!;
      }
    } else {
      return 2;
    }

  }

  setDefaultLength() {
    if (!this.enquiryToEdit?.header?.unitSystem) return;

    const isMetric = this.enquiryToEdit.header.unitSystem === 'Metric';
    const odMinKey = isMetric ? 'odMinMetric' : 'odMinImperial';
    const odMaxKey = isMetric ? 'odMaxMetric' : 'odMaxImperial';
    const idMinKey = isMetric ? 'idMinMetric' : 'idMinImperial';
    const idMaxKey = isMetric ? 'idMaxMetric' : 'idMaxImperial';
    const wtMinKey = isMetric ? 'wtMinMetric' : 'wtMinImperial';
    const wtMaxKey = isMetric ? 'wtMaxMetric' : 'wtMaxImperial';
    const lengthMinKey = isMetric ? 'minLengthMetric' : 'minLengthImperial';
    const lengthMaxKey = isMetric ? 'maxLengthMetric' : 'maxLengthImperial';

    let odValue = Number(this.odValue);
    let idValue = Number(this.idValue);
    let wtValue = Number(this.wtValue);


    if (idValue) {
      if (!odValue) {
        odValue = idValue! - (2 * wtValue);
      }
      if (!wtValue) {
        wtValue = (odValue! - idValue!) / 2
      }
    }


    const defaultLengthList = this.itemParameterLengthValues.defaultLengths?.filter(dl => {
      return (
        (!dl.plantsId || dl.plantsId.includes(this.millValue.mill?.millId!)) &&
        (!dl.smsId || dl.smsId.includes(this.smsValue.sms?.smsId!)) &&
        (!dl.rawMaterialGradesId || dl.rawMaterialGradesId.includes(this.rawMaterialGradeValue.rawMaterialGrade?.rawMaterialGradeId!)) &&
        (!dl.lengthType || dl.lengthType === this.lengthTypeValue) &&
        (!dl[odMinKey] || (odValue && odValue >= dl[odMinKey]!)) &&
        (!dl[odMaxKey] || (odValue && odValue <= dl[odMaxKey]!)) &&
        (!dl[idMinKey] || (idValue && idValue >= dl[idMinKey]!)) &&
        (!dl[idMaxKey] || (idValue && idValue <= dl[idMaxKey]!)) &&
        (!dl[wtMinKey] || (wtValue && wtValue >= dl[wtMinKey]!)) &&
        (!dl[wtMaxKey] || (wtValue && wtValue <= dl[wtMaxKey]!))
      );
    });

    if (defaultLengthList?.length) {
      const bestMatch = defaultLengthList.reduce((best, current) => {
        const bestNulls = [best.plantsId, best.smsId, best.rawMaterialGradesId, best.lengthType].filter(v => v == null).length;
        const currentNulls = [current.plantsId, current.smsId, current.rawMaterialGradesId, current.lengthType].filter(v => v == null).length;
        return currentNulls < bestNulls ? current : best;
      });
      this.lengthMinValue = bestMatch[lengthMinKey];
      this.lengthMaxValue = bestMatch[lengthMaxKey];

      if (this.lengthTypeValue == 'FL') {
        this.nominalLengthValue = this.lengthMinValue;
      }

      this.items[this.selectedIndexItem].lengthMin = this.lengthMinValue;
      this.items[this.selectedIndexItem].lengthMax = this.lengthMaxValue;
      this.items[this.selectedIndexItem].lengthNominal = this.nominalLengthValue;
    }

  }

  checkDataObsolete() {
    // GBR 16/02/2024
    // MQF-98 - Se l'oggetto non è nella lista resetto valori
    // I campi da verificare sono: SMS, NormGrades, Nps, RawMaterialGrade, MarketFamily e SurfaceType
    let _i: number = -1;
    let _k: number = -1;

    // SMS
    _k = this.itemParameterValues.sms!.findIndex(x => x.smsId == this.items[this.selectedIndexItem].sms!.smsId);
    if (_k == -1) {
      this.items[this.selectedIndexItem].sms = undefined;
      this.smsValue = null;
      this.smsIsValid = false;
    }

    // NormGrades (creo una nuova lista che sesclude quelli che non sono più validi)
    // Spostata dentro la getNormGrades

    // RawMaterialGrade
    // Qui i dati si aggiornano sulla base dell'esito del check nella getNormGrades

    // Nps
    // Se Nps è presente
    if (this.items[this.selectedIndexItem].npsSchedule) {
      this.npsIsrequired = true; // lo metto a required
      this.getNpsAndSchedules(false); // Gestito qui dentro
    }


    // MarketFamily
    _k = this.itemParameterValues.marketFamily!.findIndex(x => x.marketFamilyId == this.items[this.selectedIndexItem].marketFamily!.marketFamilyId);
    if (_k == -1) {
      this.items[this.selectedIndexItem].marketFamily = undefined;
      this.marketFamilyValue = null;
      this.marketFamilyIsValid = false;
    }

    // SurfaceType
    _k = this.itemParameterValues.surfaceTypes!.findIndex(x => x.surfaceTypeId == this.items[this.selectedIndexItem].surfaceType!.surfaceTypeId);
    if (_k == -1) {
      this.items[this.selectedIndexItem].surfaceType = undefined;
      this.surfaceTypeValue = null;
      this.surfaceTypeIsValid = false;
    }

    // SQL
    _k = this.itemParameterValues.sqls?.findIndex(x => x.sqlId == this.items[this.selectedIndexItem].sql?.sqlId) ?? -1;
    if (_k == -1) {
      this.items[this.selectedIndexItem].sql = undefined;
      this.sqlValue = null;
      this.sqlIsValid = false;
    }

    // OfferScheme
    _k = this.itemParameterValues.offerSchemes?.findIndex(x => x.offerSchemeCode == this.items[this.selectedIndexItem].offerScheme?.offerSchemeCode) ?? -1;
    if (_k == -1) {
      this.items[this.selectedIndexItem].offerScheme = undefined;
      this.offerSchemeValue = null;
      this.offerSchemeIsValid = false;
    }

  }

  async getNormGrades(value: string, fromFillForm: boolean): Promise<void> {
    if (fromFillForm) this.teiasoftLoader.start();
    try {


      const res = await firstValueFrom(this.backendService.getNormGrades([]));
      if (res && res.normGrades) {
        this.normGradesDataset = new Array();

        if (this.materialValue) {
          this.normGradesDataset = [
            ...this.normGradesMaterialDataset!.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
            ...this.normGradesMaterialDataset!.filter(x =>
              x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
              !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
            ).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!))
          ];
        }
        else if (value != '') {
          this.normGradesDataset = [
            ...res.normGrades.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
            ...res.normGrades.filter(x =>
              x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
              !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
            ).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!))
          ];

        } else {
          this.normGradesDataset = res.normGrades!
            .slice() // Create a shallow copy of the array to avoid modifying the original array
            .sort(this.sortNormGrades) // Sort by the 'score' property in descending order
            .slice(0, 100); // Take the top 100 records

          this.normGradesDataset_Cache = this.normGradesDataset;

          // GBR 16/02/2024
          // MQF-98 - Se l'oggetto non è nella lista resetto valori
          let _newList: EnquiyNormGrade[] = new Array();
          let _clearData: boolean = false;
          let _k: number = -1;

          if (!this.items[this.selectedIndexItem].normGrades) {
            this.items[this.selectedIndexItem].normGrades = new Array();
          }

          for (var c = 0; c < this.items[this.selectedIndexItem].normGrades!.length; c++) {
            _k = res.normGrades.findIndex(x => x.normGradeId == this.items[this.selectedIndexItem].normGrades![c].normGradeId);
            if (_k != -1) {
              _newList.push(this.items[this.selectedIndexItem].normGrades![c]);
            } else {
              _clearData = true;
            }
          }

          // Se sono in edit e la norm grade associata non è presente nei 100 la aggiungo (ma solo se esiste)
          for (var x = 0; x < this.items[this.selectedIndexItem].normGrades!.length; x++) {
            if (_clearData == false && this.normGradesDataset.findIndex(n => n.normGradeId == this.items[this.selectedIndexItem].normGrades![x].normGradeId) == -1)
              this.normGradesDataset!.unshift(this.items[this.selectedIndexItem].normGrades![x]);
          }

          this.items[this.selectedIndexItem].normGrades = _newList;
          if (_newList && _newList.length > 0) {
            let _ids: number[] = new Array();
            let _codes: string[] = new Array();
            for (var x = 0; x < this.items[this.selectedIndexItem].normGrades!.length; x++) {
              _ids.push(this.items[this.selectedIndexItem].normGrades![x].normGradeId!);
              _codes.push(this.items[this.selectedIndexItem].normGrades![x].normGradeCode!);
            }
            this.normGradesCodes = new Array();
            this.normGradesCodes = _codes;
            if (!this.normGradesIds) this.normGradesIds = new Array();
            this.normGradesIds = _ids;
            if (_ids.length > 0) {
              //this.getRawMaterialGrades('', _ids);
              this.getLimitationsForNormGrades(_ids, fromFillForm);
              //this.normGradeIsValid = true;
            }
          } else {
            this.normGradesIds = null;
            this.normGradesCodes = [];
            if (this.action == 'edit' || this.action == 'duplicate') {
              this.normGradeIsValid = false;
              this.analysisLimitationIsValid = false;
              this.otherLimitationIsValid = false;
            }
            this.teiasoftLoader.stop();
          }
          // A questo punto devo sbiancare anche la RawMaterialGrade (se esiste)
          if (_clearData) {
            if (this.items[this.selectedIndexItem].rawMaterialGrade?.rawMaterialGradeCode) {
              this.items[this.selectedIndexItem].rawMaterialGrade = undefined;
              this.rawMaterialGradeDataset = [];
              this.rawMaterialGradeAvailableDataset = [];
              this.rawMaterialGradeValue = null;
              this.rawMaterialGradeDisabled = true;
            }
            this.analysisLimitationFreeInput = false;
            this.analysisLimitationOptionList = new Array();
            this.analysisLimitationValue = '';
            this.otherLimitationFreeInput = false;
            this.otherLimitationOptionList = new Array();
            this.otherLimitationValue = '';
          }
        }
      }
    }
    finally {
      this.teiasoftLoader.stop();
    }
  }

  sortNormGrades(a: any, b: any) {
    let nameA: string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
    let nameB: string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  }

  private getLimitationsForRawMaterialRequest(): { analysis: string | null, other: string | null } {
    const ignoreLimitations = this.analysisLimitationFreeInput || this.otherLimitationFreeInput;
    return {
      analysis: ignoreLimitations ? null : this.analysisLimitationValue,
      other: ignoreLimitations ? null : this.otherLimitationValue
    };
  }

  private canLoadRawMaterialGrades(): boolean {
    return !!(this.normGradesIds && this.normGradesIds.length) &&
      ((this.analysisLimitationValue != '' && this.otherLimitationValue != '') || this.analysisLimitationFreeInput || this.otherLimitationFreeInput);
  }

  private reloadRawMaterialGradesOnLimitationChange(fromFillForm: boolean = false) {
    if (!this.canLoadRawMaterialGrades()) return;
    this.getRawMaterialGradesFromNormGradesAndLimitations('', this.normGradesIds!, fromFillForm);
  }


  getRawMaterialGrades(value: string, normGradeIds: number[]) {
    if (this.rawMaterialSubscription != undefined) this.rawMaterialSubscription.unsubscribe();
    this.rawMaterialSubscription = this.backendService.getRawMaterialGrades(normGradeIds).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        this.rawMaterialGradeDisabled = false;
        if (res.rawMaterialGrades.length > 0) {
          this.setRawMaterialGradeDatasets(res.rawMaterialGrades, value);
          // Se è un solo valore popolo direttamente la select
          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.rawMaterialGradeDataset);
          if (autoSelectedGrade) {
            this.rawMaterialGradeValue = autoSelectedGrade.rawMaterialGradeCode;
            this.items[this.selectedIndexItem].rawMaterialGrade = autoSelectedGrade;
          }
        } else {
          this.rawMaterialGradeAvailableDataset = [];
          this.rawMaterialGradeDataset = [];
          this.rawMaterialGradeValue = null;
          this.rawMaterialGradeDisabled = true;
          this.items[this.selectedIndexItem].rawMaterialGrade = undefined;
        }
      }
    });
  }

  getLimitationsForNormGrades(normGradeIds: number[], fromFillForm: boolean) {
    this.subscriptions.add(this.backendService.getLimitationsForNormGrades(normGradeIds).subscribe(res => {
      this.limitationForNormGrade = new LimitationsForNormGrades();
      this.limitationForNormGrade = res;
      this.analysisLimitationOptionList = new Array();
      this.otherLimitationOptionList = new Array();
      this.analysisLimitationValue = '';
      this.otherLimitationValue = '';
      /* ANALYSIS LIMITATION */
      if (res.gradeCustomerAnalysisLimitations!.length > 0) {
        for (var x = 0; x < res.gradeCustomerAnalysisLimitations!.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.value = res.gradeCustomerAnalysisLimitations![x].limitation!;
          _item.text = res.gradeCustomerAnalysisLimitations![x].limitation!;
          this.analysisLimitationOptionList.push(_item);
        }
        if (this.fillFromEnquiry) {
          this.analysisLimitationValue = res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0].limitation!;
        } else {
          if (this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation! != '') {
            this.analysisLimitationValue = this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation!;
            this.analysisLimitationFreeInput = this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation?.isCustom!;
          } else {
            this.analysisLimitationValue = res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0].limitation!;
            this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation! = res.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0];
          }
        }
      }
      else if (this.action === 'edit') {
        // MQF-207: the backendService returned 0 gradeCustomerAnalysisLimitations, but the field should be filled with the loaded value. e.g. Custom limitations are not retrieved by the service.
        this.analysisLimitationValue = this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation?.limitation!;
        this.analysisLimitationFreeInput = this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation?.isCustom!;
      }

      /* OTHER LIMITATION */
      if (res.gradeCustomerOtherLimitations!.length > 0) {
        for (var x = 0; x < res.gradeCustomerOtherLimitations!.length; x++) {
          let _item: SelectOption = new SelectOption();
          _item.value = res.gradeCustomerOtherLimitations![x].limitation!;
          _item.text = res.gradeCustomerOtherLimitations![x].limitation!;
          this.otherLimitationOptionList.push(_item);
        }
        if (this.fillFromEnquiry) {
          this.otherLimitationValue = res.gradeCustomerOtherLimitations!.findIndex(x => x.isDefault == true) != -1 ? res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0].limitation! : res.gradeCustomerOtherLimitations![0].limitation!;
        } else {
          if (this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation! != '') {
            this.otherLimitationValue = this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation!;
            this.otherLimitationFreeInput = this.items[this.selectedIndexItem].gradeCustomerOtherLimitation?.isCustom!;
          } else {
            this.otherLimitationValue = res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0].limitation!;
            this.items[this.selectedIndexItem].gradeCustomerOtherLimitation! = res.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0];
          }
        }
      }
      else if (this.action === 'edit') {
        // Same behavior as gradeCustomerAnalysisLimitations. Pre-fill even if the backend service returned zero
        this.otherLimitationValue = this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation!;
        this.otherLimitationFreeInput = this.items[this.selectedIndexItem].gradeCustomerOtherLimitation?.isCustom!;
      }

      // In Edit: Check if both limtation are present in list
      let _clearDataAnalysis: boolean = false;
      let _clearDataOther: boolean = false;
      let _i: number = -1;
      if (this.action == 'edit' && this.analysisLimitationFreeInput == false) {
        _i = res.gradeCustomerAnalysisLimitations!.findIndex(x => x.limitation! == this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation);
        if (_i == -1) _clearDataAnalysis = true;
      }

      if (this.action == 'edit' && this.otherLimitationFreeInput == false) {
        _i = res.gradeCustomerOtherLimitations!.findIndex(x => x.limitation! == this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation);
        if (_i == -1) _clearDataOther = true;
      }

      if (_clearDataAnalysis) {
        this.analysisLimitationFreeInput = false;
        this.analysisLimitationValue = '';
      }

      if (_clearDataOther) {
        this.otherLimitationFreeInput = false;
        this.otherLimitationValue = '';
      }

      // Get Raw Material Grad if limitations have values or at least one is custom
      if (this.canLoadRawMaterialGrades()) {
        // Passo i valori di Default all'oggetto ITEMS
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = this.analysisLimitationFreeInput;
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = this.analysisLimitationValue;

        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = this.otherLimitationFreeInput;
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = this.otherLimitationValue;

        // Set Limitations as valid
        this.analysisLimitationIsValid = true;
        this.otherLimitationIsValid = true;

        this.getRawMaterialGradesFromNormGradesAndLimitations('', this.normGradesIds!, fromFillForm);
      } else {

        // MQF-207 
        this.rawMaterialGradeValue = null;
        this.rawMaterialGradeDisabled = true;
        this.rawMaterialGradeIsRequired = false;
        this.rawMaterialGradeDataset = [];
        this.rawMaterialGradeAvailableDataset = [];
        this.items[this.selectedIndexItem].rawMaterialGrade = undefined;

        if (fromFillForm) this.teiasoftLoader.stop();
      }
    }));
  }

  getRawMaterialGradesFromNormGradesAndLimitations(value: string, normGradesId: number[], fromFillForm: boolean) {
    const { analysis, other } = this.getLimitationsForRawMaterialRequest();
    this.subscriptions.add(this.backendService.getRawMaterialGradesFromNormGradesAndLimitations(normGradesId, analysis, other).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        this.rawMaterialGradeDisabled = false;
        if (res.rawMaterialGrades.length > 0) {
          this.setRawMaterialGradeDatasets(res.rawMaterialGrades, value);

          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.rawMaterialGradeDataset);
          if (fromFillForm && this.rawMaterialGradeValue != '') {
            // if already present dont'override while filling the form
          }
          // Se è un solo valore popolo direttamente la select
          else if (autoSelectedGrade) {
            this.rawMaterialGradeValue = autoSelectedGrade.rawMaterialGradeCode;
            this.items[this.selectedIndexItem].rawMaterialGrade = autoSelectedGrade;
            this.rawMaterialGradeIsValid = true;
          }
          else if (this.getAutoSelectableRawMaterialGrades(this.rawMaterialGradeDataset).length > 1) {
            // cerco match con padre
            //  se ho un material code non faccio nulla => il raw material è gia selezionato
            const headerRawMaterial = this.rawMaterialGradeDataset.find(rm => rm.rawMaterialGradeCode == this.enquiryToEdit.header?.rawMaterialGrade && rm.isDummy !== true);
            if (headerRawMaterial && !this.materialValue) {
              this.rawMaterialGradeValue = headerRawMaterial.rawMaterialGradeCode;
              this.items[this.selectedIndexItem].rawMaterialGrade = headerRawMaterial;
              this.rawMaterialGradeIsValid = true;
            }

          }

          // ensure input shows the selected grade if it's still available
          const selectedGradeCode = this.items[this.selectedIndexItem].rawMaterialGrade?.rawMaterialGradeCode;
          const selectedGradeExists = selectedGradeCode && this.rawMaterialGradeDataset.some(rm => rm.rawMaterialGradeCode === selectedGradeCode);
          if (selectedGradeExists) {
            this.rawMaterialGradeValue = selectedGradeCode!;
            this.rawMaterialGradeIsValid = true;
          } else if (autoSelectedGrade) {
            this.rawMaterialGradeValue = autoSelectedGrade.rawMaterialGradeCode;
            this.items[this.selectedIndexItem].rawMaterialGrade = autoSelectedGrade;
            this.rawMaterialGradeIsValid = true;
          }
          else {
            this.rawMaterialGradeValue = null;
            this.items[this.selectedIndexItem].rawMaterialGrade = undefined;
          }

          this.rawMaterialGradeIsRequired = true;
        } else {
          this.rawMaterialGradeAvailableDataset = [];
          this.rawMaterialGradeDataset = [];
          this.rawMaterialGradeValue = null;
          this.rawMaterialGradeDisabled = false;
          this.rawMaterialGradeIsRequired = false;
          this.items[this.selectedIndexItem].rawMaterialGrade = undefined;
        }
        // MP: If no raw material grades are returned, set the field as valid and disabled
        if (res.rawMaterialGrades.length === 0) {
          this.rawMaterialGradeIsValid = true;
          this.rawMaterialGradeDisabled = true;
        }
      }
      if (fromFillForm) this.teiasoftLoader.stop();
    }));
  }

  private getAutoSelectableRawMaterialGrades(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade[] {
    return (rawMaterialGrades || []).filter(rawMaterialGrade => rawMaterialGrade?.isDummy !== true);
  }

  private getSingleAutoSelectableRawMaterialGrade(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade | undefined {
    const selectableGrades = this.getAutoSelectableRawMaterialGrades(rawMaterialGrades);
    return selectableGrades.length === 1 ? selectableGrades[0] : undefined;
  }

  private shouldRequireRawMaterialGrade(): boolean {
    return !this.rawMaterialGradeDisabled && this.rawMaterialGradeAvailableDataset.length > 0;
  }

  private getSelectedRawMaterialGrade(): RawMaterialGrade | undefined {
    const selectedRawMaterialGradeId = this.items[this.selectedIndexItem]?.rawMaterialGrade?.rawMaterialGradeId;
    if (selectedRawMaterialGradeId != null) {
      return this.rawMaterialGradeAvailableDataset.find(rmg => rmg.rawMaterialGradeId === selectedRawMaterialGradeId);
    }

    return this.rawMaterialGradeAvailableDataset.find(rmg => rmg.rawMaterialGradeCode === this.rawMaterialGradeValue);
  }

  private setRawMaterialGradeDatasets(rawMaterialGrades: RawMaterialGrade[], filterValue: string = ''): void {
    this.rawMaterialGradeAvailableDataset = this.sortRawMaterialGrades(rawMaterialGrades || []);
    const normalizedFilter = (filterValue || '').toString().trim().toLowerCase();
    this.rawMaterialGradeDataset = normalizedFilter
      ? this.rawMaterialGradeAvailableDataset.filter(x => x.rawMaterialGradeCode!.toLowerCase().includes(normalizedFilter))
      : this.rawMaterialGradeAvailableDataset.slice(0, 100);
  }

  private sortRawMaterialGrades(rawMaterialGrades: RawMaterialGrade[]): RawMaterialGrade[] {
    return rawMaterialGrades
      .slice()
      .sort((a: any, b: any) => {
        let nameA: string = a["rawMaterialGradeCode"]!.toUpperCase();
        let nameB: string = b["rawMaterialGradeCode"]!.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
  }

  getUoms(uom: string): SelectOption[] {
    let _list: SelectOption[] = new Array();
    for (const prop in this.itemParameterValues) {
      if (prop.toString() == uom) {
        let _uoms: UomsType = new UomsType();
        _uoms = this.itemParameterValues[prop as keyof ItemParametersValues] as UomsType;
        if (this.unitSystemValue.toLowerCase() == 'metric') {
          for (var x = 0; x < _uoms.metricUoms!.length; x++) {
            let _item: SelectOption = new SelectOption();
            _item.text = _uoms.metricUoms![x].uomCode!;
            _item.value = _uoms.metricUoms![x].uomCode!;
            _item.isDefault = _uoms.metricUoms![x].isDefault;
            if (!_uoms.metricUoms![x].isDefault)
              _list.push(_item);
            else
              _list.unshift(_item);
          }
        } else {
          for (var x = 0; x < _uoms.imperialUoms!.length; x++) {
            let _item: SelectOption = new SelectOption();
            _item.text = _uoms.imperialUoms![x].uomCode!;
            _item.value = _uoms.imperialUoms![x].uomCode!;
            _item.isDefault = _uoms.imperialUoms![x].isDefault;
            if (!_uoms.imperialUoms![x].isDefault)
              _list.push(_item);
            else
              _list.unshift(_item);
          }
        }
      }
    }

    return _list;
  }

  getUnitSystems() {
    this.unitSystemOptionList = new Array();
    this.unitSystemOptionList = [
      { value: 'Metric', text: this.translate.instant("enquiryBook.metric") },
      { value: 'Imperial', text: this.translate.instant("enquiryBook.imperial") }
    ];
  }

  getBooleanOptions(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let _item: SelectOption = new SelectOption();
    _item.text = this.translate.instant("noTranslations.yes");
    _item.value = true;
    _list.push(_item);
    _item = new SelectOption();
    _item.text = this.translate.instant("noTranslations.no");
    _item.value = false;
    _list.push(_item);
    return _list;
  }

  getWtOdIDNpsTTButtons() {
    this.toolbarButtonsList = new Array();

    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "wtOdId";
    _item.action = "select|wtOdIt";
    _item.type = "toggle";
    _item.state = this.items[this.selectedIndexItem].npsSchedule != null ? "" : 'pressed';
    _item.toggleText = "wtOdId";
    this.toolbarButtonsList.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "nps";
    _item.action = "select|nps";
    _item.type = "toggle";
    _item.state = this.items[this.selectedIndexItem].npsSchedule != null ? "pressed" : '';
    _item.toggleText = "nps";
    this.toolbarButtonsList.push(_item);

  }

  getMills() {
    this.millDataset = new Array();
    this.millDataset = this.itemParameterValues!.mills!;
  }

  checkWtOdId(isSave: boolean): boolean {
    //wtodidMandatory
    let _ret: boolean = true;
    let _odValue: any = this.odValue != null ? this.odValue : '';
    let _idValue: any = this.idValue != null ? this.idValue : '';
    let _wtValue: any = this.wtValue != null ? this.wtValue : '';
    const hasOdValue: boolean = _odValue !== '';
    const hasIdValue: boolean = _idValue !== '';
    const hasWtValue: boolean = _wtValue !== '';
    let _case: string = '';

    // NOT VALID - ALL VALUES PROVIDED (exactly two dimensions are required)
    if (hasOdValue && hasIdValue && hasWtValue) {
      this.odIsRequired = true;
      this.idIsRequired = true;
      this.wtIsRequired = true;

      this.odIsValid = false;
      this.idIsValid = false;
      this.wtIsValid = false;

      this.odUomIsRequired = true;
      this.idUomIsRequired = true;
      this.wtUomIsRequired = true;

      this.odUomIsValid = !(this.odUomValue == null || this.odUomValue == '');
      this.idUomIsValid = !(this.idUomValue == null || this.idUomValue == '');
      this.wtUomIsValid = !(this.wtUomValue == null || this.wtUomValue == '');

      if (isSave)
        this.teiasoftToaster.show("error", this.translate.instant('errors.odIdWtOnlyTwo'));
      return false;
    }

    // NOT VALID - ALL VALUES NULL
    if (_odValue == '' && _idValue == '' && _wtValue == '') {
      this.odIsRequired = true;
      this.odIsValid = false;

      this.odUomIsRequired = true;
      if (this.odUomValue == null || this.odUomValue == '') this.odUomIsValid = false;

      this.idIsRequired = true;
      this.idIsValid = false;

      this.idUomIsRequired = true;
      if (this.idUomValue == null || this.idUomValue == '') this.idUomIsValid = false;

      this.wtIsRequired = true;
      this.wtIsValid = false;

      this.wtUomIsRequired = true;
      if (this.wtUomValue == null || this.wtUomValue == '') this.wtUomIsValid = false;
    }

    // NOT VALID - OD VALID, ID NULL, WT NULL
    if (_odValue != '' && _idValue == '' && _wtValue == '') {
      this.odIsRequired = true;
      this.odIsValid = true;
      this.odUomIsRequired = true;
      this.odUomValue = this.odUomValue;
      this.odUomIsValid = this.odUomValue == null ? false : true;

      this.idIsRequired = true;
      this.idIsValid = false;
      this.idUomIsRequired = true;
      this.idUomIsValid = (this.idUomValue == null || this.idUomValue == '') ? false : true;

      this.wtIsRequired = true;
      this.wtIsValid = false;
      this.wtUomIsRequired = true;
      this.wtUomIsValid = (this.wtUomValue == null || this.wtUomValue == '') ? false : true;
    }

    // NOT VALID - OD NULL, ID VALID, WT NULL
    if (_odValue == '' && _idValue != '' && _wtValue == '') {
      this.odIsRequired = true;
      this.odIsValid = false;
      this.odUomIsRequired = true;
      this.odUomIsValid = (this.odUomValue == null || this.odUomValue == '') ? false : true;

      this.idIsRequired = true;
      this.idIsValid = true;
      this.idUomIsRequired = true;
      this.idUomValue = this.idUomValue;
      this.idUomIsValid = true;

      this.wtIsRequired = true;
      this.wtIsValid = false;
      this.wtUomIsRequired = true;
      this.wtUomIsValid = (this.wtUomValue == null || this.wtUomValue == '') ? false : true;
    }

    // NOT VALID - OD NULL, ID NULL, WT VALID
    if (_odValue == '' && _idValue == '' && _wtValue != '') {
      this.odIsRequired = true;
      this.odIsValid = false;
      this.odUomIsRequired = true;
      this.odUomIsValid = (this.odUomValue == null || this.odUomValue == '') ? false : true;

      this.idIsRequired = true;
      this.idIsValid = false;
      this.idUomIsRequired = true;
      this.idUomIsValid = (this.idUomValue == null || this.idUomValue == '') ? false : true;

      this.wtIsRequired = true;
      this.wtIsValid = true;
      this.wtUomIsRequired = true;
      this.wtUomValue = this.wtUomValue;
      this.wtUomIsValid = true;
    }

    // 1 VALID - OD VALID, ID VALID, WT NULL
    if (_odValue != '' && _idValue != '' && _wtValue == '') {
      this.odIsRequired = true;
      this.odIsValid = true;
      this.odUomIsRequired = true;
      this.odUomValue = this.odUomValue;
      this.odUomIsValid = !(this.odUomValue == null || this.odUomValue == '');

      this.idIsRequired = true;
      this.idIsValid = true;
      this.idUomIsRequired = true;
      this.idUomValue = this.idUomValue;
      this.idUomIsValid = !(this.idUomValue == null || this.idUomValue == '');

      this.wtIsRequired = true;
      this.wtIsValid = true;
      this.wtUomIsRequired = false;
      this.wtUomIsValid = true;
      // this.wtUomValue = '';
      _case = '1';
    }

    // 2 VALID - OD NULL, ID VALID, WT VALID
    if (_odValue == '' && _idValue != '' && _wtValue != '') {
      this.odIsRequired = true;
      this.odIsValid = true;
      this.odUomIsRequired = false;
      this.odUomIsValid = true;
      // this.odUomValue = '';

      this.idIsRequired = true;
      this.idIsValid = true;
      this.idUomIsRequired = true;
      this.idUomValue = this.idUomValue;
      this.idUomIsValid = !(this.idUomValue == null || this.idUomValue == '');

      this.wtIsRequired = true;
      this.wtIsValid = true;
      this.wtUomIsRequired = true;
      this.wtUomValue = this.wtUomValue;
      this.wtUomIsValid = !(this.wtUomValue == null || this.wtUomValue == '');
      _case = '2';
    }

    // 3 VALID - OD VALID, ID NULL, WT VALID
    if (_odValue != '' && _idValue == '' && _wtValue != '') {
      this.odIsRequired = true;
      this.odIsValid = true;
      this.odUomIsRequired = true;
      this.odUomValue = this.odUomValue;
      this.odUomIsValid = !(this.odUomValue == null || this.odUomValue == '');

      this.idIsRequired = true;
      this.idIsValid = true;
      this.idUomIsRequired = false;
      this.idUomIsValid = true;
      // this.idUomValue = '';

      this.wtIsRequired = true;
      this.wtIsValid = true;
      this.wtUomIsRequired = true;
      this.wtUomValue = this.wtUomValue;
      this.wtUomIsValid = !(this.wtUomValue == null || this.wtUomValue == '');
      _case = '3';
    }

    // Caso in cui tutti sono compilati (allora metto tutte le uom mandatory e prendo i valori)
    if (_odValue != '' && _idValue != '' && _wtValue != '') {
      this.odIsRequired = true;
      this.idIsRequired = true;
      this.wtIsRequired = true;
      this.odUomIsRequired = true;
      this.idUomIsRequired = true;
      this.wtUomIsRequired = true;
      this.idIsValid = true;
      this.odIsValid = true;
      this.wtIsValid = true;
      _case = '4';
    }

    // CHECK REGOLA od>id od>wt
    if (_ret) {
      // Prendo le uom per una corretta valutazione dei dati e porto tutto in millimetri/inches
      let _od: number = 0;
      let _id: number = 0;
      let _wt: number = 0;
      if (this.unitSystemValue.toLowerCase() == 'metric') {
        _od = this.odValue * (this.odUomValue == 'cm' ? 10 : (this.odUomValue == 'dm' ? 100 : (this.odUomValue == 'm' ? 1000 : 1)));
        _id = this.idValue * (this.idUomValue == 'cm' ? 10 : (this.idUomValue == 'dm' ? 100 : (this.idUomValue == 'm' ? 1000 : 1)));
        _wt = this.wtValue * (this.wtUomValue == 'cm' ? 10 : (this.wtUomValue == 'dm' ? 100 : (this.wtUomValue == 'm' ? 1000 : 1)));
      } else {
        _od = this.odValue * (this.odUomValue == 'thou' ? 0.001 : (this.odUomValue == 'ft' ? 12 : (this.odUomValue == 'm' ? 36 : 1)));
        _id = this.idValue * (this.idUomValue == 'thou' ? 0.001 : (this.idUomValue == 'ft' ? 12 : (this.idUomValue == 'm' ? 36 : 1)));
        _wt = this.wtValue * (this.wtUomValue == 'thou' ? 0.001 : (this.wtUomValue == 'ft' ? 12 : (this.wtUomValue == 'm' ? 36 : 1)));
      }


      if ((_case == '1' || _case == '4') && _od <= _id) {
        this.odIsValid = false;
        this.idIsValid = false;
        this.teiasoftToaster.show("error", this.translate.instant('errors.odMajorId'));
      }

      if ((_case == '3' || _case == '4') && _od <= (2 * _wt)) {
        this.odIsValid = false;
        this.wtIsValid = false;
        this.teiasoftToaster.show("error", this.translate.instant('errors.odMajorWt'));
      }

      if (_case == '4' && (Number((_od - _id)).toFixed(2) != (2 * _wt).toFixed(2))) {
        this.idIsValid = false;
        this.odIsValid = false;
        this.wtIsValid = false;
        this.teiasoftToaster.show("error", this.translate.instant('errors.odIdWtNotConsistent'));
      }

      _ret = (this.odIsValid && this.odUomIsValid && this.idIsValid && this.idUomIsValid && this.wtIsValid && this.wtUomIsValid);

      if (_ret) {
        // this.odIsValid = true;
        // this.idIsValid = true;
        // this.wtIsValid = true;
        this.items[this.selectedIndexItem].odUom = this.odUomValue;
        this.items[this.selectedIndexItem].idUom = this.idUomValue;
        this.items[this.selectedIndexItem].wtUom = this.wtUomValue;

      }
    } else {
      if (isSave == true) this.teiasoftToaster.show("error", this.translate.instant('errors.wtodidMandatory'));
    }

    return _ret;
  }

  setWtOdIdNps(show: string, cancelValue: boolean) {
    if (show == 'nps') {
      // Turn OFF 
      this.odIsRequired = false;
      //this.odValue = this.items[this.selectedIndexItem].od;
      this.odReadOnly = true;

      this.odUomIsRequired = false;
      //this.odUomValue = this.items[this.selectedIndexItem].odUom;
      this.odUomReadOnly = true;

      this.idIsRequired = false;
      this.idValue = null; //this.items[this.selectedIndexItem].id;
      this.idReadOnly = true;
      //this.idIsDisabled = true;

      this.idUomIsRequired = false;
      this.idUomValue = null; // this.items[this.selectedIndexItem].idUom;
      this.idToleranceMinusValue = null;
      this.idTolerancePlusValue = null;
      this.idToleranceUomValue = null;
      this.items[this.selectedIndexItem].idToleranceMinus = undefined;
      this.items[this.selectedIndexItem].idTolerancePlus = undefined;
      this.items[this.selectedIndexItem].idToleranceUom = undefined;

      this.idUomReadOnly = true;
      //this.idUomIsDisabled = true;

      this.wtIsRequired = false;
      //this.wtValue = this.items[this.selectedIndexItem].wt;
      this.wtReadOnly = true;

      this.wtUomIsRequired = false;
      //this.wtUomValue = this.items[this.selectedIndexItem].wtUom;
      this.wtUomReadOnly = true;

      // Turn ON Nps Description
      /*  this.npsValue = this.items[this.selectedIndexItem].npsSchedule ? this.items[this.selectedIndexItem].npsSchedule.npsDescription : '';
       this.npsId =  this.items[this.selectedIndexItem].npsSchedule ? this.items[this.selectedIndexItem].npsSchedule.npsScheduleId : null; */
      this.npsIsReadOnly = true;
      this.npsDisabled = false;
      this.npsIsrequired = true;

    } else {
      // Turn ON ID/OD/WT
      this.odIsRequired = true;
      this.odValue = null; //cancelValue ? '' : this.items[this.selectedIndexItem].od;
      this.items[this.selectedIndexItem].od = this.odValue;
      this.odReadOnly = false;

      this.cleanOdTolerances();


      this.odUomIsRequired = true;
      this.odUomValue = this.items[this.selectedIndexItem].unitSystem?.toLowerCase() == 'metric' ? this.itemParameterValues.odUoms!.metricUoms!.filter(x => x.isDefault == true)[0].uomCode! : this.itemParameterValues.odUoms!.imperialUoms!.filter(x => x.isDefault == true)[0].uomCode!
      this.items[this.selectedIndexItem].odUom = this.odUomValue;
      this.odUomReadOnly = false;

      this.idIsRequired = true;
      this.idValue = null; //''; //cancelValue ? '' : this.items[this.selectedIndexItem].id;
      this.items[this.selectedIndexItem].id = this.idValue;
      this.idReadOnly = false;
      //this.idIsDisabled = false;

      this.idUomIsRequired = true;
      this.idUomValue = this.items[this.selectedIndexItem].unitSystem?.toLowerCase() == 'metric' ? this.itemParameterValues.idUoms!.metricUoms!.filter(x => x.isDefault == true)[0].uomCode! : this.itemParameterValues.idUoms!.imperialUoms!.filter(x => x.isDefault == true)[0].uomCode!
      this.items[this.selectedIndexItem].idUom = this.idUomValue;
      this.idUomReadOnly = false;
      //this.idUomIsDisabled = true;
      this.cleanIdTolerances();

      this.wtIsRequired = true;
      this.wtValue = null; //cancelValue ? '' :this.items[this.selectedIndexItem].wt;
      this.items[this.selectedIndexItem].wt = this.wtValue;
      this.wtReadOnly = false;

      this.wtUomIsRequired = true;
      this.wtUomValue = this.items[this.selectedIndexItem].unitSystem?.toLowerCase() == 'metric' ? this.itemParameterValues.wtUoms!.metricUoms!.filter(x => x.isDefault == true)[0].uomCode! : this.itemParameterValues.wtUoms!.imperialUoms!.filter(x => x.isDefault == true)[0].uomCode!
      this.items[this.selectedIndexItem].wtUom = this.wtUomValue;
      this.wtUomReadOnly = false;

      this.cleanWtTolerances();

      // Turn OFF Nps Description
      this.turnOffNps();
    }
  }

  turnOffNps() {
    this.npsValue = '';
    this.npsId = null;
    this.npsIsReadOnly = true;
    this.npsDisabled = true;
    this.npsIsrequired = false;
    this.items[this.selectedIndexItem].npsSchedule = null;
    this.odReadOnly = false;
    this.idReadOnly = false;
    this.wtReadOnly = false;
    this.getWtOdIDNpsTTButtons();
  }

  private cleanWtTolerances() {
    this.wtToleranceUomValue = null;
    this.wtToleranceUomIsValid = true;
    this.wtToleranceMinusValue = null;
    this.wtToleranceMinusIsValid = true;
    this.wtTolerancePlusValue = null;
    this.wtTolerancePlusIsValid = true;
    this.tubeExecutionValue = null;
    this.typeOfToleranceValue = null;
    this.items[this.selectedIndexItem].wtToleranceUom = this.wtToleranceUomValue;
    this.items[this.selectedIndexItem].wtToleranceMinus = this.wtToleranceMinusValue;
    this.items[this.selectedIndexItem].wtTolerancePlus = this.wtTolerancePlusValue;
    this.items[this.selectedIndexItem].tubeExecution = this.tubeExecutionValue;
    this.items[this.selectedIndexItem].typeOfTolerance = this.typeOfToleranceValue;
    this.tubeExecutionIsDisabled = true;
    this.tubeExecutionIsValid = true;
    this.typeOfToleranceIsDisabled = true;
    this.typeOfToleranceIsValid = true;
  }

  private cleanIdTolerances() {
    this.idToleranceUomValue = null;
    this.idToleranceUomIsValid = true;
    this.idToleranceMinusValue = null;
    this.idToleranceMinusIsValid = true;
    this.idTolerancePlusValue = null;
    this.idTolerancePlusIsValid = true;
    this.items[this.selectedIndexItem].idToleranceUom = this.idToleranceUomValue;
    this.items[this.selectedIndexItem].idToleranceMinus = this.idToleranceMinusValue;
    this.items[this.selectedIndexItem].idTolerancePlus = this.idTolerancePlusValue;
  }

  private cleanOdTolerances() {
    this.odToleranceUomValue = null;
    this.odToleranceUomIsValid = true;
    this.odToleranceMinusValue = null;
    this.odToleranceMinusIsValid = true;
    this.odTolerancePlusValue = null;
    this.odTolerancePlusIsValid = true;
    this.items[this.selectedIndexItem].odToleranceUom = this.odToleranceUomValue;
    this.items[this.selectedIndexItem].odToleranceMinus = this.odToleranceMinusValue;
    this.items[this.selectedIndexItem].odTolerancePlus = this.odTolerancePlusValue;
  }

  getNpsAndSchedules(openForm: boolean) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getNpsAndSchedules().subscribe(res => {
      this.teiasoftLoader.stop();
      this.dataSetNps = new Array();
      if (res) {
        this.dataSetNps = this.utils.sortNpSAndSchedule(res.npsSchedules!); // MQF-150
        for (var x = 0; x < this.dataSetNps.length; x++) {
          let obj: any = this.dataSetNps[x];
          for (const key in obj) {
            if (typeof obj[key] == 'number') {
              if (key.toLowerCase() != 'npsscheduleid') {
                let _digits: number = 2;
                let _col: string = key.substring(0, 2);
                if (key.indexOf("Metric") != -1 && this.roundDigitsForItemForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForItemForm!.filter(r => r.fieldName == _col)[0].metricDigits!;
                }
                if (key.indexOf("Imperial") != -1 && this.roundDigitsForItemForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForItemForm!.filter(r => r.fieldName == _col)[0].imperialDigits!;
                }
                this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(_digits); // Number(this.dataSetNps[x][key].toFixed(4));
              }
              //this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(4); // Number(this.dataSetNps[x][key].toFixed(4));
            }
          }

          // Adding Uoms
          let _metricUom: string = "metricUom";
          this.dataSetNps[x][_metricUom as string] = 'mm';

          let _imperialUom: string = "imperialUom";
          this.dataSetNps[x][_imperialUom as string] = 'in';
        }

        // GBR 16/02/2024
        // MQF-98 - Se l'oggetto non è nella lista resetto valori
        if (openForm == false) {
          let _k: number = -1;
          _k = this.dataSetNps.findIndex(x => x["npsScheduleId"] == this.items[this.selectedIndexItem].npsSchedule!.npsScheduleId!);
          if (_k == -1) {
            this.items[this.selectedIndexItem].npsSchedule = undefined;
            this.npsValue = null;
            this.npsIsValid = false;
            // DEVO ANCHE PULIRE OD/WT e relative Uoms
            this.items[this.selectedIndexItem].od = undefined;
            this.odValue = null;
            this.items[this.selectedIndexItem].odUom = undefined;
            this.odUomValue = null;
            this.items[this.selectedIndexItem].wt = undefined;
            this.wtValue = null;
            this.items[this.selectedIndexItem].wtUom = undefined;
            this.wtUomValue = null;
          }
        } else {
          this.showSelectNps = true;
        }
      }
    }));
  }

  setUomDefault(uom: string): string | null {
    let _uomSystem: string = this.unitSystemValue != null ? this.unitSystemValue : '';
    if (_uomSystem == '') return null;
    if (uom == 'od') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.odUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.odUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'id') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.idUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.idUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'wt') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.wtUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.wtUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'totalWeight') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.totalWeightUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.totalWeightUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'quantity') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.quantityUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.quantityUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'length') {
      if (_uomSystem.toLowerCase() == 'metric')
        return this.itemParameterValues!.lengthUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode!;
      else
        return this.itemParameterValues!.lengthUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode!;
    }

    if (uom == 'all') {
      if (_uomSystem.toLowerCase() == 'metric') {
        this.odUomValue = this.itemParameterValues!.odUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.idUomValue = this.itemParameterValues!.idUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.wtUomValue = this.itemParameterValues!.wtUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.quantityUomValue = this.itemParameterValues!.quantityUoms!.metricUoms?.filter(x => x.isDefault == true)[0]?.uomCode;
        this.totalWeightUomValue = this.itemParameterValues!.totalWeightUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.lengthUomValue = this.itemParameterValues!.lengthUoms!.metricUoms?.filter(x => x.isDefault == true)[0].uomCode;
      } else {
        this.odUomValue = this.itemParameterValues!.odUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.idUomValue = this.itemParameterValues!.idUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.wtUomValue = this.itemParameterValues!.wtUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.quantityUomValue = this.itemParameterValues!.quantityUoms!.imperialUoms?.filter(x => x.isDefault == true)[0]?.uomCode;
        this.totalWeightUomValue = this.itemParameterValues!.totalWeightUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode;
        this.lengthUomValue = this.itemParameterValues!.lengthUoms!.imperialUoms?.filter(x => x.isDefault == true)[0].uomCode;
      }
    }



    // Assign values
    this.setItemUoms();
    return '';
  }

  setItemUoms() {
    this.items[this.selectedIndexItem].odUom = this.odUomValue;
    this.items[this.selectedIndexItem].idUom = this.idUomValue;
    this.items[this.selectedIndexItem].wtUom = this.wtUomValue;
    this.items[this.selectedIndexItem].quantityUom = this.quantityUomValue;
    this.items[this.selectedIndexItem].totalWeightUom = this.totalWeightUomValue;
    this.items[this.selectedIndexItem].lengthUom = this.lengthUomValue;
  }

  isFormValid(checkLimitation: boolean): boolean {
    let _ret: boolean = true;

    const normalizedCustomerItemNo = this.utils.normalizeCustomerItemNo(this.customerItemNoValue);
    if (!normalizedCustomerItemNo || !this.utils.isCustomerItemNoNumeric(normalizedCustomerItemNo)) {
      this.customerItemNoIsValid = false;
      _ret = false;
    } else {
      this.customerItemNoIsValid = true;
      this.customerItemNoValue = normalizedCustomerItemNo;
      this.items[this.selectedIndexItem].customerItemNo = normalizedCustomerItemNo;
    }

    this.alloySurchargeIsValid = true;

    if (!this.normGradesCodes || this.normGradesCodes.length == 0) {
      this.normGradeIsValid = false;
      _ret = false;
    } else {
      this.normGradeIsValid = true;
    }

    if (checkLimitation == true) {
      if (this.analysisLimitationValue == '') {
        this.analysisLimitationIsValid = false;
        _ret = false;
      } else {
        this.analysisLimitationIsValid = true;
      }

      if (this.otherLimitationValue == '') {
        this.otherLimitationIsValid = false;
        _ret = false;
      } else {
        this.otherLimitationIsValid = true;
      }
    }


    // Raw material grade is required only when options are available
    const shouldRequireRawMaterialGrade = this.shouldRequireRawMaterialGrade();
    this.rawMaterialGradeIsRequired = shouldRequireRawMaterialGrade;
    if (shouldRequireRawMaterialGrade && !this.getSelectedRawMaterialGrade()) {
      this.rawMaterialGradeIsValid = false;
      _ret = false;
    } else {
      this.rawMaterialGradeIsValid = true;
    }

    if (this.unitSystemValue == null || this.unitSystemValue == '') {
      this.unitSystemIsValid = false;
      _ret = false;
    } else {
      this.unitSystemIsValid = true;
    }

    if (this.quantityValue == null || this.quantityValue.toString() == '') {
      this.quantityIsValid = false;
      _ret = false;
    } else {
      this.quantityIsValid = true;
    }

    if (this.quantityUomValue == null || this.quantityUomValue.toString() == '') {
      this.quantityUomIsValid = false;
      _ret = false;
    } else {
      this.quantityUomIsValid = true;
    }

    if (this.wtValue && (this.typeOfToleranceValue == null || this.typeOfToleranceValue.toString() == '')) {
      this.typeOfToleranceIsValid = false;
      _ret = false;
    } else {
      this.typeOfToleranceIsValid = true;
    }

    const hasTubeExecution = this.tubeExecutionValue != null && this.tubeExecutionValue.toString() != '';
    const requiresWtTolerances = this.wtValue && hasTubeExecution;

    this.tubeExecutionIsValid = true;

    if (requiresWtTolerances && (this.wtToleranceMinusValue == null || this.wtToleranceMinusValue.toString() == '')) {
      this.wtToleranceMinusIsValid = false;
      _ret = false;
    } else {
      this.wtToleranceMinusIsValid = true;
    }

    if (requiresWtTolerances && (this.wtTolerancePlusValue == null || this.wtTolerancePlusValue.toString() == '')) {
      this.wtTolerancePlusIsValid = false;
      _ret = false;
    } else {
      this.wtTolerancePlusIsValid = true;
    }

    if (requiresWtTolerances && (this.wtToleranceUomValue == null || this.wtToleranceUomValue.toString() == '')) {
      this.wtToleranceUomIsValid = false;
      _ret = false;
    } else {
      this.wtToleranceUomIsValid = true;
    }

    if (this.lengthTypeValue == null || this.lengthTypeValue.toString() == '') {
      this.lengthTypeIsValid = false;
      _ret = false;
    } else {
      this.lengthTypeIsValid = true;
    }

    if ((this.lengthMinValue == null || this.lengthMinValue.toString() == '') && (this.multipleLengthValue!! || this.lengthTypeValue == 'RL')) {
      this.lengthMinIsValid = false;
      _ret = false;
    } else {
      this.lengthMinIsValid = true;
    }

    if ((this.lengthMaxValue == null || this.lengthMaxValue.toString() == '') && (this.multipleLengthValue!! || this.lengthTypeValue == 'RL')) {
      this.lengthMaxIsValid = false;
      _ret = false;
    } else {
      this.lengthMaxIsValid = true;
    }

    if (this.lengthUomValue == null || this.lengthUomValue.toString() == '') {
      this.lengthUomIsValid = false;
      _ret = false;
    } else {
      this.lengthUomIsValid = true;
    }

    if (this.smsValue == null || this.smsValue.toString() == '') {
      this.smsIsValid = false;
      _ret = false;
    } else {
      this.smsIsValid = true;
    }

    if (this.marketFamilyValue == null || this.marketFamilyValue.toString() == '') {
      this.marketFamilyIsValid = false;
      _ret = false;
    } else {
      this.marketFamilyIsValid = true;
    }


    if (this.endsConditionValue == null || this.endsConditionValue.toString() == '') {
      this.endsConditionIsvalid = false;
      _ret = false;
    } else {
      this.endsConditionIsvalid = true;
    }

    if (this.surfaceTypeValue == null || this.surfaceTypeValue.toString() == '') {
      this.surfaceTypeIsValid = false;
      _ret = false;
    } else {
      this.surfaceTypeIsValid = true;
    }

    if (this.sqlValue == null || this.sqlValue.toString() == '') {
      this.sqlIsValid = false;
      _ret = false;
    } else {
      this.sqlIsValid = true;
    }

    if (this.offerSchemeValue == null || this.offerSchemeValue.toString() == '') {
      this.offerSchemeIsValid = false;
      _ret = false;
    } else {
      this.offerSchemeIsValid = true;
    }

    if (this.millValue == null || this.millValue == undefined || this.millValue.toString() == '') {
      this.millIsValid = false;
      _ret = false;
    } else {
      this.millIsValid = true;
    }

    // if (this.totalWeightValue == null || this.totalWeightValue.toString() == ''){
    //   this.totalWeightIsvalid = false;
    //   _ret = false;
    // } else {
    //   this.totalWeightIsvalid = true;
    // }

    if (this.totalWeightUomValue == null || this.totalWeightUomValue.toString() == '') {
      this.totalWeightUomIsValid = false;
      _ret = false;
    } else {
      this.totalWeightUomIsValid = true;
    }

    // if (this.optionDateValue == null || this.optionDateValue == undefined || this.optionDateValue.toString() == 'NaN' || this.optionDateValue.toString() == '') {
    //   this.optionDateIsValid = false;
    //   _ret = false;
    // } else {
    //   this.optionDateIsValid = true;
    // }

    /*     if (_ret && checkWtOdId) 
      _ret = this.checkWtOdId(checkWtOdId); */


    if (this.energySurchargeValue == null) {
      this.energySurchargeIsValid = false;
      _ret = false;
    } else {
      this.energySurchargeIsValid = true;
    }

    // if (this.testConditionValue == null || this.testConditionValue.toString() == '') {
    //   this.testConditionIsvalid = false;
    //   _ret = false;
    // } else {
    //   this.testConditionIsvalid = true;
    // }

    if (this.uBentValue == null) {
      this.uBentIsValid = false;
      _ret = false;
    } else {
      this.uBentIsValid = true;
    }

    if (this.multipleLengthValue == null) {
      this.multipleLengthIsValid = false;
      _ret = false;
    } else {
      this.multipleLengthIsValid = true;
    }


    return _ret;
  }

  isFormValidForOtherItem(checkWtOdId: boolean): boolean {
    let _ret: boolean = true;
    if (!this.normGradesCodes || this.normGradesCodes.length == 0)
      _ret = false;

    if (this.unitSystemValue == null || this.unitSystemValue == '')
      _ret = false;


    if (this.quantityValue == null || this.quantityValue.toString() == '')
      _ret = false;

    if (this.quantityUomValue == null || this.quantityUomValue.toString() == '')
      _ret = false;

    if (this.typeOfToleranceValue == null || this.typeOfToleranceValue.toString() == '')
      _ret = false;

    if (this.lengthTypeValue == null || this.lengthTypeValue.toString() == '')
      _ret = false;

    if (this.lengthMinValue == null || this.lengthMinValue.toString() == '')
      _ret = false;

    if (this.lengthMaxValue == null || this.lengthMaxValue.toString() == '')
      _ret = false;

    if (this.lengthUomValue == null || this.lengthUomValue.toString() == '')
      _ret = false;

    if (this.smsValue == null || this.smsValue.toString() == '')
      _ret = false;

    if (this.marketFamilyValue == null || this.marketFamilyValue.toString() == '')
      _ret = false;

    if (this.utValue == null || this.utValue.toString() == '')
      _ret = false;

    if (this.hydroTestValue == null || this.hydroTestValue.toString() == '')
      _ret = false;

    if (this.endsConditionValue == null || this.endsConditionValue.toString() == '')
      _ret = false;

    if (this.htValue == null || this.htValue.toString() == '')
      _ret = false;

    if (this.htAdditionalValue == null || this.htAdditionalValue.toString() == '')
      _ret = false;

    if (this.inspectionType3Dot2Value == null || this.inspectionType3Dot2Value.toString() == '')
      _ret = false;

    if (this.multipleCuttingValue == null || this.multipleCuttingValue.toString() == '')
      _ret = false;

    if (this.surfaceTypeValue == null || this.surfaceTypeValue.toString() == '')
      _ret = false;

    if (this.sqlValue == null || this.sqlValue.toString() == '')
      _ret = false;

    if (this.offerSchemeValue == null || this.offerSchemeValue.toString() == '')
      _ret = false;

    if (this.millValue == null || this.millValue == undefined || this.millValue.toString() == '')
      _ret = false;

    // if (this.totalWeightValue == null || this.totalWeightValue.toString() == '')
    //   _ret = false;

    if (this.totalWeightUomValue == null || this.totalWeightUomValue.toString() == '')
      _ret = false;

    if (this.optionDateValue == null || this.optionDateValue == undefined || this.optionDateValue.toString() == 'NaN' || this.optionDateValue.toString() == '')
      _ret = false;

    //if (checkWtOdId) this.checkWtOdId(checkWtOdId);
    return _ret;
  }

  isGraterZeroValuesValid(): boolean {
    let _ret: boolean = true;

    if (this.quantityValue != null && parseFloat(this.quantityValue.toString()) <= 0) {
      this.quantityIsValid = false;
      _ret = false;
    }

    if (this.odValue != null && this.odValue <= 0) {
      this.odIsValid = false;
      _ret = false;
    }

    if (this.idValue != null && this.idValue <= 0) {
      this.idIsValid = false;
      _ret = false;
    }

    if (this.wtValue != null && this.wtValue <= 0) {
      this.wtIsValid = false;
      _ret = false;
    }

    if (this.lengthMinValue != null && this.lengthMinValue <= 0) {
      this.lengthMinIsValid = false;
      _ret = false;
    }

    if (this.lengthMaxValue != null && this.lengthMaxValue <= 0) {
      this.lengthMaxIsValid = false;
      _ret = false;
    }


    return _ret;
  }

  invalidateWeight(): void {
    this.totalWeightValue = '';
  }

  calculateWeight(): void {
    this.checkWeightCanBeCalculated();

    if (!this.totalWeightCanBeCalculated) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.fieldMandatory'));
      return;
    }

    const payload = new CalculateItemWeightParamters();
    payload.unitSystem = this.unitSystemValue;
    payload.quantity = this.quantityValue;
    payload.quantityUom = this.quantityUomValue;
    payload.totalWeightUom = this.totalWeightUomValue;
    payload.od = this.odValue;
    payload.odUom = this.odUomValue;
    payload.odToleranceMinus = this.toFiniteNumberOrUndefined(this.odToleranceMinusValue);
    payload.odTolerancePlus = this.toFiniteNumberOrUndefined(this.odTolerancePlusValue);
    payload.odToleranceUom = this.odToleranceUomValue;
    payload.wt = this.wtValue;
    payload.wtUom = this.wtUomValue;
    payload.id = this.idValue;
    payload.idUom = this.idUomValue;
    payload.idToleranceMinus = this.toFiniteNumberOrUndefined(this.idToleranceMinusValue);
    payload.idTolerancePlus = this.toFiniteNumberOrUndefined(this.idTolerancePlusValue);
    payload.idToleranceUom = this.idToleranceUomValue;
    payload.npsScheduleId = this.npsId;
    payload.rawMaterialGradeId = this.getSelectedRawMaterialGrade()?.rawMaterialGradeId;
    payload.smsId = Number.isFinite(this.smsValue) ? this.smsValue : null;
    payload.typeOfTolerance = this.typeOfToleranceValue;
    payload.tubeExecutionId = this.tubeExecutionValue === "" ? null : this.tubeExecutionValue;
    payload.wtToleranceMinus = this.toFiniteNumberOrUndefined(this.wtToleranceMinusValue);
    payload.wtTolerancePlus = this.toFiniteNumberOrUndefined(this.wtTolerancePlusValue);
    payload.wtToleranceUom = this.wtToleranceUomValue;
    payload.lengthType = this.lengthTypeValue;
    payload.lengthMin = this.lengthMinValue;
    payload.lengthMax = this.lengthMaxValue;
    payload.lengthUom = this.lengthUomValue;
    payload.lengthNominal = this.nominalLengthValue;
    payload.multipleLength = this.multipleLengthValue;
    payload.uBent = this.uBentValue;

    // invoke api
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.calculateItemWeight(payload).subscribe(res => {
      if (res) {
        const weight = this.utils.checkDecimal(res.totalWeight);
        if (weight !== 'error') {
          this.totalWeightIsvalid = true;
          let _i: number = this.roundDigitsForItemForm.findIndex(x => x.fieldName!.toLowerCase() == 'totalweight');
          if (_i != -1) {
            if (this.items[this.selectedIndexItem].unitSystem == 'Metric')
              this.totalWeightValue = weight.toFixed(this.roundDigitsForItemForm[_i].metricDigits!);
            else
              this.totalWeightValue = weight.toFixed(this.roundDigitsForItemForm[_i].imperialDigits!);
          } else {
            this.totalWeightValue = weight.toFixed(2);
          }
        }
      }
      this.teiasoftLoader.stop();
    }));

  }

  weight_isValidQuantity(): boolean {
    this.quantityIsValid = true;
    this.totalWeightUomIsValid = true;

    let isValid = true;

    if (this.quantityValue == null || parseFloat(this.quantityValue.toString()) <= 0) {
      this.quantityIsValid = false;
      isValid = false;
    }

    if (!this.totalWeightUomValue || this.totalWeightUomValue.toString() == '') {
      this.totalWeightUomIsValid = false;
      isValid = false;
    }

    return isValid;
  }


  weight_isValidLength(): boolean {
    this.rawMaterialGradeIsRequired = false;
    this.rawMaterialGradeIsValid = true;
    this.smsIsValid = true;
    this.typeOfToleranceIsValid = true;
    this.tubeExecutionIsValid = true;
    this.wtToleranceMinusIsValid = true;
    this.wtTolerancePlusIsValid = true;
    this.wtToleranceUomIsValid = true;
    this.lengthTypeIsValid = true;
    this.lengthUomIsValid = true;

    let isValid = true;

    if (!this.npsIsValid || !this.checkWtOdId(false) || !this.tolerancesAreValid()) {
      isValid = false;
    }

    if (!this.rawMaterialGradeValue || this.rawMaterialGradeValue.toString() == '') {
      this.rawMaterialGradeIsRequired = true;
      this.rawMaterialGradeIsValid = false;
      isValid = false;
    }

    // if ((this.odValue == null || this.wtValue == null) && (!this.smsValue || this.smsValue.toString() == '')) {
    //   this.smsIsValid = false;
    //   isValid = false;
    // }

    if (this.wtValue && (!this.typeOfToleranceValue || this.typeOfToleranceValue.toString() == '')) {
      this.typeOfToleranceIsValid = false;
      isValid = false;
    }

    const hasTubeExecution = this.tubeExecutionValue != null && this.tubeExecutionValue.toString() != '';
    const requiresWtTolerances = this.wtValue && hasTubeExecution;

    if (requiresWtTolerances && (!this.isFinite(this.wtToleranceMinusValue) || this.wtToleranceMinusValue.toString() == '')) {
      this.wtToleranceMinusIsValid = false;
      isValid = false;
    }

    if (requiresWtTolerances && (!this.isFinite(this.wtTolerancePlusValue) || this.wtTolerancePlusValue.toString() == '')) {
      this.wtTolerancePlusIsValid = false;
      isValid = false;
    }

    if (requiresWtTolerances && (!this.wtToleranceUomValue || this.wtToleranceUomValue.toString() == '')) {
      this.wtToleranceUomIsValid = false;
      isValid = false;
    }

    if (!this.lengthTypeValue || this.lengthTypeValue.toString() == '') {
      this.lengthTypeIsValid = false;
      isValid = false;
    }

    if (!this.lengthUomValue || this.lengthUomValue.toString() == '') {
      this.lengthUomIsValid = false;
      isValid = false;
    }

    return isValid;
  }


  weight_isValidUnit(): boolean {
    return this.checkLength();
  }

  getQuantityUomTypeByUomCode(uomCode: string): string | undefined {
    if (this.unitSystemValue.toLowerCase() == 'metric')
      return this.itemParameterValues.quantityUoms?.metricUoms?.filter(u => u.uomCode === uomCode)[0].uomType;
    else
      return this.itemParameterValues.quantityUoms?.imperialUoms?.filter(u => u.uomCode === uomCode)[0].uomType;
  }

  checkWeightCanBeCalculated(): void {
    this.totalWeightCanBeCalculated = false;

    // Reset validation flags
    this.quantityUomIsValid = true;
    this.rawMaterialGradeIsValid = true;
    this.smsIsValid = true;
    this.typeOfToleranceIsValid = true;
    this.tubeExecutionIsValid = true;
    this.wtToleranceMinusIsValid = true;
    this.wtTolerancePlusIsValid = true;
    this.lengthTypeIsValid = true;
    this.lengthUomIsValid = true;

    if (!this.quantityUomValue || this.quantityUomValue.toString() == '') {
      this.quantityUomIsValid = false;
      return; // Stop further validation if UOM is missing
    }

    const quantityValueUomType = this.getQuantityUomTypeByUomCode(this.quantityUomValue);

    let quantityValid = this.weight_isValidQuantity();
    let lengthValid = true;
    let unitValid = true;

    switch (quantityValueUomType?.toLowerCase()) {
      case 'weight':
        break; // Only quantity validation is needed for weight
      case 'length':
        lengthValid = this.weight_isValidLength();
        break;
      case 'units':
        lengthValid = this.weight_isValidLength();
        unitValid = this.weight_isValidUnit();
        break;
    }

    // Combine all validation results
    this.totalWeightCanBeCalculated = quantityValid && lengthValid && unitValid;
  }


  isValidFormat(): boolean {
    let _ret: boolean = true;
    const regex = /^[0-9.,]+$/;

    // GBR MQBF-21 04/03/2024 Check numeric OD, ID, WT e quantity
    let _quantity: any = this.utils.checkDecimal(this.quantityValue);
    if (_quantity == 'error') {
      this.quantityIsValid = false;
      _ret = false;
    } else {
      this.quantityValue = _quantity;
      this.items[this.selectedIndexItem].quantity = this.quantityValue;
    }

    let _od: any = this.utils.checkDecimal(this.odValue);
    if (_od == 'error') {
      this.odIsValid = false;
      _ret = false;
    } else {
      this.odValue = _od;
      this.items[this.selectedIndexItem].od = this.odValue;
    }

    let _id: any = this.utils.checkDecimal(this.idValue);
    if (_id == 'error') {
      this.idIsValid = false;
      _ret = false;
    } else {
      this.idValue = _id;
      this.items[this.selectedIndexItem].id = this.idValue;
    }

    let _wt: any = this.utils.checkDecimal(this.wtValue);
    if (_wt == 'error') {
      this.wtIsValid = false;
      _ret = false;
    } else {
      this.wtValue = _wt;
      this.items[this.selectedIndexItem].wt = this.wtValue;
    }


    let _tMinus: any = this.utils.checkDecimal(this.wtToleranceMinusValue);
    if (_tMinus == 'error') {
      this.wtToleranceMinusIsValid = false;
      _ret = false;
    } else {
      this.wtToleranceMinusValue = _tMinus;
      this.items[this.selectedIndexItem].wtToleranceMinus = this.wtToleranceMinusValue;
    }

    let _tPlus: any = this.utils.checkDecimal(this.wtTolerancePlusValue);
    if (_tPlus == 'error') {
      this.wtTolerancePlusIsValid = false;
      _ret = false;
    } else {
      this.wtTolerancePlusValue = _tPlus;
      this.items[this.selectedIndexItem].wtTolerancePlus = this.wtTolerancePlusValue;
    }

    let _lMin: any = this.utils.checkDecimal(this.lengthMinValue);
    if (_lMin == 'error') {
      this.lengthMinIsValid = false;
      _ret = false;
    } else {
      this.lengthMinValue = _lMin;
      this.items[this.selectedIndexItem].lengthMin = this.lengthMinValue;
    }

    let _lMax: any = this.utils.checkDecimal(this.lengthMaxValue);
    if (_lMax == 'error') {
      this.lengthMaxIsValid = false;
      _ret = false;
    } else {
      this.lengthMaxValue = _lMax;
      this.items[this.selectedIndexItem].lengthMax = this.lengthMaxValue;
    }

    return _ret;
  }

  tolerancesAreValid(): boolean {
    let isValid = true;

    // Reset all validity indicators before validation
    this.wtToleranceUomIsValid = true;
    this.odToleranceUomIsValid = true;
    this.idToleranceUomIsValid = true;

    const hasWtMinus = this.hasToleranceValue(this.wtToleranceMinusValue);
    const hasWtPlus = this.hasToleranceValue(this.wtTolerancePlusValue);
    const hasWtUom = this.hasToleranceValue(this.wtToleranceUomValue);
    const hasWtTolerance = hasWtMinus && hasWtPlus;
    const hasOdMinus = this.hasToleranceValue(this.odToleranceMinusValue);
    const hasOdPlus = this.hasToleranceValue(this.odTolerancePlusValue);
    const hasOdTolerance = hasOdMinus && hasOdPlus;
    const hasIdMinus = this.hasToleranceValue(this.idToleranceMinusValue);
    const hasIdPlus = this.hasToleranceValue(this.idTolerancePlusValue);
    const hasIdTolerance = hasIdMinus && hasIdPlus;
    const hasAnyOdTolerance = hasOdMinus || hasOdPlus || this.hasToleranceValue(this.odToleranceUomValue);
    const hasAnyIdTolerance = hasIdMinus || hasIdPlus || this.hasToleranceValue(this.idToleranceUomValue);
    const hasAnyWtTolerance = hasWtMinus || hasWtPlus || hasWtUom;
    const hasTubeExecution = !!this.items[this.selectedIndexItem].tubeExecution;
    const requiresWtTolerance = this.wtValue && hasTubeExecution;

    // Rule 1: If WT tolerances are required or partially filled, both tolerances and UOM are mandatory
    if (requiresWtTolerance || hasAnyWtTolerance) {
      if (!this.isFinite(this.wtToleranceMinusValue)) {
        isValid = false;
        this.wtToleranceMinusIsValid = false;
      }
      if (!this.isFinite(this.wtTolerancePlusValue)) {
        isValid = false;
        this.wtTolerancePlusIsValid = false;
      }
      if (!this.wtToleranceUomValue) {
        isValid = false;
        this.wtToleranceUomIsValid = false;
      }
    }

    // Rule 2: If OD tolerances have partial values, the counterpart and UOM must also be provided
    if (hasAnyOdTolerance) {
      if (!hasOdTolerance || !this.odToleranceUomValue) {
        this.odToleranceUomIsValid = this.odToleranceUomValue!!;
        this.odTolerancePlusIsValid = this.isFinite(this.odTolerancePlusValue);
        this.odToleranceMinusIsValid = this.isFinite(this.odToleranceMinusValue);
        isValid = this.odToleranceUomIsValid && this.odTolerancePlusIsValid && this.odToleranceMinusIsValid;
      }
    }

    // Rule 3: If ID tolerances have partial values, the counterpart and UOM must also be provided
    if (hasAnyIdTolerance) {
      if (!hasIdTolerance || !this.idToleranceUomValue) {
        this.idToleranceUomIsValid = this.idToleranceUomValue!!;
        this.idTolerancePlusIsValid = this.isFinite(this.idTolerancePlusValue);
        this.idToleranceMinusIsValid = this.isFinite(this.idToleranceMinusValue);
        isValid = this.idToleranceUomIsValid && this.idTolerancePlusIsValid && this.idToleranceMinusIsValid;
      }
    }

    if (hasOdTolerance && Number(this.odToleranceMinusValue) > Number(this.odTolerancePlusValue)) {
      isValid = false;
      this.odToleranceMinusIsValid = false;
      this.odTolerancePlusIsValid = false;
    }

    if (hasIdTolerance && Number(this.idToleranceMinusValue) > Number(this.idTolerancePlusValue)) {
      isValid = false;
      this.idToleranceMinusIsValid = false;
      this.idTolerancePlusIsValid = false;
    }

    if (hasWtTolerance && Number(this.wtToleranceMinusValue) > Number(this.wtTolerancePlusValue)) {
      isValid = false;
      this.wtToleranceMinusIsValid = false;
      this.wtTolerancePlusIsValid = false;
    }

    // Rule 4: Only two out of the three tolerance types (WT, OD, ID) should have values
    const toleranceCount = [hasWtTolerance, hasOdTolerance, hasIdTolerance].filter(Boolean).length;
    if (toleranceCount > 2) {
      isValid = false;
      this.teiasoftToaster.show("error", this.translate.instant('errors.tolerancesNotValidOnlyTwo'));
    }

    // Rule 5: if execution tube is not custom , wt uom should be expressed as percentage
    const isCustom = this.items[this.selectedIndexItem].tubeExecution && this.items[this.selectedIndexItem].tubeExecution!.isCustom;
    if (this.wtValue && hasTubeExecution && !isCustom && this.wtToleranceUomValue != '%') {
      isValid = false;
      this.wtToleranceUomIsValid = false;
    }

    return isValid;
  }

  areExtraDeliveryPropertiesValid(): boolean {
    return true;
    // deprecated check as requested by customer 2025-03-27
    if (this.millValue == 'CV' && this.htValue != false) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.htNotValid'));
      this.htIsValid = false;
      return false; // HT true is not valid for mill CV
    }
    else {
      this.htIsValid = true;
      return true; // otherwise always valid
    }
  }

  checkLength(): boolean {

    // Case when lengthType is "FL"
    if (this.lengthTypeValue === "FL") {
      // If multipleLengthValue is true, check that min is less than max
      if (this.multipleLengthValue && parseFloat(this.lengthMaxValue) <= parseFloat(this.lengthMinValue)) {
        this.teiasoftToaster.show("error", this.translate.instant("errors.lengthMinMax"));
        return false;
      }

      if (!this.nominalLengthValue) {
        this.nominalLengthIsValid = false;
        return false;
      }

      // If multipleLengthValue is false, skip the min-max check
    } else {
      // For non-FL length types, always check that min is less than max
      if (parseFloat(this.lengthMaxValue) <= parseFloat(this.lengthMinValue)) {
        this.lengthMaxIsValid = false;
        this.lengthMinIsValid = false;
        this.teiasoftToaster.show("error", this.translate.instant("errors.lengthMinMax"));
        return false;
      }

    }

    const qtyUomType = this.getQuantityUomTypeByUomCode(this.quantityUomValue);


    if (qtyUomType?.toLowerCase() === 'units' && this.lengthTypeValue === "RL") {
      this.teiasoftToaster.show("error", this.translate.instant("errors.lengthShouldBeFixed"));
      return false;
    }

    if (this.uBentValue!! && (this.multipleLengthValue!! || this.lengthTypeValue !== "FL")) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.uBentShouldBeFixedLength"));
      return false;
    }

    if (this.uBentValue!! && this.ctsValue) {
      this.teiasoftToaster.show("error", this.translate.instant("errors.uBentCtsCheck"));
      return false;
    }

    if (this.ctsValue) {
      let sms = this.smsOptionList.find(opt => opt.value == this.smsValue)?.text;
      if (this.testConditionValue != 'TC1') {
        // TC1 is always allowed, TC2 only if CV and instrumentation
        if (this.millValue != 'CV' || sms != 'INSTRUMENTATION') {
          this.teiasoftToaster.show("error", this.translate.instant("errors.testConditionCtsCheck"));
          return false;
        }
      }
    }


    // this.lengthMaxIsValid = true;
    // this.lengthMinIsValid = true;
    return true;
  }

  /**
   * PREPARE ITEM TO SAVE
   * @param callBackend 
   */
  prepareItemsToSave(callBackend: boolean) {
    let _items: ItemToUpdate[] = new Array();
    let _unitSystem: string = this.enquiryToEdit.header!.unitSystem!;
    for (var x = 0; x < this.items.length; x++) {
      let _item: ItemToUpdate = new ItemToUpdate();
      _item.alloySurcharge = true;
      _item.energySurcharge = this.items[x].energySurcharge;
      _item.uBent = this.items[x].uBent;
      _item.testCondition = this.items[x].testCondition;

      _item.applicableNorms = this.items[x].applicableNorms ? this.items[x].applicableNorms : null;
      _item.customerDeliveryDate = this.items[x].customerDeliveryDate ? this.items[x].customerDeliveryDate : null;
      _item.endsCondition = this.items[x].endsCondition;
      _item.ht = this.items[x].ht;
      _item.htAdditional = this.items[x].htAdditional;
      _item.hydroTest = this.items[x].hydroTest;
      _item.id = !this.items[x].id ? null : parseFloat(parseFloat(this.items[x].id!.toString()).toFixed(this.getRoundDigits('od')));
      _item.idUom = _item.id != null ? this.items[x].idUom : null;
      _item.idToleranceMinus = this.toRoundedFiniteNumberOrUndefined(this.items[x].idToleranceMinus, this.getRoundDigits('toleranceMinus'));
      _item.idTolerancePlus = this.toRoundedFiniteNumberOrUndefined(this.items[x].idTolerancePlus, this.getRoundDigits('tolerancePlus'));
      _item.idToleranceUom = this.areToleranceMeasuresFinite(_item.idToleranceMinus, _item.idTolerancePlus) ? this.items[x].idToleranceUom : undefined;
      _item.inspectionType3dot2 = this.items[x].inspectionType3Dot2;
      _item.itemNo = this.items[x].itemNo ? this.items[x].itemNo : null;
      _item.customerItemNo = this.utils.normalizeCustomerItemNo(this.items[x].customerItemNo);
      _item.remark = this.items[x].remark || null;
      _item.lengthNominal = this.items[x].lengthNominal && this.items[x].lengthType == 'FL' ? parseFloat(parseFloat(this.items[x].lengthNominal!.toString()).toFixed(this.getRoundDigits('lengthMin'))) : null;
      _item.multipleLength = this.items[x].multipleLength!!;
      _item.lengthMax = this.items[x].lengthMax ? parseFloat(parseFloat(this.items[x].lengthMax!.toString()).toFixed(this.getRoundDigits('lengthMin'))) : undefined;
      _item.lengthMin = this.items[x].lengthMin ? parseFloat(parseFloat(this.items[x].lengthMin!.toString()).toFixed(this.getRoundDigits('lengthMin'))) : undefined;
      _item.lengthType = this.items[x].lengthType;
      _item.lengthUom = this.items[x].lengthUom;
      _item.marketFamilyId = this.items[x].marketFamily?.marketFamilyId;
      _item.marketingGradeId = null;
      _item.millId = this.items[x].mill?.millId;
      _item.multipleCutting = this.items[x].multipleCutting;
      _item.normGradesId = new Array();
      for (var c = 0; c < this.items[x].normGrades!.length; c++) {
        _item.normGradesId.push(this.items[x].normGrades![c].normGradeId!);
      }
      _item.gradeCustomerAnalysisLimitation = new ItemLimitation();
      _item.gradeCustomerAnalysisLimitation.isCustom = this.items[x].gradeCustomerAnalysisLimitation!.isCustom;
      _item.gradeCustomerAnalysisLimitation.limitation = this.items[x].gradeCustomerAnalysisLimitation!.limitation;
      _item.gradeCustomerOtherLimitation = new ItemLimitation();
      _item.gradeCustomerOtherLimitation.isCustom = this.items[x].gradeCustomerOtherLimitation!.isCustom;
      _item.gradeCustomerOtherLimitation.limitation = this.items[x].gradeCustomerOtherLimitation!.limitation;
      _item.npsScheduleId = this.items[x].npsSchedule ? this.items[x].npsSchedule?.npsScheduleId : null;
      _item.od = !this.items[x].od ? null : parseFloat(parseFloat(this.items[x].od!.toString()).toFixed(this.getRoundDigits('od')));
      _item.odUom = _item.od != null ? this.items[x].odUom : null;
      _item.odToleranceMinus = this.toRoundedFiniteNumberOrUndefined(this.items[x].odToleranceMinus, this.getRoundDigits('toleranceMinus'));
      _item.odTolerancePlus = this.toRoundedFiniteNumberOrUndefined(this.items[x].odTolerancePlus, this.getRoundDigits('tolerancePlus'));
      _item.odToleranceUom = this.areToleranceMeasuresFinite(_item.odToleranceMinus, _item.odTolerancePlus) ? this.items[x].odToleranceUom : undefined;

      _item.optionDate = this.items[x].optionDate!;
      _item.quantity = parseFloat(parseFloat(this.items[x].quantity!.toString()).toFixed(this.getRoundDigits('quantity')));
      _item.quantityUom = this.items[x].quantityUom;

      _item.rawMaterialGradeId = this.items[x].rawMaterialGrade ? this.items[x].rawMaterialGrade!.rawMaterialGradeId : null;

      _item.smsId = this.items[x].sms?.smsId;
      _item.surfaceTypeId = this.items[x].surfaceType!.surfaceTypeId!;
      _item.sqlId = this.items[x].sql?.sqlId ?? undefined;
      _item.offerSchemeCode = this.items[x].offerScheme?.offerSchemeCode ?? null;
      // _item.totalWeight = parseFloat(this.items[x].totalWeight!.toString()); // the totalWeight will be calculated on the backend
      _item.totalWeightUom = this.items[x].totalWeightUom;
      _item.typeOfTolerance = this.items[x].typeOfTolerance;
      _item.tubeExecutionId = this.items[x].tubeExecution ? this.items[x].tubeExecution!.tubeExecutionId : undefined;
      _item.wtToleranceMinus = this.toRoundedFiniteNumberOrUndefined(this.items[x].wtToleranceMinus, this.getRoundDigits('toleranceMinus'));
      _item.wtTolerancePlus = this.toRoundedFiniteNumberOrUndefined(this.items[x].wtTolerancePlus, this.getRoundDigits('tolerancePlus'));
      _item.wtToleranceUom = this.areToleranceMeasuresFinite(_item.wtToleranceMinus, _item.wtTolerancePlus) ? this.items[x].wtToleranceUom : undefined;
      _item.unitSystem = this.items[x].unitSystem;
      _item.ut = this.items[x].ut!;
      _item.wt = !this.items[x].wt ? null : parseFloat(parseFloat(this.items[x].wt!.toString()).toFixed(this.getRoundDigits('wt')));
      _item.wtUom = _item.wt != null ? this.items[x].wtUom : null;
      _item.sourceItemNo = this.items[x].sourceItemNo;
      _item.attachments = new Array();
      if (this.action == 'create' || this.action == 'duplicate') {
        _item.attachments = this.items[x].attachments ? this.items[x].attachments : [];
      }

      // delivery extra fields
      _item.cts = this.items[x].cts;
      _item.dyePenetrant = this.items[x].dyePenetrant;
      _item.dyePenetrant100P = this.items[x].dyePenetrant100P;
      _item.penalty = this.items[x].penalty;
      _item.colorCoding = this.items[x].colorCoding;
      _item.specialOperations = this.items[x].specialOperations;
      _item.specialTests = this.items[x].specialTests;
      _item.grindingHoning = this.items[x].grindingHoning;
      _item.ec = this.items[x].ec;
      _item.notStdPackaging = this.items[x].notStdPackaging;

      // materialCode
      _item.materialCode = this.items[x].material?.materialCode ?? null;


      _items.push(_item);
    }
    if (callBackend)
      this.updateEnquiryItems(_items);

  }

  /**
   * UPDATE ENQUIRY ITEMS
   * @param items 
   */
  updateEnquiryItems(items: ItemToUpdate[]) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.updateEnquiryItems(items, this.enquiryNo).subscribe(res => {
      this.updateItemAttachment();
    }));
  }

  /**
   * UPLOAD ITEM ATTACHMENT (FOR EDIT ITEM)
   */
  updateItemAttachment() {
    if (this.attachmentsToUpdate && this.attachmentsToUpdate.length > 0) {
      this.subscriptions.add(this.backendService.uploadItemAttachment(this.attachmentsToUpdate!, this.items[this.selectedIndexItem].itemNo!, this.enquiryNo!).subscribe(res => {
        this.deleteItemAttachment();
      }));
    } else {
      this.deleteItemAttachment();
    }
  }

  /**
   * DELETE ITEM ATTACHMENTS (FOR EDIT)
   */
  deleteItemAttachment() {
    if (this.listAttachToDelete && this.listAttachToDelete.length > 0) {
      let _ids: number[] = new Array();
      for (var x = 0; x < this.listAttachToDelete.length; x++) {
        _ids.push(this.listAttachToDelete[x].fileId!);
      }
      this.subscriptions.add(this.backendService.deleteItemAttachment(_ids, this.items[this.selectedIndexItem].itemNo!, this.enquiryNo!).subscribe(res => {
        this.items = [];
        this.attachmentsToUpdate = [];
        this.reloadEnquiry.emit(this.enquiryNo);
        this.teiasoftLoader.stop();
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      }));
    } else {
      this.items = [];
      this.attachmentsToUpdate = [];
      this.reloadEnquiry.emit(this.enquiryNo);
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
    }

  }

  /**
   * MILL RULE
   * @returns 
   */
  odMillRuleActive(): boolean {
    // Per duplicate la regola non si attiva
    if (this.action == 'duplicate') return false;
    // GBR 13/03/2024 - Se all'apertura della form ho un valore allora la regola non si attiva
    // if (this.enquiryToEdit.items![this.selectedIndexItem] && this.enquiryToEdit.items![this.selectedIndexItem].mill != null && this.enquiryToEdit.items![this.selectedIndexItem].mill != undefined) return false;
    // END
    if ((this.salesOffice == 'DUS' || this.salesOffice == 'EU1' || this.marketingRoute == 'Cold' || this.marketingRoute == 'Hot') && this.millChangedByUser == false)
      return true;
    else
      return false;
  }

  applyOdMillRule() {
    if (this.odMillRuleActive()) {
      let _odValue = this.getOdInMm();
      let _data: Mill = new Mill();
      if (this.salesOffice == 'DUS' || this.salesOffice == 'EU1') {
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'HO')!;
      } else {
        if (this.marketingRoute == 'Hot')
          _data = this.itemParameterValues.mills!.find(x => x.shortName == 'MB')!;

        if (this.marketingRoute == 'Cold' && _odValue !== null && _odValue >= 6 && _odValue <= 88.99)
          _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

        if (this.marketingRoute == 'Cold' && _odValue !== null && _odValue > 88.99)
          _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!;

        /* if (this.marketingRoute == 'ColdFinished' && (parseFloat(this.odValue) >= 6 && parseFloat(this.odValue) <= 88.99) && this.odUomValue == 'mm')
          _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

        if (this.marketingRoute == 'ColdFinished' && (parseFloat(this.odValue) > 88.99) && this.odUomValue == 'mm')
          _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!; */
      }


      if (_data.millId) {
        this.millValue = _data.shortName;
        this.millIsValid = true;
        this.items[this.selectedIndexItem].mill = _data;
      } else {
        this.millValue = null;
        this.items[this.selectedIndexItem].mill = undefined;
        this.millIsValid = false;
      }
    }
  }

  /**
   * CHE ICO TYPE FOR ATTACHMENT
   * @param attach 
   * @returns 
   */
  getFileIcoType(attach: ItemAttachment): string {
    let _ret: string = "fas fa-file";

    if (attach.fileName!.endsWith('.txt'))
      return 'fas fa-file';

    if (attach.fileName!.endsWith('.doc') || attach.fileName!.endsWith('.docx'))
      return 'fas fa-file-word';

    if (attach.fileName!.endsWith('.xls') || attach.fileName!.endsWith('.xlsx'))
      return 'fas fa-file-excel';

    if (attach.fileName!.endsWith('.ppt') || attach.fileName!.endsWith('.pptx'))
      return 'fas fa-file-powerpoint';

    if (attach.fileName!.endsWith('.pdf'))
      return 'fas fa-file-pdf';

    if (attach.fileName!.endsWith('.jpg') || attach.fileName!.endsWith('.jpeg') || attach.fileName!.endsWith('.png') || attach.fileName!.endsWith('.svg') || attach.fileName!.endsWith('.gif')
      || attach.fileName!.endsWith('.tiff'))
      return 'fas fa-file-image';

    if (attach.fileName!.endsWith('.zip') || attach.fileName!.endsWith('.7z'))
      return 'fas fa-file-archive';

    if (attach.fileName!.endsWith('.mp4') || attach.fileName!.endsWith('.wav') || attach.fileName!.endsWith('.mov'))
      return 'fas fa-file-video';

    if (attach.fileName!.endsWith('.mp3') || attach.fileName!.endsWith('.wav'))
      return 'fas fa-file-audio';

    return _ret;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const relatedTarget = event.relatedTarget as HTMLElement;
    const dropZone = event.currentTarget as HTMLElement;

    // Only unset isDragging if truly leaving the drop zone
    if (!relatedTarget || !dropZone.contains(relatedTarget)) {
      this.isDragging = false;
    }
  }

  onDropFile(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      Array.from(files).forEach((file) => {
        this.processFile(file);
      });
    }
  }

  /**
   * ATTACHMENT FILE SELECT
   * @param evt 
   * @returns 
   */

  onFileSelectedAttach(evt: any): void {
    if (!evt.target.files || evt.target.files.length === 0) return;

    Array.from(evt.target.files).forEach((file) => {
      this.processFile(file as File);
    });

    evt.target.value = null; // Clear the input after processing
  }

  processFile(file: File): void {
    this.teiasoftLoader.start();

    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
    const MAX_OVERALL_REQUEST_SIZE = 100 * 1024 * 1024; // 100 MB in bytes
    const fileName = file.name;

    // Check if file exceeds the maximum file size
    if (file.size > MAX_FILE_SIZE) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("error", this.translate.instant("errors.maxFileUploadSizeExceeded"));
      return;
    }

    // Calculate the size of current attachments and check overall size constraint
    const actualAttachmentsToUpdateSize = this.attachmentsToUpdate.reduce((prev, curr) =>
      prev + (curr.fileContent ? this.fileSizeInBytes(curr.fileContent) : 0), 0);

    const allItemsToUpdateSize = this.items.map(x => x.attachments).flat().reduce((prev, curr: any) => {
      return (prev) + (curr && curr.fileContent ? this.fileSizeInBytes(curr.fileContent) : 0);
    }, 0);

    if ((allItemsToUpdateSize + actualAttachmentsToUpdateSize + file.size) > MAX_OVERALL_REQUEST_SIZE) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("error", this.translate.instant("errors.maxOverallUploadSizeExceeded"));
      return;
    }

    if (!this.items[this.selectedIndexItem].attachments) {
      this.items[this.selectedIndexItem].attachments = [];
    }
    if (!this.attachmentsToUpdate) {
      this.attachmentsToUpdate = [];
    }

    const isDuplicate = this.action === 'create'
      ? this.items[this.selectedIndexItem].attachments!.some(f => f.fileName === fileName)
      : this.attachmentsToUpdate.some(x => x.fileName === fileName);

    if (isDuplicate) {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("info", this.translate.instant("info.fileAldreadyLoaded"));
      return;
    }

    // Read file as Base64
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (evt: any) => {
      const base64 = evt.target.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      const attachment: AttachmentToUpdate = {
        fileCreationDate: new Date().getTime(),
        fileName,
        fileContent: base64
      };

      if (!this.items[this.selectedIndexItem].itemNo) {
        this.items[this.selectedIndexItem].attachments!.push(attachment);
      } else {
        this.attachmentsToUpdate.push(attachment);
      }

      this.teiasoftLoader.stop();
    };
  }


  /**
   * 
   * @param base64 
   * @returns 
   */
  fileSizeInBytes(base64: string): number {
    const base64String = base64.replaceAll('=', '');
    const bytes = base64String.length * (3 / 4);

    return bytes;
  }

  prepareUomsList(skipSetDefault = false) {
    this.items[this.selectedIndexItem].unitSystem = this.unitSystemValue;
    this.unitSystemIsValid = true;
    this.quantityUomOptionList = new Array();
    this.quantityUomOptionList = this.getUoms('quantityUoms');
    this.odUomOptionList = new Array();
    this.odUomOptionList = this.getUoms('odUoms');
    this.wtUomOptionList = new Array();
    this.wtUomOptionList = this.getUoms('wtUoms');
    this.idUomOptionList = new Array();
    this.idUomOptionList = this.getUoms('idUoms');
    this.totalWeightUomOptionList = new Array();
    this.totalWeightUomOptionList = this.getUoms('totalWeightUoms');
    this.lengthUomOptionList = new Array();
    this.lengthUomOptionList = this.getUoms('lengthUoms');
    this.toleranceUomOptionList = new Array();
    this.toleranceUomOptionList = this.getUoms('toleranceUoms');
    if (skipSetDefault)
      return;
    if (!this.isInitialLoad || (this.action == 'create' && !this.fillFromEnquiry))
      this.setUomDefault('all');
  }

  getMeasureLabel(measure: string) {
    let base = this.translate.instant('grid.' + measure);
    let uom = this.getUoms(`${measure.replace('Max', '').replace('Min', '').toLowerCase()}Uoms`).find(u => u.isDefault);
    return `${base} (${uom?.text})`;
  }

  getDefaultUom(measure: 'od' | 'id' | 'wt') {
    return this.getUoms(`${measure}Uoms`).find(u => u.isDefault);
  }

  hasToleranceValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  hasAnyToleranceValue(...values: any[]): boolean {
    return values.some(value => this.hasToleranceValue(value));
  }

  private hasDuplicateCustomerItemNo(): boolean {
    const duplicates = this.utils.findDuplicateCustomerItemNoNumbers(this.items.map(i => i.customerItemNo));
    return duplicates.length > 0;
  }

  private validateCustomerItemNoConstraints(): boolean {
    const hasInvalidFormat = this.items
      .map(i => this.utils.normalizeCustomerItemNo(i.customerItemNo))
      .some(value => !this.utils.isCustomerItemNoNumeric(value));

    if (hasInvalidFormat) {
      this.customerItemNoIsValid = this.utils.isCustomerItemNoNumeric(this.customerItemNoValue);
      this.teiasoftToaster.show("error", this.translate.instant('errors.formatNotValid'));
      return false;
    }

    if (this.hasDuplicateCustomerItemNo()) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.customerItemNoDuplicate'));
      return false;
    }

    return true;
  }

  /* EVENTS */
  onAddAttachmentClick() {
    $("#fileUploadAttach").click();
  }

  onAddItemClick() {
    // MQF-113: - Form di Edit Enquiry. 
    // 1) Clicco su pulsante Add Item(s): la form di Add Item deve prefillare i campi con gli stessi valori della enquiry (ovviamente solo per quei campi 
    //    che sono presenti anche a livello di enquiy)
    // 2) Se poi dopo aver compilato tutti i campi dell’item, clicco su “Add Item” per aggiungere un’altro item, al seguito del click 
    //    la form di Add Item deve essere prefillata con i valori uguali all’item appena compilato

    let _isFormValid: boolean = this.isFormValid(true);
    if (!_isFormValid) {
      const hasCustomerItemNoFormatError = !!this.utils.normalizeCustomerItemNo(this.customerItemNoValue) && !this.customerItemNoIsValid;
      this.teiasoftToaster.show("error", this.translate.instant(hasCustomerItemNoFormatError ? 'errors.formatNotValid' : 'errors.fieldMandatory'));
      return;
    }

    if (!this.validateCustomerItemNoConstraints()) {
      return;
    }

    let _isValidGreaterThanZero: boolean = this.isGraterZeroValuesValid();
    if (!_isValidGreaterThanZero) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.greaterZero'));
      return;
    }

    let _isValidFormat: boolean = this.isValidFormat();
    if (!_isValidFormat) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.formatNotValid'));
      return;
    }

    let _tolerancesAreValid: boolean = this.tolerancesAreValid();
    if (!_tolerancesAreValid) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.tolerancesNotValid'));
      return;
    }

    if (this.checkWtOdId(false) && this.checkLength()) {
      // se sto creando e enquiryNo == null allora metto gli attachment dentro l'item corrente
      /*       if (this.action == 'create' && this.items[this.selectedIndexItem].itemNo == null){
              this.items[this.selectedIndexItem].attachments = this.attachmentsToUpdate.filter(x => x.itemNo == null);
              this.attachmentsToUpdate = new Array();
            } */

      /*       if (!this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation){
              this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
              this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = this.analysisLimitationFreeInput;
              this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = this.analysisLimitationValue;
            }
      
            if (!this.items[this.selectedIndexItem].gradeCustomerOtherLimitation){
              this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
              this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = this.otherLimitationFreeInput;
              this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = this.otherLimitationValue;
            } */


      let _new: EnquiryHeaderItem = new EnquiryHeaderItem();
      // caso 2) copio questo item del nuovo
      _new = Object.assign(_new, this.items[this.selectedIndexItem]);
      _new.itemNo = null;
      _new.attachments = new Array();
      this.items.push(_new);
      this.selectedIndexItem = this.items.length - 1;
      _new.customerItemNo = this.calculateNextCustomerItemNo(this.items);
      this.action = 'create';
      this.fillForm();
      this.invalidateWeight();
    }
  }

  calculateNextCustomerItemNo(items: EnquiryHeaderItem[]): string {
    if (items.length === 1) {
      return '001';  // First item in the list
    }

    let allNumeric = true;
    let maxCustomerItemNo = 0;
    let maxCustomerItemNoRaw = '';

    for (const item of items) {
      const parsedCustomerItemNo = this.utils.toCustomerItemNoNumber(item.customerItemNo);
      if (parsedCustomerItemNo === null) {
        allNumeric = false;
      } else {
        if (parsedCustomerItemNo > maxCustomerItemNo) {
          maxCustomerItemNo = parsedCustomerItemNo;
          maxCustomerItemNoRaw = this.utils.normalizeCustomerItemNo(item.customerItemNo);
        }
      }
    }

    if (allNumeric) {
      // Determine next number based on previous format
      const nextCustomerItemNo = (maxCustomerItemNo + 1).toString();
      const paddingLength = maxCustomerItemNoRaw.length;

      // Add padding only if it was present
      return nextCustomerItemNo.padStart(paddingLength, '0');
    } else {
      // Fallback to itemNo + 1
      const nextItemNo = parseInt(this.items[this.items.length - 1].itemNo!, 10) + 1;
      if (isNaN(nextItemNo)) {
        return '';
      }
      return nextItemNo.toString();
    }
  }

  onSaveItemsClick() {
    // MQF-367 Per default setto a valid la RawMaterialGrade
    //if (this.normGradeIsValid && (this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom == true || this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom == true)){
    if (this.rawMaterialGradeDisabled == true) {
      this.rawMaterialGradeIsValid = true;
      this.rawMaterialGradeIsRequired = false;
    }

    //****************************************************** */

    let _isFormValid: boolean = this.isFormValid(true);
    if (!_isFormValid) {
      const hasCustomerItemNoFormatError = !!this.utils.normalizeCustomerItemNo(this.customerItemNoValue) && !this.customerItemNoIsValid;
      this.teiasoftToaster.show("error", this.translate.instant(hasCustomerItemNoFormatError ? 'errors.formatNotValid' : 'errors.fieldMandatory'));
    }

    if (_isFormValid && !this.validateCustomerItemNoConstraints()) {
      return;
    }

    let _isValidGreaterThanZero: boolean = this.isGraterZeroValuesValid();
    if (!_isValidGreaterThanZero) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.greaterZero'));
    }

    let _isValidFormat: boolean = this.isValidFormat();
    if (!_isValidFormat) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.formatNotValid'));
    }

    let _tolerancesAreValid: boolean = this.tolerancesAreValid();
    if (!_tolerancesAreValid) {
      this.teiasoftToaster.show("error", this.translate.instant('errors.tolerancesNotValid'));
    }

    let _extraDeliveryPropsAreValid: boolean = this.areExtraDeliveryPropertiesValid();

    if (this.checkWtOdId(true) && this.checkLength()) {
      if (this.action == 'create' && (this.items[this.selectedIndexItem].itemNo == null || this.items[this.selectedIndexItem].itemNo == undefined)) {
        // QUESTO CHECK SERVE PER VALORIZZARE LA NORMGRADE IN CASO DI ARRIVO DA FILL FROM ENQUIRY
        if (!this.items[this.selectedIndexItem].normGrades) {
          this.items[this.selectedIndexItem].normGrades = new Array();
          this.items[this.selectedIndexItem].normGrades = this.enquiryToEdit.header!.normGrades!;
          this.items[this.selectedIndexItem].totalWeight = this.enquiryToEdit.header!.totalWeight!;
        }
      }

      if (_tolerancesAreValid && _extraDeliveryPropsAreValid && _isValidFormat && _isValidGreaterThanZero && _isFormValid)
        this.prepareItemsToSave(true);
    }
  }

  onCloseModalClick() {
    // MQF-421: if discard multiple items ask for confirm
    if (this.items.filter(i => !i.itemNo).length > 1) {
      this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.discardItem"), this.translate.instant("enquiryBook.confirmDiscardItem", { count: this.items.filter(i => !i.itemNo).length }), this.items.filter(i => !i.itemNo).length, 'confirmDiscardItemEdit');
      return;
    }
    this.closeModalItem.emit(this.action);
  }

  onOpenAttach(attach: ItemAttachment) {
    let _isPreview: boolean = true;

    if (attach.fileName!.endsWith('.txt'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.doc') || attach.fileName!.endsWith('.docx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.xls') || attach.fileName!.endsWith('.xlsx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.ppt') || attach.fileName!.endsWith('.pptx'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.pdf'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.jpg') || attach.fileName!.endsWith('.jpeg') || attach.fileName!.endsWith('.png') || attach.fileName!.endsWith('.svg') || attach.fileName!.endsWith('.gif')
      || attach.fileName!.endsWith('.tiff'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.zip') || attach.fileName!.endsWith('.7z'))
      _isPreview = false;

    if (attach.fileName!.endsWith('.mp4') || attach.fileName!.endsWith('.mov'))
      _isPreview = true;

    if (attach.fileName!.endsWith('.mp3') || attach.fileName!.endsWith('.wav'))
      _isPreview = true;

    ///////// TEMOP VERIFICARE CON LUCA
    window.open(attach.presignedUrl, '_blank');
    /* if (!_isPreview){
      window.open(attach.presignedUrl,'_blank');
    } else {        
      this.selectedAttach = new ItemAttachment();
      this.selectedAttach = attach;
      this.showSelectAttach = true;
    } */
  }

  onDeleteAttachClick(attach: ItemAttachment) {
    // Verifico se è un file appena inserito MQF-151
    if (!attach.attachmentsId) {
      let _temp: AttachmentToUpdate[] = new Array();
      _temp = JSON.parse(JSON.stringify(this.items[this.selectedIndexItem].attachments!));
      this.items[this.selectedIndexItem].attachments = _temp.filter((k: AttachmentToUpdate) => k["fileName"] != attach["fileName"]);
    } else {
      if (!this.listAttachToDelete) this.listAttachToDelete = new Array();
      let _attachToDelete: ItemAttachmentToDelete = new ItemAttachmentToDelete();
      _attachToDelete.enquiryNo = this.enquiryNo;
      _attachToDelete.fileId = attach.attachmentsId!;
      _attachToDelete.itemNo = this.items[this.selectedIndexItem].itemNo!;
      this.listAttachToDelete.push(_attachToDelete);
    }

  }

  onDeleteAttachToUpdateClick(attach: AttachmentToUpdate) {
    // MQF-151
    this.attachmentsToUpdate = this.attachmentsToUpdate.filter(k => k.fileName != attach.fileName);
  }

  isInDeletion(fileId: number): boolean {
    if (this.listAttachToDelete.findIndex(x => x.fileId == fileId) != -1)
      return true;
    else
      return false;
  }

  onCancelDeleteClick(fileId: number) {
    this.listAttachToDelete = this.listAttachToDelete.filter(x => x.fileId != fileId);
  }

  onSelecteUnitSystem(evt: SelectOption) {
    this.unitSystemValue = evt.value;
    this.prepareUomsList(true);
    // this.invalidateWeight();


    if (this.isInitialLoad) {
      return;
    } else {
      // OD/WT/ID VALUES
      if (this.unitSystemValue.toLowerCase() == 'metric') {
        if (this.selectedNpsRow.odMetric) {
          this.odValue = this.selectedNpsRow.odMetric!;
          this.wtValue = this.selectedNpsRow.wtMetric!;
        }
      }
      else {
        if (this.selectedNpsRow.odImperial) {
          this.odValue = this.selectedNpsRow.odImperial!;
          this.wtValue = this.selectedNpsRow.wtImperial!;
        }
      }
    }

    this.setRoundDigitsEnquiryForm();

  }

  onSelectedMarketingRouteSms(evt: SelectOption) {

    this.smsMarketingRouteValue = evt.value;
    this.smsMarketingRouteIsValid = true;


    this.smsOptionList = this.getSmsOptionList();

    const smsName = this.itemParameterValues.sms?.find(s => s.smsId === this.smsValue)?.description;

    // check if selection is still valid
    if (this.smsOptionList.map(o => o.text).includes(smsName)) {
      this.onSelectedSms(this.smsOptionList.find(s => s.text === smsName)!);
    }
    else {
      this.smsValue = '';
      this.smsIsValid = false;
    }

    this.surfaceTypeOptionList = this.getSurfaceTypeOptionList(this.smsMarketingRouteValue);
    this.tubeExecutionOptionList = this.getTubeExecutionOptionList();

    const currentTubeExecution = this.items[this.selectedIndexItem].tubeExecution;
    const currentTubeExecutionId = this.tubeExecutionValue ?? currentTubeExecution?.tubeExecutionId;
    if (currentTubeExecution?.isCustom) {
      this.ensureTubeExecutionOption(currentTubeExecution);
    }
    if (currentTubeExecutionId != null && currentTubeExecutionId !== '') {
      this.tubeExecutionValue = currentTubeExecutionId;
    }

    const hasTubeExecution =
      currentTubeExecutionId != null &&
      currentTubeExecutionId !== '' &&
      this.tubeExecutionOptionList.some(opt => opt.value != null && opt.value.toString() === currentTubeExecutionId.toString());
    if (!this.fillFormLoading && !hasTubeExecution) {
      this.tubeExecutionValue = null;
      this.items[this.selectedIndexItem].tubeExecution = null;
      this.prefillTolerances();
    }

    if (this.isInitialLoad) {
      return;
    }
    else {
      // set default

      // if hot, set default surfacetype 
      if (this.smsMarketingRouteValue == 'Hot') {
        this.surfaceTypeOptionList = this.getSurfaceTypeOptionList(this.smsMarketingRouteValue);
        if (!this.surfaceTypeOptionList.map(sto => sto.value).includes(this.surfaceTypeValue)) {
          this.surfaceTypeValue = null; // if the previous selection is not more valid, clean the selection
          if (this.surfaceTypeOptionList.length == 1) { // eventually select the only possibile value
            this.surfaceTypeValue = this.surfaceTypeOptionList[0].value;
            this.items[this.selectedIndexItem].surfaceType = this.itemParameterValues.surfaceTypes!.find(x => x.surfaceTypeId == this.surfaceTypeValue);
          }
        }
      }
      else {
        this.surfaceTypeOptionList = this.getSurfaceTypeOptionList();
      }

      this.applyDefaultSurfaceType();


      if (this.wtValue && !this.typeOfToleranceValue) {
        // set default type of tolerance if needed
        const defaultTolType = this.typeOfToleranceOptionList.find(tot => tot.isDefault);
        if (defaultTolType)
          this.onSelectedTypeOfTolerance(defaultTolType);
      }

      this.setDefaultHtValue();

    }
    this.calculateDefaultMill();
    this.applyDefaultSurfaceType();
    this.syncHydroTestRule(true);
    this.invalidateMaterialCode();
  }

  setDefaultHtValue(skipMaterialValidation: boolean = false) {
    const defaultHtValue = this.smsMarketingRouteValue == 'Cold';
    const selectedOption = this.htOptionList.find(ht => ht.value == defaultHtValue);
    if (selectedOption) {
      this.onSelectedHt(selectedOption, skipMaterialValidation);
    }
  }

  calculateDefaultMill() {
    let _data: Mill = new Mill();
    const odMm = this.getOdInMm();
    if (this.enquiryToEdit.header?.salesOffice == 'DUS' || this.enquiryToEdit.header?.salesOffice == 'EU1') {
      _data = this.itemParameterValues.mills!.find(x => x.shortName == 'HO')!;
    } else {
      if (this.smsMarketingRouteValue == 'Hot')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'MB')!;

      if (this.smsMarketingRouteValue == 'Cold' && odMm !== null && odMm >= 6 && odMm <= 88.99)
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

      if (this.smsMarketingRouteValue == 'Cold' && odMm !== null && odMm > 88.99)
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!;
    }

    if (_data.millId) {
      this.millValue = _data.shortName;
      this.items[this.selectedIndexItem].mill = _data;
    }
  }

  onSelectedSms(evt: SelectOption) {
    const previousValue = _.cloneDeep(this.items[this.selectedIndexItem].sms);
    const millPreviousValue = _.cloneDeep(this.items[this.selectedIndexItem].mill);

    this.smsValue = evt.value;
    this.smsIsValid = true;
    this.items[this.selectedIndexItem].sms = new EnquirySms();
    this.items[this.selectedIndexItem].sms = this.itemParameterValues.sms!.find(x => x.smsId == this.smsValue)!;
    this.marketingRoute = this.items[this.selectedIndexItem].sms!.marketingRoute!;
    // CHECK THE MARKETING ROUTE
    if (this.action == 'create' && this.millChangedByUser == false) {
      if (this.items[this.selectedIndexItem].sms!.name == 'HB HOT') {
        let _data: Mill = new Mill();
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'MB')!;
        this.millValue = _data.shortName;
        this.millIsValid = true;
        this.items[this.selectedIndexItem].mill = _data;
      } else {
        this.millValue = null;
        this.items[this.selectedIndexItem].mill = undefined;
      }
      this.applyOdMillRule();
      // if mill changes and mill is not compliant with material code mills then invalidate material code
      if (millPreviousValue && millPreviousValue.millId != this.items[this.selectedIndexItem].mill?.millId && !this.itemAttributesForMaterialCode?.millsId?.includes(this.items[this.selectedIndexItem].mill?.millId!)) {
        this.invalidateMaterialCode();
      }
    }

    if (this.isHollowBarsSms(this.items[this.selectedIndexItem].sms)) {
      if (!this.isHollowBarsSms(previousValue)) // update only if it not already was HB
        this.onSelectedHollowBarsSms();
    }

    if (this.isHexuSms(this.items[this.selectedIndexItem].sms)) {
      this.setUbentValue(true);
    }
    else {
      if (this.uBentValue === true)
        this.setUbentValue(false);
    }

    // if u don't have a quantity , quantityUom will be updated ; MP REMOVED ON 2025-11-06 AS REQUESTED BY Customer
    // if (!Number.isFinite(this.quantityValue))
    this.setDefaultQuantityUom();
    this.syncHydroTestRule(true);
  }

  isFinite(value: any): boolean {
    return this.toFiniteNumber(value) !== null;
  }

  private toFiniteNumber(value: any): number | null {
    const normalizedValue = this.utils.checkDecimal(value);
    return Number.isFinite(normalizedValue) ? normalizedValue : null;
  }

  private toFiniteNumberOrUndefined(value: any): number | undefined {
    const normalizedValue = this.toFiniteNumber(value);
    return normalizedValue === null ? undefined : normalizedValue;
  }

  private toRoundedFiniteNumberOrUndefined(value: any, roundDigits: number): number | undefined {
    const normalizedValue = this.toFiniteNumber(value);
    return normalizedValue === null ? undefined : parseFloat(normalizedValue.toFixed(roundDigits));
  }

  private areToleranceMeasuresFinite(minus: number | undefined, plus: number | undefined): boolean {
    return Number.isFinite(minus) && Number.isFinite(plus);
  }

  setUbentValue(val: boolean) {
    let so = new SelectOption();
    so.value = val;
    this.onSelectedUBent(so);
  }

  onSelectedHollowBarsSms() {
    // clean tolerances values for WT
    // if od and id are empty then default to 0
    // od tol +2% -0%
    // id tol +0% -2%
    // check that when open in edit and the sms already was hb, values are not overwritten
    if (this.npsValue) {
      const evt = new TTButton();
      evt.action = 'select|wtOdIt';
      this.onBtnToolbarClick(evt);
    }

    this.wtValue = null;
    this.items[this.selectedIndexItem].wt = undefined;
    this.cleanWtTolerances();

    this.odValue = !Number.isFinite(this.odValue) ? 0 : this.odValue;
    this.items[this.selectedIndexItem].od = 0;
    this.odToleranceMinusDisabled = false;
    this.odTolerancePlusDisabled = false;
    this.odTolerancePlusValue = 2;
    this.odToleranceMinusValue = 0;
    this.odToleranceUomValue = '%';
    this.items[this.selectedIndexItem].odTolerancePlus = this.odTolerancePlusValue;
    this.items[this.selectedIndexItem].odToleranceMinus = this.odToleranceMinusValue;
    this.items[this.selectedIndexItem].odToleranceUom = this.odToleranceUomValue;

    this.idValue = !Number.isFinite(this.idValue) ? 0 : this.idValue;
    this.items[this.selectedIndexItem].id = 0;
    this.idToleranceMinusDisabled = false;
    this.idTolerancePlusDisabled = false;
    this.idTolerancePlusValue = 0;
    this.idToleranceMinusValue = -2;
    this.idToleranceUomValue = '%';
    this.items[this.selectedIndexItem].idTolerancePlus = this.idTolerancePlusValue;
    this.items[this.selectedIndexItem].idToleranceMinus = this.idToleranceMinusValue;
    this.items[this.selectedIndexItem].idToleranceUom = this.idToleranceUomValue;

  }

  setDefaultQuantityUom(): void {
    if (this.isInitialLoad && !this.fillFromEnquiry) return;

    const unitSystem = (this.unitSystemValue ?? this.items[this.selectedIndexItem]?.unitSystem ?? this.enquiryToEdit.header?.unitSystem ?? '').toString().trim().toLowerCase();
    const isMetric = unitSystem === 'metric';
    const currentItem = this.items[this.selectedIndexItem];
    const previousQuantityUom = currentItem.quantityUom ?? null;
    const uoms = this.itemParameterValues.quantityUoms;

    if (this.isHollowBarsSms(currentItem.sms)) {
      this.quantityUomValue = isMetric ? this.findQuantityUomCode(uoms?.metricUoms, 'kg') : this.findQuantityUomCode(uoms?.imperialUoms, 'lb', 'lbs');
    } else if (this.lengthTypeValue === 'FL') {
      this.quantityUomValue = this.findQuantityUomCode(uoms?.metricUoms, 'pcs');
    } else if (this.lengthTypeValue === 'RL') {
      this.quantityUomValue = isMetric ? this.findQuantityUomCode(uoms?.metricUoms, 'm') : this.findQuantityUomCode(uoms?.imperialUoms, 'ft');
    }

    this.items[this.selectedIndexItem].quantityUom = this.quantityUomValue;
    this.quantityUomIsValid = !!this.quantityUomValue;

    if ((this.quantityUomValue ?? null) !== previousQuantityUom) {
      this.items[this.selectedIndexItem].quantity = null;
      this.quantityValue = 0;
    }
  }


  onInputCustomerItemNo(evt: any) {
    this.customerItemNoValue = this.utils.normalizeCustomerItemNo(evt);
    this.items[this.selectedIndexItem].customerItemNo = this.customerItemNoValue;
    this.customerItemNoIsValid = this.customerItemNoValue === '' || this.utils.isCustomerItemNoNumeric(this.customerItemNoValue);
  }

  onInputRemark(evt: any) {
    this.remarkValue = evt || '';
    this.items[this.selectedIndexItem].remark = this.remarkValue;
  }

  onInputApplicableNorms(evt: any) {
    this.applicableNormsValue = evt;
    this.items[this.selectedIndexItem].applicableNorms = this.applicableNormsValue;
  }

  onBtnToolbarClick(evt: TTButton) {
    let _action: string = "";
    if (evt["action"]) _action = evt["action"];

    if (_action.endsWith("nps")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      this.getNpsAndSchedules(true);
    }

    if (_action.endsWith("wtOdIt")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      this.setWtOdIdNps(_temp[1], true);
    }
  }

  onInputQuantity(evt: any) {
    this.quantityValue = evt != '' ? evt : null;
    this.quantityIsValid = true;
    this.items[this.selectedIndexItem].quantity = this.quantityValue;

    this.invalidateWeight();
  }

  onSelectedQuantityUom(evt: SelectOption) {
    this.quantityUomValue = evt.value;
    this.quantityUomIsValid = true;
    this.items[this.selectedIndexItem].quantityUom = this.quantityUomValue;

    this.invalidateWeight();
  }

  onSelectedAlloySurcharge(evt: any) {
    this.alloySurchargeValue = evt.value;
    this.alloySurchargeIsValid = true;
    this.items[this.selectedIndexItem].alloySurcharge = true;
  }

  onInputOd(evt: any) {
    this.odValue = evt != '' ? evt : null;
    this.checkWtOdId(false);
    this.items[this.selectedIndexItem].od = this.odValue;
    this.applyOdMillRule();
    this.syncHydroTestRule(true);
    this.invalidateWeight();
    this.invalidateMaterialCode();
    /* if (this.odMillRuleActive()){
      let _data: Mill = new Mill();
      if (this.marketingRoute == 'ColdFinished' && (parseFloat(this.odValue) >= 6 && parseFloat(this.odValue) <= 88.99) && this.odUomValue == 'mm')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'CV')!;

      if (this.marketingRoute == 'ColdFinished' && (parseFloat(this.odValue) > 88.99) && this.odUomValue == 'mm')
        _data = this.itemParameterValues.mills!.find(x => x.shortName == 'RS')!;

      if (_data.millId){
        this.millValue = _data.shortName;
        this.millIsValid = true;
        this.items[this.selectedIndexItem].mill = _data;
      } else {
        this.millValue = null;
        this.items[this.selectedIndexItem].mill = undefined;
      }
    } */
  }

  onInputOdFocusOut(evt: any) {
    const value = evt != '' ? evt.target.value : null
    if (!value) {
      this.cleanOdTolerances();
    }
    this.applyDefaultSurfaceType();
    this.calculateDefaultMill();
  }

  onInputIdFocusOut(evt: any) {
    const value = evt != '' ? evt.target.value : null
    if (!value) {
      this.cleanIdTolerances();
    }
  }

  onInputWtFocusOut(evt: any) {
    const value = evt != '' ? evt.target.value : null
    if (!value) {
      // clean the wt tolerances
      this.cleanWtTolerances();

    }
    else {
      this.tubeExecutionIsDisabled = false;
      this.typeOfToleranceIsDisabled = false;

      // set default type of tolerance if needed
      if (!this.typeOfToleranceValue) {
        const defaultTolType = this.typeOfToleranceOptionList.find(tot => tot.isDefault);
        if (defaultTolType)
          this.onSelectedTypeOfTolerance(defaultTolType);
      }

    }
  }

  onSelectedOdUom(evt: SelectOption) {
    this.odUomValue = evt.value;
    this.items[this.selectedIndexItem].odUom = this.odUomValue;
    this.applyOdMillRule();
    this.syncHydroTestRule(true);
    this.invalidateWeight();
  }

  onInputWt(evt: any) {
    this.wtValue = evt != '' ? evt : null;
    this.checkWtOdId(false);
    this.items[this.selectedIndexItem].wt = this.wtValue;
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onSelectedWt(evt: SelectOption) {
    this.wtUomValue = evt.value;
    this.items[this.selectedIndexItem].wtUom = this.wtUomValue;
    this.invalidateWeight();
  }

  onInputTotalWeight(evt: any) {
    this.totalWeightValue = evt != '' ? evt : null;
    this.totalWeightIsvalid = true;
    this.items[this.selectedIndexItem].totalWeight = this.totalWeightValue;
  }

  onSelectedTotalWeightUom(evt: SelectOption) {
    this.totalWeightUomValue = evt.value;
    this.totalWeightUomIsValid = true;
    this.items[this.selectedIndexItem].totalWeightUom = this.totalWeightUomValue;

    this.invalidateWeight();
  }

  onInputId(evt: any) {
    this.idValue = evt != '' ? evt : null;
    this.checkWtOdId(false);
    this.items[this.selectedIndexItem].id = this.idValue;
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onSelectedId(evt: SelectOption) {
    this.idUomValue = evt.value;
    this.items[this.selectedIndexItem].idUom = this.idUomValue;
    this.invalidateWeight();
  }

  onSelectedTypeOfTolerance(evt: SelectOption, skipMaterialValidation: boolean = false) {
    this.typeOfToleranceValue = evt.value;
    this.typeOfToleranceIsValid = true;
    this.items[this.selectedIndexItem].typeOfTolerance = this.typeOfToleranceValue;
    if (this.fillFormLoading) {
      return;
    }
    this.prefillTolerances();

    this.invalidateWeight();
    if (!skipMaterialValidation) {
      this.invalidateMaterialCodeOnTypeOfToleranceMismatch();
    }
  }

  onSelectedTubeExecution(evt: SelectOption) {

    this.prevTubeExecutionValue = this.tubeExecutionValue ? JSON.parse(JSON.stringify(this.tubeExecutionValue)) : null; // deep copy previous value
    this.tubeExecutionValue = evt.value;
    this.items[this.selectedIndexItem].tubeExecution = new TubeExecution();
    this.items[this.selectedIndexItem].tubeExecution = this.itemParameterValues.tubeExecution!.filter(x => x.tubeExecutionId == evt.value)[0];
    this.tubeExecutionIsValid = true;
    if (this.fillFormLoading) {
      return;
    }
    this.prefillTolerances();

    this.invalidateWeight();
  }

  prefillTolerances() {
    // Prefill Tolerance- and Tolerance+

    if (this.items[this.selectedIndexItem].tubeExecution) {

      const isCustom = this.items[this.selectedIndexItem].tubeExecution!.isCustom;

      if (!isCustom) {

        if (this.items[this.selectedIndexItem].typeOfTolerance == 'AW') {
          this.wtToleranceMinusValue = this.items[this.selectedIndexItem].tubeExecution!.toleranceMinusAw;
          this.wtTolerancePlusValue = this.items[this.selectedIndexItem].tubeExecution!.tolerancePlusAw;
        }
        if (this.items[this.selectedIndexItem].typeOfTolerance == 'MW') {
          this.wtToleranceMinusValue = this.items[this.selectedIndexItem].tubeExecution!.toleranceMinusMw;
          this.wtTolerancePlusValue = this.items[this.selectedIndexItem].tubeExecution!.tolerancePlusMw;
        }

        this.wtToleranceMinusIsValid = true;
        this.wtTolerancePlusIsValid = true;

        this.wtToleranceUomValue = this.toleranceUomOptionList.filter(opt => opt.value == '%')[0].value;
        this.items[this.selectedIndexItem].wtToleranceUom = this.wtToleranceUomValue;
        this.wtToleranceUomDisabled = true;
        this.wtToleranceUomIsValid = true;

      }
      else {
        // MQF-272: if it's  custom, check if the previous selection was a not custom
        // in this case reset the custom value to null 
        const prevTubeIdx = this.itemParameterValues.tubeExecution!.findIndex(x => x.tubeExecutionId == this.prevTubeExecutionValue);
        if (prevTubeIdx >= 0 && this.itemParameterValues.tubeExecution![prevTubeIdx].isCustom == false) {
          this.wtToleranceMinusValue = null;
          this.wtTolerancePlusValue = null;
        }
      }

      this.wtToleranceMinusDisabled = !isCustom;
      this.wtTolerancePlusDisabled = !isCustom;
      this.wtToleranceUomDisabled = !isCustom;

      this.items[this.selectedIndexItem].wtToleranceMinus = this.wtToleranceMinusValue;
      this.items[this.selectedIndexItem].wtTolerancePlus = this.wtTolerancePlusValue;
    }
    else {
      // no execution tube
      this.wtToleranceMinusDisabled = true;
      this.wtTolerancePlusDisabled = true;
      this.wtToleranceUomDisabled = true;
      this.wtToleranceMinusValue = null;
      this.wtTolerancePlusValue = null;
      this.wtToleranceUomValue = null;
      this.items[this.selectedIndexItem].wtToleranceMinus = this.wtToleranceMinusValue;
      this.items[this.selectedIndexItem].wtTolerancePlus = this.wtTolerancePlusValue;
      this.items[this.selectedIndexItem].wtToleranceUom = this.wtToleranceUomValue;
    }

  }

  onInputToleranceMinus(evt: any) {

    if (evt != '') {
      this.wtToleranceMinusValue = evt;
      this.items[this.selectedIndexItem].wtToleranceMinus = Number(this.wtToleranceMinusValue);
    }
    else {
      this.wtToleranceMinusValue = undefined;
      this.items[this.selectedIndexItem].wtToleranceMinus = this.wtToleranceMinusValue;
    }
    this.wtToleranceMinusIsValid = true;

    this.invalidateWeight();
  }

  onInputTolerancePlus(evt: any) {

    if (evt != '') {
      this.wtTolerancePlusValue = evt;
      this.items[this.selectedIndexItem].wtTolerancePlus = Number(this.wtTolerancePlusValue);
    }
    else {
      this.wtTolerancePlusValue = undefined;
      this.items[this.selectedIndexItem].wtTolerancePlus = this.wtTolerancePlusValue;
    }

    this.wtTolerancePlusIsValid = true;

    this.invalidateWeight();
  }

  onInputOdTolerancePlus(evt: any) {
    if (evt != '') {
      this.odTolerancePlusValue = evt;
      this.items[this.selectedIndexItem].odTolerancePlus = Number(this.odTolerancePlusValue);
    }
    else {
      this.odTolerancePlusValue = undefined;
      this.items[this.selectedIndexItem].odTolerancePlus = this.odTolerancePlusValue;
    }

    this.odTolerancePlusIsValid = true;
    this.invalidateWeight();
  }

  onInputOdToleranceMinus(evt: any) {
    if (evt != '') {
      this.odToleranceMinusValue = evt;
      this.items[this.selectedIndexItem].odToleranceMinus = Number(this.odToleranceMinusValue);
    }
    else {
      this.odToleranceMinusValue = undefined;
      this.items[this.selectedIndexItem].odToleranceMinus = this.odToleranceMinusValue;
    }

    this.odToleranceMinusIsValid = true;

    this.invalidateWeight();
  }

  onInputIdTolerancePlus(evt: any) {
    if (evt != '') {
      this.idTolerancePlusValue = evt;
      this.items[this.selectedIndexItem].idTolerancePlus = Number(this.idTolerancePlusValue);
    }
    else {
      this.idTolerancePlusValue = undefined;
      this.items[this.selectedIndexItem].idTolerancePlus = this.idTolerancePlusValue;
    }
    this.idTolerancePlusIsValid = true;

    this.invalidateWeight();
  }

  onInputIdToleranceMinus(evt: any) {
    if (evt != '') {
      this.idToleranceMinusValue = evt;
      this.items[this.selectedIndexItem].idToleranceMinus = Number(this.idToleranceMinusValue);
    }
    else {
      this.idToleranceMinusValue = undefined;
      this.items[this.selectedIndexItem].idToleranceMinus = this.idToleranceMinusValue;
    }

    this.idToleranceMinusIsValid = true;

    this.invalidateWeight();
  }

  onSelectedOdToleranceUom(evt: SelectOption) {
    this.odToleranceUomValue = evt.value;
    this.odToleranceUomIsValid = true;
    this.items[this.selectedIndexItem].odToleranceUom = this.odToleranceUomValue;

    this.invalidateWeight();
  }

  onSelectedIdToleranceUom(evt: SelectOption) {
    this.idToleranceUomValue = evt.value;
    this.idToleranceUomIsValid = true;
    this.items[this.selectedIndexItem].idToleranceUom = this.idToleranceUomValue;

    this.invalidateWeight();
  }

  onSelectedWtToleranceUom(evt: SelectOption) {
    this.wtToleranceUomValue = evt.value;
    this.wtToleranceUomIsValid = true;
    this.items[this.selectedIndexItem].wtToleranceUom = this.wtToleranceUomValue;

    this.invalidateWeight();
  }

  onSelectedMarketFamily(evt: SelectOption) {
    this.marketFamilyValue = evt.value;
    this.marketFamilyIsValid = true;
    this.items[this.selectedIndexItem].marketFamily = new MarketFamily();
    this.items[this.selectedIndexItem].marketFamily = this.itemParameterValues.marketFamily!.find(x => x.marketFamilyId == this.marketFamilyValue)!;
  }

  onSelectedUt(evt: SelectOption) {
    this.utValue = evt.value;
    this.utIsValid = true;
    this.items[this.selectedIndexItem].ut = this.utValue;
    this.invalidateMaterialCode();
  }

  onSelectedHydroTest(evt: SelectOption) {
    this.hydroTestValue = evt.value;
    this.hydroTestIsValid = true;
    this.items[this.selectedIndexItem].hydroTest = this.hydroTestValue;
    this.invalidateMaterialCode();
  }

  onSelectedCts(evt: SelectOption) {
    const hasMaterialCode = !!(this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode);
    const materialValuesBeforeCts = this.getMaterialDependentCtsValuesForCurrentItem();

    this.ctsValue = evt.value;
    this.ctsIsvalid = true;
    this.items[this.selectedIndexItem].cts = this.ctsValue;

    if (this.ctsValue) {
      this.utValue = false;
      this.htAdditionalValue = false;
      this.htValue = false;

      this.dyePenetrantValue = false;
      this.dyePenetrant100PValue = false;
      this.penaltyValue = false;
      this.colorCodingValue = false;
      this.specialOperationsValue = false;
      this.specialTestsValue = false;
      this.grindingHoningValue = false;
      this.ecValue = false;
      this.notStdPackagingValue = false;
      this.multipleCuttingValue = false;
      this.inspectionType3Dot2Value = false;
      const itemProps = ["ut", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting'];
      itemProps.forEach(p => this.updateItemDeliveryExtraProperty(p, false));

      this.endsConditionValue = this.endsConditionOptionList.find(ec => ec.text == 'SquareCutDeburred')?.value;
      this.items[this.selectedIndexItem].endsCondition = this.endsConditionValue;

      this.testConditionValue = this.testConditionOptionList.find(ec => ec.text == 'TC1')?.value;
      this.items[this.selectedIndexItem].testCondition = this.testConditionValue;

      this.setDefaultHtValue(true);
    }

    this.syncHydroTestRule(true);

    const materialValuesAfterCts = this.getMaterialDependentCtsValuesForCurrentItem();
    if (hasMaterialCode && !_.isEqual(materialValuesBeforeCts, materialValuesAfterCts)) {
      this.invalidateMaterialCode();
    }
  }

  private getMaterialDependentCtsValuesForCurrentItem(): Record<string, any> {
    const currentItem = this.items[this.selectedIndexItem];
    if (!currentItem) {
      return {};
    }

    return this.materialDependentCtsProperties.reduce((values, property) => {
      values[property] = _.cloneDeep(currentItem[property]);
      return values;
    }, {} as Record<string, any>);
  }

  private syncHydroTestRule(applyDefaultForEditable: boolean): void {
    this.hydroTestDisabled = this.isHydroTestDisabledForCurrentItem();

    if (!this.ctsValue) {
      return;
    }

    const currentItem = this.items[this.selectedIndexItem];
    if (!currentItem) {
      return;
    }

    if (this.hydroTestDisabled) {
      this.hydroTestValue = false;
      currentItem.hydroTest = false;
      return;
    }

    if (!applyDefaultForEditable) {
      return;
    }

    const hydroDefaultValue = this.resolveHydroTestDefaultValue();
    this.hydroTestValue = hydroDefaultValue;
    currentItem.hydroTest = hydroDefaultValue;
  }

  onSelectedEndsCondition(evt: SelectOption) {
    this.endsConditionValue = evt.value;
    this.endsConditionIsvalid = true;
    this.items[this.selectedIndexItem].endsCondition = this.endsConditionValue;
    this.invalidateMaterialCode();
  }

  onSelectedTestCondition(evt: SelectOption) {
    this.testConditionValue = evt.value;
    this.testConditionIsvalid = true;
    this.items[this.selectedIndexItem].testCondition = this.testConditionValue;
    this.invalidateMaterialCode();
  }

  onSelectedSql(evt: SelectOption) {
    this.sqlValue = evt.value;
    this.sqlIsValid = true;
    this.items[this.selectedIndexItem].sql = this.itemParameterValues.sqls?.find(x => x.sqlId == this.sqlValue);
    this.validateSelectedSqlCompatibility();
  }

  onSelectedOfferScheme(evt: SelectOption) {
    this.offerSchemeValue = evt.value;
    this.offerSchemeIsValid = true;
    this.items[this.selectedIndexItem].offerScheme = this.itemParameterValues.offerSchemes?.find(x => x.offerSchemeCode == this.offerSchemeValue);
  }

  onSelectedEnergySurcharge(evt: SelectOption) {
    this.energySurchargeValue = evt.value;
    this.energySurchargeIsValid = true;
    this.items[this.selectedIndexItem].energySurcharge = this.energySurchargeValue;
  }

  onSelectedUBent(evt: SelectOption) {
    this.uBentValue = evt.value;
    this.uBentIsValid = true;
    this.items[this.selectedIndexItem].uBent = this.uBentValue;
    this.invalidateMaterialCode();
  }

  onSelectedHt(evt: SelectOption, skipMaterialValidation: boolean = false) {
    this.htValue = evt.value;
    this.htIsValid = true;
    this.items[this.selectedIndexItem].ht = this.htValue;
    if (!skipMaterialValidation) {
      this.invalidateMaterialCode();
    }
  }

  onSelectedHtAdditional(evt: SelectOption) {
    this.htAdditionalValue = evt.value;
    this.htAdditionalIsValid = true;
    this.items[this.selectedIndexItem].htAdditional = this.htAdditionalValue;
    this.invalidateMaterialCode();
  }

  onSelectedInspectionType3Dot2(evt: SelectOption) {
    this.inspectionType3Dot2Value = evt.value;
    this.inspectionType3Dot2IsValid = true;
    this.items[this.selectedIndexItem].inspectionType3Dot2 = this.inspectionType3Dot2Value;
  }

  onSelectedLengthType(evt: SelectOption) {
    this.lengthTypeValue = evt.value;
    this.lengthTypeIsValid = true;
    this.items[this.selectedIndexItem].lengthType = this.lengthTypeValue;

    if (this.lengthTypeValue === 'FL' && !this.multipleLengthValue) {
      this.lengthMaxValue = this.lengthMinValue = null;
      this.items[this.selectedIndexItem].lengthMin = this.lengthMinValue;
      this.items[this.selectedIndexItem].lengthMax = this.lengthMaxValue;
    }
    if (this.lengthTypeValue == 'RL') {
      this.multipleLengthValue = false;
      this.nominalLengthValue = null;
      this.items[this.selectedIndexItem].multipleLength = this.multipleLengthValue;
      this.items[this.selectedIndexItem].lengthNominal = this.nominalLengthValue;
    }

    this.setDefaultQuantityUom();
    this.invalidateMaterialCode();

  }

  onInputLengthMin(evt: any) {
    this.lengthMinValue = evt != '' ? evt : null;
    if (evt != '')
      this.lengthMinIsValid = true;
    else
      this.lengthMinIsValid = false;

    this.items[this.selectedIndexItem].lengthMin = this.lengthMinValue;

    this.invalidateWeight();
    this.invalidateMaterialCode();

  }

  onInputLengthMax(evt: any) {
    this.lengthMaxValue = evt != '' ? evt : null;
    if (evt != '')
      this.lengthMaxIsValid = true;
    else
      this.lengthMaxIsValid = false;

    this.items[this.selectedIndexItem].lengthMax = this.lengthMaxValue;

    this.invalidateWeight();
    this.invalidateMaterialCode();

  }

  onInputNominalLength(evt: any) {
    this.nominalLengthValue = evt != '' ? evt : null;
    if (evt != '')
      this.nominalLengthIsValid = true;
    else
      this.nominalLengthIsValid = false;

    this.items[this.selectedIndexItem].lengthNominal = this.nominalLengthValue;
    // if (!this.multipleLengthValue)
    //   this.lengthMinValue = this.lengthMaxValue = this.nominalLengthValue;
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onSelectedLengthUom(evt: SelectOption) {
    this.lengthUomValue = evt.value;
    this.lengthUomIsValid = true;
    this.items[this.selectedIndexItem].lengthUom = this.lengthUomValue;

    this.invalidateWeight();
  }

  onSelectedMultipleCutting(evt: SelectOption) {
    this.multipleCuttingValue = evt.value;
    this.multipleCuttingIsValid = true;
    this.items[this.selectedIndexItem].multipleCutting = this.multipleCuttingValue;
  }

  onSelectedsurfaceType(evt: SelectOption) {
    this.surfaceTypeValue = evt.value;
    this.surfaceTypeIsValid = true;
    this.items[this.selectedIndexItem].surfaceType = this.itemParameterValues.surfaceTypes!.find(x => x.surfaceTypeId == this.surfaceTypeValue);
  }

  onChangeOptionDate(evt: any) {
    this.optionDateValue = parseInt(evt); // GBR 13/03/2024 new Date(evt.toString()).getTime();
    if (evt != 0)
      this.optionDateIsValid = true;
    else
      this.optionDateIsValid = false;

    this.items[this.selectedIndexItem].optionDate = this.optionDateValue;
  }

  onChangeCustomerDeliveryDate(evt: any) {
    this.customerDeliveryDateValue = parseInt(evt);  //new Date(evt.toString()).getTime();
    this.items[this.selectedIndexItem].customerDeliveryDate = this.customerDeliveryDateValue;
  }

  /* AUTOCOMPLETE COMMONS EVENTS */
  onAutocompleteSelectRows(evt: Autocomplete) {
    if (evt.field == 'normGrades') {
      let _data: any[] = JSON.parse(evt.object!);
      let _ids: number[] = new Array();
      let _codes: string[] = new Array();
      for (var x = 0; x < _data.length; x++) {
        _ids.push(_data[x]["normGradeId"]);
        _codes.push(_data[x]["normGradeCode"]);
      }
      this.normGradesCodes = new Array();
      this.normGradesCodes = _codes;
      if (!this.normGradesIds) this.normGradesIds = new Array();
      this.normGradesIds = _ids;

      // Se ho selezionato qualcosa abilito le RawMaterialGrade
      if (_ids.length > 0) {
        //this.getRawMaterialGrades('', _ids);
        //if (this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom == true){
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = false;
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = '';
        //}

        //if (this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom == true){
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = false;
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = '';
        //}

        this.getLimitationsForNormGrades(_ids, false);
        //this.normGradeIsValid = true;
      }

      this.items[this.selectedIndexItem].normGrades = _data;
      // La rendo valida
      this.normGradeIsValid = true;
    }
    this.invalidateWeight();
  }

  onAutocompleteInputChange(evt: Autocomplete) {
    if (evt.field == 'normGrades') {
      this.getNormGrades(evt.object!, false);
    }

    if (evt.field == 'rawMaterialGrades') {
      //this.getRawMaterialGrades(evt.object!, this.normGradesIds!);
      this.getRawMaterialGradesFromNormGradesAndLimitations(evt.object!, this.normGradesIds!, false);
    }

    /* GBR 27/03/2024 MQF-160 */
    if (evt.field == 'mill') {
      this.millDataset = new Array();
      this.millDataset = this.itemParameterValues.mills!.filter(x => x.name!.toLowerCase().indexOf(evt.object!.toLowerCase()) != -1
        || x.shortName!.toLowerCase().indexOf(evt.object!.toLowerCase()) != -1
        || x.city!.toLowerCase().indexOf(evt.object!.toLowerCase()) != -1
        || x.country!.toLowerCase().indexOf(evt.object!.toLowerCase()) != -1);
    }

    // GBR 23/01/2024 - RULE FOR WT/ID/OD
    if (evt.field == 'id' || evt.field == 'od' || evt.field == 'wt') {
      this.checkWtOdId(false);
    }

    if (evt.field == 'materialCode') {
      this.materialDataset = this.materials.filter(x => x.materialCode!.toLowerCase().indexOf(evt.object!.toLowerCase()) != -1)
        .sort(this.sortMaterials)
        .slice(0, 100);
    }

    this.invalidateWeight();
  }

  sortMaterials(a: any, b: any) {
    let nameA: string = a["materialCode"]!.toUpperCase(); // ignore upper and lowercase
    let nameB: string = b["materialCode"]!.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }

  onAutocompleteSelect(evt: Autocomplete) {
    if (evt.field == 'rawMaterialGrades') {
      let _data: any = JSON.parse(evt.object!);
      this.rawMaterialGradeValue = _data["rawMaterialGradeCode"];
      this.items[this.selectedIndexItem].rawMaterialGrade = JSON.parse(evt.object!);
      this.rawMaterialGradeIsValid = true;
      this.invalidateWeight();
      this.invalidateMaterialCode();
    }

    if (evt.field == 'mill') {
      let _data: any = JSON.parse(evt.object!);
      this.millValue = _data["shortName"];
      if (this.millValue != null && this.millValue != '')
        this.millIsValid = true;
      else
        this.millIsValid = false;

      this.items[this.selectedIndexItem].mill = JSON.parse(evt.object!);
      this.applyDefaultSurfaceType();

      if (!!this.ctsValue) {
        // this.htValue = false;
        this.setDefaultHtValue();
        this.items[this.selectedIndexItem].ht = false;
      }
      this.syncHydroTestRule(true);
      const currentMaterialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
      const applyMaterialRules = (attrs?: ItemAttributesByMaterialCode) => {
        if (!attrs) {
          this.resetSqlOptionList();
          return;
        }

        this.itemAttributesForMaterialCode = attrs;
        const selectedMillId = this.items[this.selectedIndexItem].mill?.millId;
        if (selectedMillId && Array.isArray(attrs.millsId) && attrs.millsId.length > 0 && !attrs.millsId.includes(selectedMillId)) {
          this.invalidateMaterialCode();
          return;
        }

        this.applySqlRulesForCurrentMaterialAndMill(attrs);
      };

      if (!currentMaterialCode) {
        this.resetSqlOptionList();
        return;
      }

      if (this.itemAttributesForMaterialCode) {
        applyMaterialRules(this.itemAttributesForMaterialCode);
      } else {
        const requestedMaterialCode = currentMaterialCode;
        this.subscriptions.add(
          this.backendService.getItemAttributesByMaterialCode(requestedMaterialCode, this.enquiryToEdit.header!.unitSystem!).subscribe({
            next: res => {
              const materialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
              if (materialCode != requestedMaterialCode) {
                return;
              }
              applyMaterialRules(res);
            },
            error: () => {
              this.resetSqlOptionList();
            }
          })
        );
      }
    }

    if (evt.field == 'materialCode') {
      let _data: Material = JSON.parse(evt.object!);
      this.materialValue = _data.materialCode;
      this.items[this.selectedIndexItem].material = _data;
      this.onSelectedMaterialCode();
    }

  }

  onAutocompleteRemoveElement(evt: Autocomplete) {
    if (evt.field == 'materialCode') {
      this.materialDataset = this.materials.slice(0, 100);
      this.itemAttributesForMaterialCode = undefined;
      this.resetSqlOptionList();
      this.materialValue = undefined;
      this.materialIsValid = !this.materialIsRequired;

      if (this.selectedIndexItem != -1 && this.items[this.selectedIndexItem]) {
        this.items[this.selectedIndexItem].material = undefined;
      }

      if (this.normGradesDataset_Cache.length > 0)
        this.normGradesDataset = this.normGradesDataset_Cache;
      else
        this.getNormGrades('', false);

      return;
    }

    if (evt.field == 'normGrades') {
      // REMOVE VALUE
      let _values: any[] = this.normGradesCodes; //.toString().split(',');
      let _i: number = _values.findIndex(x => x == evt.object);
      this.normGradesCodes = _values.filter(x => x != evt.object); //.join(',');
      let _ids: number[] = new Array();
      _ids = this.normGradesIds!.filter(x => x < 100000);
      this.normGradesIds = new Array();
      for (var x = 0; x < _ids.length; x++) {
        if (x != _i) {
          this.normGradesIds.push(_ids[x]);
        }
      }


      if (this.normGradesIds.length > 0) {
        //this.getRawMaterialGrades('',this.normGradesIds);
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = false;
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = false;
        this.getLimitationsForNormGrades(this.normGradesIds, false);
      } else {
        this.rawMaterialGradeValue = '';
        this.rawMaterialGradeDataset = new Array();
        this.rawMaterialGradeAvailableDataset = [];
        this.rawMaterialGradeDisabled = true;
        this.rawMaterialGradeIsRequired = false;
        this.analysisLimitationValue = '';
        this.otherLimitationValue = '';
        this.analysisLimitationFreeInput = false;
        this.otherLimitationFreeInput = false;
        this.analysisLimitationOptionList = new Array();
        this.otherLimitationOptionList = new Array();
      }

      //this.items[this.selectedIndexItem].normGrades = JSON.parse(evt.object!);
      this.items[this.selectedIndexItem].normGrades = this.items[this.selectedIndexItem].normGrades!.filter(x => x.normGradeCode != evt.object!);
    }
    this.invalidateWeight();
  }

  // MATERIALS
  onSelectedMaterialCode() {
    const currentMaterialCode = this.materialValue;
    if (currentMaterialCode) {
      const hadMultipleLength = !!this.items[this.selectedIndexItem]?.multipleLength;
      this.subscriptions.add(this.backendService.getItemAttributesByMaterialCode(currentMaterialCode, this.enquiryToEdit.header!.unitSystem!).subscribe(res => {

        this.itemAttributesForMaterialCode = res;
        let so = new SelectOption();

        this.turnOffNps(); // clean nps

        // set value from api response
        // ubent is not compliant don't apply it, show error

        // set CTS to false before applying values from api response
        so.value = false;
        this.onSelectedCts(so);

        // res.marketingRoute
        so.value = res.marketingRoute;
        this.onSelectedMarketingRouteSms(so);

        this.applyMaterialDimensionsByType(res);
        this.applyDefaultSurfaceType();
        this.applyMaterialTypeOfTolerance(res);

        if (hadMultipleLength) {
          this.multipleLengthValue = false;
          this.items[this.selectedIndexItem].multipleLength = false;
        }

        so = new SelectOption();
        so.value = res.lengthType;
        this.onSelectedLengthType(so)

        if (res.lengthType == 'FL')
          this.onInputNominalLength(res.lengthMin);
        else if (hadMultipleLength) {
          this.lengthMinValue = null;
          this.lengthMaxValue = null;
          this.lengthMinIsValid = true;
          this.lengthMaxIsValid = true;
          this.items[this.selectedIndexItem].lengthMin = null;
          this.items[this.selectedIndexItem].lengthMax = null;
          this.invalidateWeight();
        } else {
          this.onInputLengthMin(res.lengthMin);
          this.onInputLengthMax(res.lengthMax);
        }

        so.value = res.uBent;
        this.onSelectedUBent(so);

        so.value = res.endsCondition;
        this.onSelectedEndsCondition(so);

        so.value = res.ht;
        this.onSelectedHt(so);

        so.value = res.ut;
        this.onSelectedUt(so);

        so.value = res.htAdditional;
        this.onSelectedHtAdditional(so);

        so.value = res.hydroTest;
        this.onSelectedHydroTest(so);

        so.value = res.testCondition;
        this.onSelectedTestCondition(so);

        const offerSchemeCode = (res as any).offerSchemeCode ?? (res as any).offerScheme?.offerSchemeCode;
        if (offerSchemeCode != null && offerSchemeCode !== '') {
          so.value = offerSchemeCode;
          this.onSelectedOfferScheme(so);
        }

        const selectedMill = this.resolveMillForMaterial(res);
        if (selectedMill) {
          let ac = new Autocomplete();
          ac.object = JSON.stringify(selectedMill);
          ac.field = 'mill';
          this.onAutocompleteSelect(ac);
        }

        const sqlFromMaterial = this.resolveSqlFromApiValue((res as any).sqlId ?? (res as any).sql?.sqlId);
        const hasSqlRestriction = this.applySqlRulesForCurrentMaterialAndMill(res);
        if (!hasSqlRestriction && sqlFromMaterial) {
          so.value = sqlFromMaterial.sqlId;
          this.onSelectedSql(so);
        }

        // set again the orginal code value 
        this.materialValue = currentMaterialCode;
        this.items[this.selectedIndexItem].material = this.materials.find(m => m.materialCode == currentMaterialCode);

        // update norms dataset
        this.normGradesCodes = new Array();
        this.normGradesIds = new Array();
        this.analysisLimitationValue = '';
        this.otherLimitationValue = '';
        this.rawMaterialGradeValue = res.rawMaterialGrade?.isDummy === true ? null : res.rawMaterialGrade?.rawMaterialGradeCode;
        this.items[this.selectedIndexItem].rawMaterialGrade = res.rawMaterialGrade?.isDummy === true ? undefined : res.rawMaterialGrade;
        this.rawMaterialGradeAvailableDataset = res.rawMaterialGrade ? [res.rawMaterialGrade] : [];
        this.rawMaterialGradeDataset = this.rawMaterialGradeAvailableDataset.slice(0, 100);
        this.items[this.selectedIndexItem].normGrades = [];
        this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
        this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
        this.normGradesMaterialDataset = res.normGrades;
        this.normGradesDataset = res.normGrades?.sort(this.sortNormGrades) || [];

      }));
    }
  }

  private applyMaterialDimensionsByType(attrs: ItemAttributesByMaterialCode): void {
    const dimType = this.resolveMaterialDimType(attrs);
    if (dimType == 'IdWt') {
      this.setMaterialDimensionValue('id', attrs.id, attrs.idUom);
      this.setMaterialDimensionValue('wt', attrs.wt, attrs.wtUom);
      this.clearMaterialDimensionValue('od');
      return;
    }

    if (dimType == 'OdId') {
      this.setMaterialDimensionValue('od', attrs.od, attrs.odUom);
      this.setMaterialDimensionValue('id', attrs.id, attrs.idUom);
      this.clearMaterialDimensionValue('wt');
      return;
    }

    // Default fallback (legacy payload compatibility)
    this.setMaterialDimensionValue('od', attrs.od, attrs.odUom);
    this.setMaterialDimensionValue('wt', attrs.wt, attrs.wtUom);
    this.clearMaterialDimensionValue('id');
  }

  private applyMaterialTypeOfTolerance(attrs: ItemAttributesByMaterialCode): void {
    if (!this.materialDimTypeHasWt(attrs) || !attrs.typeOfTolerance) {
      this.typeOfToleranceValue = null;
      this.typeOfToleranceIsValid = true;
      this.items[this.selectedIndexItem].typeOfTolerance = null;
      return;
    }

    const so = new SelectOption();
    so.value = attrs.typeOfTolerance;
    this.onSelectedTypeOfTolerance(so, true);
  }

  private resolveMaterialDimType(attrs: ItemAttributesByMaterialCode): DimType {
    if (attrs.dimType == 'IdWt' || attrs.dimType == 'OdId' || attrs.dimType == 'OdWt') {
      return attrs.dimType;
    }

    const hasOd = attrs.od != null;
    const hasId = attrs.id != null;
    const hasWt = attrs.wt != null;

    if (hasId && hasWt && !hasOd) return 'IdWt';
    if (hasOd && hasId && !hasWt) return 'OdId';
    return 'OdWt';
  }

  private setMaterialDimensionValue(dimension: 'od' | 'id' | 'wt', value?: number, uom?: string): void {
    if (dimension == 'od') {
      this.onInputOd(value ?? null);
      if (uom) {
        const so = new SelectOption();
        so.value = uom;
        this.onSelectedOdUom(so);
      }
      return;
    }

    if (dimension == 'id') {
      this.onInputId(value ?? null);
      if (uom) {
        const so = new SelectOption();
        so.value = uom;
        this.onSelectedId(so);
      }
      return;
    }

    this.onInputWt(value ?? null);
    if (uom) {
      const so = new SelectOption();
      so.value = uom;
      this.onSelectedWt(so);
    }
  }

  private clearMaterialDimensionValue(dimension: 'od' | 'id' | 'wt'): void {
    if (dimension == 'od') {
      this.onInputOd(null);
      this.cleanOdTolerances();
      return;
    }

    if (dimension == 'id') {
      this.onInputId(null);
      this.cleanIdTolerances();
      return;
    }

    this.onInputWt(null);
    this.cleanWtTolerances();
  }

  private materialDimTypeHasWt(attrs?: ItemAttributesByMaterialCode): boolean {
    const dimType = (attrs?.dimType || '').toString().toLowerCase();
    return dimType.includes('wt');
  }

  private resolveMillForMaterial(attrs: ItemAttributesByMaterialCode): Mill | undefined {
    const materialMills = (attrs?.millsId || [])
      .map(millId => this.itemParameterValues.mills?.find(m => m.millId == millId))
      .filter((mill): mill is Mill => !!mill);

    if (materialMills.length == 0) {
      this.millValue = null;
      this.items[this.selectedIndexItem].mill = undefined;
      return undefined;
    }

    if (materialMills.length == 1) {
      return materialMills[0];
    }

    this.calculateDefaultMill();
    const defaultMillId = this.items[this.selectedIndexItem].mill?.millId;
    return materialMills.find(m => m.millId == defaultMillId) || materialMills[0];
  }

  private resolveSqlFromApiValue(value: unknown): Sql | undefined {
    if (value == null) {
      return undefined;
    }

    const normalizedValue = value.toString().trim().toLowerCase();
    if (!normalizedValue) {
      return undefined;
    }

    const byId = this.itemParameterValues.sqls?.find(sql => sql.sqlId != null && sql.sqlId.toString() == normalizedValue);
    if (byId) {
      return byId;
    }

    return this.itemParameterValues.sqls?.find(sql => (sql.name || '').toLowerCase() == normalizedValue);
  }

  private getSqlsForMaterialAndMill(attrs: ItemAttributesByMaterialCode, millId: number): Sql[] {
    const sqlValues = attrs.sqlsPerMill?.[millId.toString()] || attrs.sqlsPerMill?.[millId as any];
    if (!Array.isArray(sqlValues) || sqlValues.length == 0) {
      return [];
    }

    const uniqueSqls = new Map<number, Sql>();
    for (const value of sqlValues) {
      const sql = this.resolveSqlFromApiValue(value);
      if (sql?.sqlId == null) {
        continue;
      }
      uniqueSqls.set(sql.sqlId, sql);
    }

    return Array.from(uniqueSqls.values());
  }

  private setSqlSelection(sql: Sql | null): void {
    if (!sql) {
      this.sqlValue = null;
      this.sqlIsValid = false;
      this.items[this.selectedIndexItem].sql = undefined;
      return;
    }

    this.sqlValue = sql.sqlId;
    this.sqlIsValid = true;
    this.items[this.selectedIndexItem].sql = sql;
  }

  private resetSqlOptionList(): void {
    this.sqlOptionList = this.defaultSqlOptionList.map(opt => ({ ...opt } as SelectOption));
  }

  private applySqlRulesForCurrentMaterialAndMill(attrs?: ItemAttributesByMaterialCode): boolean {
    const millId = this.items[this.selectedIndexItem]?.mill?.millId;
    if (!attrs?.sqlsPerMill || !millId || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, millId.toString())) {
      this.resetSqlOptionList();
      return false;
    }

    const sqlsForMill = this.getSqlsForMaterialAndMill(attrs, millId);
    this.sqlOptionList = sqlsForMill.map(sql => {
      const option = new SelectOption();
      option.text = sql.name;
      option.value = sql.sqlId;
      return option;
    });

    if (sqlsForMill.length == 1) {
      this.setSqlSelection(sqlsForMill[0]);
    } else {
      this.setSqlSelection(null);
    }

    return true;
  }

  private isSelectedSqlCompatible(attrs?: ItemAttributesByMaterialCode, sqlId?: number, millId?: number): boolean | null {
    if (!attrs?.sqlsPerMill || !sqlId || !millId || !Object.prototype.hasOwnProperty.call(attrs.sqlsPerMill, millId.toString())) {
      return null;
    }

    const compatibleSqlIds = new Set(this.getSqlsForMaterialAndMill(attrs, millId).map(sql => sql.sqlId));
    return compatibleSqlIds.has(sqlId);
  }

  private validateSelectedSqlCompatibility(): void {
    const materialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
    const selectedSqlId = this.items[this.selectedIndexItem]?.sql?.sqlId;
    const millId = this.items[this.selectedIndexItem]?.mill?.millId;
    if (!materialCode || !selectedSqlId || !millId) {
      return;
    }

    const checkCompatibility = (attrs?: ItemAttributesByMaterialCode) => {
      const isCompatible = this.isSelectedSqlCompatible(attrs, selectedSqlId, millId);
      if (isCompatible === false) {
        this.invalidateMaterialCode();
      }
    };

    if (this.itemAttributesForMaterialCode) {
      checkCompatibility(this.itemAttributesForMaterialCode);
      return;
    }

    const requestedMaterialCode = materialCode;
    this.subscriptions.add(
      this.backendService.getItemAttributesByMaterialCode(requestedMaterialCode, this.enquiryToEdit.header!.unitSystem!).subscribe({
        next: res => {
          const currentMaterialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
          if (currentMaterialCode != requestedMaterialCode) {
            return;
          }
          this.itemAttributesForMaterialCode = res;
          checkCompatibility(res);
        },
        error: () => { }
      })
    );
  }

  private invalidateMaterialCodeOnTypeOfToleranceMismatch(): void {
    const materialCodeToValidate = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
    if (!materialCodeToValidate) {
      return;
    }

    const validateMismatch = (attrs?: ItemAttributesByMaterialCode) => {
      if (!attrs || !this.materialDimTypeHasWt(attrs) || !attrs.typeOfTolerance) {
        return;
      }

      const currentType = this.typeOfToleranceValue != null ? this.typeOfToleranceValue.toString() : '';
      if (currentType !== attrs.typeOfTolerance) {
        const currentMaterialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
        if (currentMaterialCode === materialCodeToValidate) {
          this.invalidateMaterialCode();
        }
      }
    };

    if (this.itemAttributesForMaterialCode) {
      validateMismatch(this.itemAttributesForMaterialCode);
      return;
    }

    this.subscriptions.add(this.backendService.getItemAttributesByMaterialCode(materialCodeToValidate, this.enquiryToEdit.header!.unitSystem!).subscribe({
      next: res => {
        const currentMaterialCode = this.materialValue || this.items[this.selectedIndexItem]?.material?.materialCode;
        if (currentMaterialCode !== materialCodeToValidate) {
          return;
        }

        this.itemAttributesForMaterialCode = res;
        validateMismatch(res);
      },
      error: () => { }
    }));
  }

  invalidateMaterialCode() {
    // on first load, never invalidate previous values
    if (!this.isInitialLoad) {
      this.itemAttributesForMaterialCode = undefined;
      this.resetSqlOptionList();
      this.materialValue = undefined;
      this.items[this.selectedIndexItem].material = undefined;

      // recover normList 
      if (this.normGradesDataset_Cache.length > 0)
        this.normGradesDataset = this.normGradesDataset_Cache;
      else
        this.getNormGrades('', false);
    }
  }

  // // deprecated
  // checkMaterialCodeAttributes() {
  //   if (!this.itemAttributesForMaterialCode) return;

  //   const item = this.items[this.selectedIndexItem];
  //   const attrs = this.itemAttributesForMaterialCode;

  //   const anyMismatch =
  //     attrs.od !== item.od ||
  //     attrs.odUom !== item.odUom ||
  //     attrs.wt !== item.wt ||
  //     attrs.wtUom !== item.wtUom ||
  //     attrs.marketingRoute !== item.marketingRoute ||
  //     attrs.ut !== item.ut ||
  //     attrs.hydroTest !== item.hydroTest ||
  //     attrs.ht !== item.ht ||
  //     attrs.htAdditional !== item.htAdditional ||
  //     attrs.millId !== item.mill?.millId ||
  //     attrs.rawMaterialGradeId !== item.rawMaterialGrade?.rawMaterialGradeId ||
  //     attrs.lengthType !== item.lengthType ||
  //     attrs.lengthMin !== item.lengthMin ||
  //     attrs.lengthMax !== item.lengthMax ||
  //     attrs.lengthUom !== item.lengthUom ||
  //     attrs.endsCondition !== this.endsConditionValue ||
  //     attrs.uBent !== item.uBent;

  //   if (anyMismatch) {
  //     this.materialCodeValue = null;
  //     item.materialCode = undefined;
  //   }

  // }

  /** LIMITATIONS */
  onSelectedAnalysisLimitation(evt: SelectOption) {
    this.analysisLimitationValue = evt.value;
    this.analysisLimitationIsValid = true;
    this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
    this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = false;
    this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = evt.value;
    this.reloadRawMaterialGradesOnLimitationChange();
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onSelectedOtherLimitation(evt: SelectOption) {
    this.otherLimitationValue = evt.value;
    this.otherLimitationIsValid = true;
    this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
    this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = false;
    this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = evt.value;
    this.reloadRawMaterialGradesOnLimitationChange();
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onInputAnalysisLimitation(evt: string) {
    this.analysisLimitationValue = evt;
    if (this.analysisLimitationValue == '') {
      this.analysisLimitationIsValid = false;
    } else {
      this.analysisLimitationIsValid = true;
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = true;
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = this.analysisLimitationValue;
      this.reloadRawMaterialGradesOnLimitationChange();
      this.rawMaterialGradeIsValid = true;
    }
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onInputOtherLimitation(evt: string) {
    this.otherLimitationValue = evt;
    if (this.otherLimitationValue == '') {
      this.otherLimitationIsValid = false;
    } else {
      this.otherLimitationIsValid = true;
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = true;
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = this.otherLimitationValue;
      this.reloadRawMaterialGradesOnLimitationChange();
      this.rawMaterialGradeIsValid = true;
    }
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onCheckMultipleLength() {
    this.multipleLengthValue = !this.multipleLengthValue;
    this.items[this.selectedIndexItem].multipleLength = this.multipleLengthValue;

    if (!this.multipleLengthValue) {
      // if fixed length, reset min = max
      if (this.lengthTypeValue == 'FL')
        this.lengthMinValue = this.lengthMaxValue = null;
    }
  }

  private isHollowBarsSms(sms?: { description?: string | null; name?: string | null } | null): boolean {
    const normalizedDescription = (sms?.description ?? '').toString().trim().toLowerCase();
    const normalizedName = (sms?.name ?? '').toString().trim().toLowerCase();
    return normalizedDescription === 'hollow bars' || normalizedName === 'hollow bars';
  }

  private isHexuSms(sms?: { name?: string | null } | null): boolean {
    return (sms?.name ?? '').toString().trim().toUpperCase() === 'HEXU';
  }

  private shouldSetUbentFromHeaderForFirstItem(): boolean {
    return this.action == 'create'
      && this.selectedIndexItem == 0
      && this.items.length == 1
      && this.isHexuSms(this.enquiryToEdit.header?.sms);
  }

  private isHydroEditableMillCode(millShortName?: string | null): boolean {
    const normalizedMillCode = (millShortName ?? '').toString().trim().toUpperCase();
    return normalizedMillCode === 'MB' || normalizedMillCode === 'RS';
  }

  private getCurrentMillShortName(): string {
    return (this.items[this.selectedIndexItem]?.mill?.shortName || this.millValue || '').toString().trim().toUpperCase();
  }

  private isHydroTestDisabledForCurrentItem(): boolean {
    if (!this.ctsValue) {
      return false;
    }

    return !this.isHydroEditableMillCode(this.getCurrentMillShortName());
  }

  private resolveHydroTestDefaultValue(): boolean {
    const currentItem = this.items[this.selectedIndexItem];
    const isHollowBars = this.isHollowBarsSms(currentItem?.sms);
    const odMm = this.getOdInMm();
    return isHollowBars || (odMm !== null && odMm > 168.3);
  }

  private findQuantityUomCode(list: Uom[] | undefined, ...codes: string[]): string | undefined {
    if (!list || list.length == 0) {
      return undefined;
    }

    const normalizedCodes = codes.map(code => code.toString().trim().toLowerCase());
    return list.find(qu => qu.uomCode && normalizedCodes.includes(qu.uomCode.toString().trim().toLowerCase()))?.uomCode;
  }

  onCheckAnalysisLimitation() {
    this.analysisLimitationFreeInput = !this.analysisLimitationFreeInput;
    if (this.analysisLimitationFreeInput) {
      this.analysisLimitationValue = "";
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = true;
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = '';
      this.rawMaterialGradeIsRequired = false;
      this.rawMaterialGradeValue = this.items[this.selectedIndexItem].rawMaterialGrade?.rawMaterialGradeCode || null;
    } else {
      this.analysisLimitationValue = this.limitationForNormGrade.gradeCustomerAnalysisLimitations!.length > 0 ? this.limitationForNormGrade.gradeCustomerAnalysisLimitations!.filter(x => x.isDefault == true)[0].limitation! : '';
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.isCustom = false;
      this.items[this.selectedIndexItem].gradeCustomerAnalysisLimitation!.limitation = this.analysisLimitationValue;
      // if both Limitation are on Select Mode enable RawMaterial Grade
      this.rawMaterialGradeIsValid = true; // MQF-367
      this.rawMaterialGradeValue = this.items[this.selectedIndexItem].rawMaterialGrade ? this.items[this.selectedIndexItem].rawMaterialGrade!.rawMaterialGradeCode : null;
    }
    this.rawMaterialGradeDisabled = false;
    this.reloadRawMaterialGradesOnLimitationChange();
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  onCheckOtherLimitation() {
    this.otherLimitationFreeInput = !this.otherLimitationFreeInput;
    if (this.otherLimitationFreeInput) {
      this.otherLimitationValue = "";
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = true;
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = '';
      this.rawMaterialGradeIsRequired = false;
      this.rawMaterialGradeValue = this.items[this.selectedIndexItem].rawMaterialGrade?.rawMaterialGradeCode || null;
    } else {
      this.otherLimitationValue = this.limitationForNormGrade.gradeCustomerOtherLimitations!.length > 0 ? this.limitationForNormGrade.gradeCustomerOtherLimitations!.filter(x => x.isDefault == true)[0].limitation! : '';
      // if both Limitation are on Select Mode enable RawMaterial Grade
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation = new ItemLimitation();
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.isCustom = false;
      this.items[this.selectedIndexItem].gradeCustomerOtherLimitation!.limitation = this.otherLimitationValue;
      this.rawMaterialGradeIsValid = true; // MQF-367
      this.rawMaterialGradeValue = this.items[this.selectedIndexItem].rawMaterialGrade ? this.items[this.selectedIndexItem].rawMaterialGrade!.rawMaterialGradeCode : null;
    }
    this.rawMaterialGradeDisabled = false;
    this.reloadRawMaterialGradesOnLimitationChange();
    this.invalidateWeight();
    this.invalidateMaterialCode();
  }

  /* NPS MODAL */
  onConfirmModalNps(evt: any) {
    // Check which unit system is selected
    let _uomSystem: string = this.unitSystemValue;
    if (_uomSystem == '' || _uomSystem == undefined) {
      this.teiasoftModalService.show('info', this.translate.instant('enquiryBook.add'), this.translate.instant('enquiryBook.selectUomSystem'), '', '');
      return;
    }

    // NPS DESCRIPTION
    this.npsValue = evt["npsDescription"];
    this.npsId = parseInt(evt["npsScheduleId"]);
    this.npsIsValid = true;

    evt["odMetric"] = parseFloat(evt["odMetric"]).toFixed(this.getRoundDigits('od'));
    evt["wtMetric"] = parseFloat(evt["wtMetric"]).toFixed(this.getRoundDigits('wt'));
    evt["odImperial"] = parseFloat(evt["odImperial"]).toFixed(this.getRoundDigits('od'));
    evt["wtImperial"] = parseFloat(evt["wtImperial"]).toFixed(this.getRoundDigits('wt'));

    // OD/WT/ID VALUES
    if (_uomSystem.toLowerCase() == 'metric') {
      this.odValue = evt["odMetric"];
      this.wtValue = evt["wtMetric"];
    } else {
      this.odValue = evt["odImperial"];
      this.wtValue = evt["wtImperial"];
    }

    // OD/WT/ID UOM
    this.odUomOptionList = new Array();
    this.odUomOptionList = this.getUoms('odUoms');
    this.idUomOptionList = new Array();
    this.idUomOptionList = this.getUoms('idUoms');
    this.wtUomOptionList = new Array();
    this.wtUomOptionList = this.getUoms('wtUoms');

    this.odUomValue = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"];
    this.wtUomValue = _uomSystem.toLowerCase() == 'metric' ? evt["metricUom"] : evt["imperialUom"];
    this.items[this.selectedIndexItem].odUom = this.odUomValue;
    this.items[this.selectedIndexItem].wtUom = this.wtUomValue;

    //this.setUomDefault('all');
    this.showSelectNps = false;
    this.selectedNpsRow = new NpsAndSchedule();
    this.selectedNpsRow = evt;
    this.selectedNpsRow.npsScheduleId = this.npsId;

    this.items[this.selectedIndexItem].od = this.odValue;
    this.items[this.selectedIndexItem].wt = this.wtValue;
    this.items[this.selectedIndexItem].npsSchedule = new EnquiryNpsSchedule();
    this.items[this.selectedIndexItem].npsSchedule = this.selectedNpsRow;

    this.setWtOdIdNps('nps', true);

    this.invalidateWeight();
    this.invalidateMaterialCode();
    //this.items[this.selectedIndexItem].npsSchedule = this.optionDateValue;
  }

  onCloseModalNps(evt: any) {
    // If the pre-value is Nps I don't do nothing - GBR 25/01/2024
    if (this.npsValue == '' || this.npsValue == null) {
      // this.setWtOdIdNps('wtOdId', false); MQF-743
      this.toolbarButtonsList![0].state = 'pressed';
      this.toolbarButtonsList![1].state = '';
      // Metto a valida la descrizione NPS
      this.npsIsValid = true;
    }
    this.showSelectNps = false;
  }

  /* BREADCRUMB EVENTS */
  tbcClick(evt: TeiasoftBreadCrumb) {
    /*     this.selectedIndexItem = evt.newIndex!;
        this.fillForm(); */
  }
}
